/* global BASE_URL, DOKUMENT_ID, WF_ID, typ_dokumentu_id, smer_typu_dokumentu, Nette, subjectAutocompleteMinLength */

var stop_timer = 0;
var url;
var cache = Array();
var xhr;
var xhrTimer;
var xhrTimeout = 1000;


$(window).bind("beforeunload", function () {
  $(".ui-autocomplete-input").attr("autocomplete", "off");
});

isJsonString = function (str) {
  try {
	JSON.parse(str);
  } catch (e) {
	return false;
  }
  return true;
};

loadToasts = function() {
	// Defer so Nette snippet DOM replace finishes before Bootstrap toast init
	setTimeout(function() {
		$('.toast').each(function() {
			$(this).toast('show');
		});
	}, 0);
};

$(document).ready(function() {
  loadToasts();

  $.nette.ext('snippetHandler', {
	success: function(payload) {
	  if (payload.snippets && Object.keys(payload.snippets).some(function(id) {
		return id.indexOf('flashes') !== -1;
	  })) {
		loadToasts();
	  }
	}
  });

  $(document).ajaxComplete(function(event, xhr, settings) {
	if (settings.url.includes('changeStatus')) {
	  loadToasts();
	}
  });

});

// Strom spisů (strom2) - průběžné načítání dalších kořenových řádků (tlačítko "Načíst další" a posun na konec seznamu)
$(document).ready(function() {
  var stromObserver = null;

  var stromRadky = function () {
	return $('[data-datagrid-name="spisyTreeGrid"] .datagrid-tree').first();
  };

  // poChybe - po neúspěšném načtení se čeká, až patička opustí viditelnou oblast, aby se požadavek neopakoval ve smyčce
  var stromSledovat = function (poChybe) {
	if (stromObserver) {
	  stromObserver.disconnect();
	  stromObserver = null;
	}
	var odkaz = document.querySelector('[data-strom-dalsi]');
	if (!odkaz || !('IntersectionObserver' in window)) {
	  return;
	}
	var cekatNaOpusteni = !!poChybe;
	stromObserver = new IntersectionObserver(function (entries) {
	  entries.forEach(function (entry) {
		if (!entry.isIntersecting) {
		  cekatNaOpusteni = false;
		  return;
		}
		if (!cekatNaOpusteni && stromObserver) {
		  stromObserver.disconnect();
		  stromObserver = null;
		  stromNactiDalsi(entry.target);
		}
	  });
	}, {threshold: 0});
	stromObserver.observe(odkaz);
  };

  var stromNactiDalsi = function (odkaz) {
	var $odkaz = $(odkaz);
	if ($odkaz.attr('data-nacitam')) {
	  return;
	}
	$odkaz.attr('data-nacitam', '1').addClass('disabled');

	var xhr = $.nette.ajax({
	  url: odkaz.href,
	  off: ['history'],
	  // radky stromu vyjmeme ze snippetu, aby je vychozi obsluha snippetu neprepsala; pripoji je rozsireni nize
	  dataFilter: function (data) {
		var payload;
		try {
		  payload = JSON.parse(data);
		} catch (e) {
		  return data;
		}
		if (!payload || !payload._spisyStromDalsi || !payload.snippets) {
		  return data;
		}
		payload._spisyStromRadky = {};
		Object.keys(payload.snippets).forEach(function (name) {
		  if (name.indexOf('snippet-spisyTreeGrid-item-') === 0) {
			if (/-item-\d+$/.test(name)) {
			  payload._spisyStromRadky[name] = payload.snippets[name];
			}
			delete payload.snippets[name];
		  }
		});
		return JSON.stringify(payload);
	  }
	});

	var obnovitOdkaz = function () {
	  $odkaz.removeAttr('data-nacitam').removeClass('disabled');
	  stromSledovat(true);
	};

	if (xhr && typeof xhr.fail === 'function') {
	  xhr.fail(obnovitOdkaz);
	  xhr.done(function (payload) {
		if (!payload || !payload._spisyStromDalsi) {
		  obnovitOdkaz();
		}
	  });
	} else {
	  obnovitOdkaz();
	}
  };

  $.nette.ext('spisyStromDalsi', {
	success: function (payload) {
	  if (!payload._spisyStromDalsi) {
		return;
	  }
	  var $strom = stromRadky();
	  $.each(payload._spisyStromRadky || {}, function (name, html) {
		var $obsah = $(html);
		var $radekObsah = $obsah.filter('.datagrid-tree-item-content');
		var id = $radekObsah.attr('data-id');
		if (!id || $strom.children('.datagrid-tree-item[data-id="' + id + '"]').length) {
		  return;
		}
		var $radek = $('<div class="datagrid-tree-item">').attr('id', name).attr('data-id', id).append($obsah);
		if ($radekObsah.data('has-children')) {
		  $radek.addClass('has-children');
		}
		$strom.append($radek);
	  });
	  if (typeof dataGridLoad === 'function') {
		dataGridLoad();
	  }
	  stromSledovat();
	}
  });

  $(document).on('click', '[data-strom-dalsi]', function (e) {
	e.preventDefault();
	stromNactiDalsi(this);
  });

  stromSledovat();
});

$(function () {
  $.nette.init();
  if (!$.nette.ext('krizoveOdkazy')) {
  $.nette.ext('krizoveOdkazy', {
	success: function (payload) {
	  if (payload && payload.closeOdkazyForm && typeof closeLinkBox === 'function') {
		closeLinkBox();
	  }
	  if (!payload || !payload.reloadKrizoveOdkazy) {
		return;
	  }
	  var tabLink = $('#odkazy-tab');
	  var url = tabLink.data('url');
	  if (!url || typeof loadTabContent !== 'function') {
		return;
	  }
	  tabLink.removeClass('content-loaded');
	  loadTabContent(url, tabLink);
	}
  });
  }
  var snippetsExt = $.nette.ext('snippets');
  if (snippetsExt && typeof snippetsExt.after === 'function') {
	snippetsExt.after(function($el) {
	  var id = $el.attr('id') || '';
	  if (id.indexOf('flashes') !== -1 || $el.find('.toast').length) {
		loadToasts();
	  }
	});
  }
  bsCustomFileInput.init();
  const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
  const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl, {trigger: 'hover'}))

  // @param callback a handler to be called when Ajax requests complete
  $("[data-dependentselectbox]").dependentSelectBox(function () {});

  installDatePicker();
  initSelect2();

  document.querySelectorAll('select[multiple]').forEach(select => {

	select.querySelectorAll('option').forEach(option => {
	  option.addEventListener('mouseover', () => option.classList.add('selected-option'));
	  option.addEventListener('mouseout', () => {
		if (!option.selected) option.classList.remove('selected-option');
	  });

	  option.addEventListener('focus', () => option.classList.add('selected-option'));
	  option.addEventListener('blur', () => {
		if (!option.selected) option.classList.remove('selected-option');
	  });
	});


	select.addEventListener('change', () => {
	  select.querySelectorAll('option').forEach(option => {
		if (option.selected) {
		  option.classList.add('selected-option');
		} else {
		  option.classList.remove('selected-option');
		}
	  });
	});

  });

  $.nette.ext('downloadManager', {
	success: function(payload) {
	  if (payload.action === 'downloadFile' && payload.fileUrl) {
		window.location.href = payload.fileUrl;
		return;
	  }

	  if (payload.action === 'showModal' && payload.modalBodyContent) {
		var $modal = $('#theModal');
		$modal.find(".modal-title").text(payload.modalTitle || "");
		$modal.find('.modal-body').html(payload.modalBodyContent);
		$modal.modal('show');
	  }
	},
	error: function(jqXHR, textStatus, errorThrown) {
		// chybu nevypisujeme, objevuje se totiz i pri beznem volani v datagridech, kdy se vola vice dotazu najednou
		// pro potrebu generovani TP logu je nutne rozlisovat a vypisovat
		// alert('Nastala chyba při komunikaci se serverem.');
	}
  });

  $("#theModal").on("show.bs.modal", function (e) {
	// fix pro datepicker v modalu, odpaluje stejny event
	if(e.target.classList.contains('datepicker')) return;

	var button = $(e.relatedTarget);
	var remote = button ? button.data("remote") : null;

	if (!remote) {
		return;
	}

	var title = button.data("title");
	var size = button.data("size");
	var modal = $(this);

	modal.find(".modal-title").html('');
	modal.find(".modal-body").html('');
	if (button.data("global-loader")) {
		$("#ajax-spinner").addClass("above-modal").show();
	}

	if(size !== undefined){
		modal.find(".modal-dialog").removeClass("modal-xl");
		modal.find(".modal-dialog").addClass(size);
	}

	modal.find(".modal-title").text(title);
	modal.find(".modal-dialog").addClass(size);
	modal.find(".modal-body").load(remote, function (response, status, xhr) {
	  $("#ajax-spinner").removeClass("above-modal");
	  $("#ajax-spinner").hide();

	  if (isJsonString(response)) {
		let redirect = JSON.parse(response).redirect ?? null;

		if (redirect) {
		  console.log("Přesměrování na: " + redirect);
		  modal
			.find(".modal-body")
			.text("Omlouváme se, aplikace si vyžádala přesměrování...");
		  window.location.href = redirect;
		}
	  }
	});
  });

  // Bootstrap 5 při kliku na data-bs-toggle zavře už otevřený modal.
  // Druhý dialog (vyhledání DS) se má otevřít nad formulářem subjektu a po zavření se na něj vrátit.
  document.addEventListener("click", function (event) {
	var target = event.target;
	if (!target || !target.closest) {
	  return;
	}
	var link = target.closest("a[data-bs-toggle='modal'][data-bs-target='#theModal2'], a[data-bs-toggle='modal'][href='#theModal2']");
	if (!link) {
	  return;
	}
	var parentModal = document.getElementById("theModal");
	if (!parentModal || !parentModal.classList.contains("show")) {
	  return;
	}
	event.preventDefault();
	event.stopPropagation();
	$("#theModal2").modal("show", link);
  }, true);

  $("#theModal2").on("show.bs.modal", function (e) {

	// fix pro datepicker v modalu, odpaluje stejny event
	if(e.target.classList.contains('datepicker')) return;

	// Označit rodičovský dialog hned. Po animaci Bootstrapu už není :visible a přišlo by se na něj zapomenout.
	if ($("#theModal").hasClass("show") || $("#theModal").is(":visible")) {
	  $("#theModal").addClass("modalhidden");
	}

	var button = $(e.relatedTarget);
	var remote = button.data("remote");
	var title = button.data("title");
	var size = button.data("size");
	var modal = $(this);

	modal.find(".modal-title").html('');
	modal.find(".modal-body").html('');

	if(size !== undefined){
		modal.find(".modal-dialog").removeClass("modal-xl");
		modal.find(".modal-dialog").addClass(size);
	}

	modal.find(".modal-title").text(title);
	modal.find(".modal-body").load(remote, function (response, status, xhr) {
	  $("#ajax-spinner").hide();
	  if($('#theModal:visible').length){
		$("#theModal").hide().addClass("modalhidden");
	  }


	  if (isJsonString(response)) {
		let redirect = JSON.parse(response).redirect ?? null;

		if (redirect) {
		  console.log("Přesměrování na: " + redirect);
		  modal
			.find(".modal-body")
			.text("Omlouváme se, aplikace si vyžádala přesměrování...");
		  window.location.href = redirect;
		}
	  }
	});
  });

  $("#theModal").on("hidden.bs.modal", function () {
	$("#ajax-spinner").removeClass("above-modal").hide();
  });
  $("#theModal2").on("hidden.bs.modal", function () {
	  $("#ajax-spinner").hide();
  });

  $("#changeUserModal").on("show.bs.modal", function (e) {
	var button = $(e.relatedTarget);
	var modal = $(this);

	modal.find(".modal-body").load(button.data("remote"));
  });

  if (window.location.hash === "#send_to_erp_box") {
	$("#send_to_erp_box").toggle();
  }

  $("#frmerpForm-evidencni_cislo").on("keyup", function () {
	$("#frmerpForm-variabilni_symbol").val($(this).val());
  });

  // naseptavac spisu ve formulari pro odeslani do ERP
  $("#frmerpForm-assignSpis").autocomplete({
	minLength: 3,
	source: BASE_URL + "spisy/seznam-erp-ajax",
	focus: function (event, ui) {
	  return false;
	},
	select: function (event, ui) {
	  $("input[name=spis_id]").val(ui.item.id);
	},
  });

  $("#frmerpForm-assignSpis").keypress(function (event) {
	if (event.which == 13) {
	  event.preventDefault();
	}
  });

  $("#frmspisHeliosForm-assignSpis").autocomplete({
	minLength: 3,
	source: BASE_URL + "spisy/seznam-erp-ajax",
	focus: function (event, ui) {
	  return false;
	},
	select: function (event, ui) {
	  $("input[name=spis_id]").val(ui.item.id);
	},
  });

  $("#frmspisHeliosForm-assignSpis").keypress(function (event) {
	if (event.which == 13) {
	  event.preventDefault();
	}
  });

  $(".select2-multiple").select2({
	width: "100%",
	placeholder: {
	  id: '-1', // the value of the option
	  text: 'Vyberte z možnosti kliknutím na pole',
	},
	allowClear: false
  });
  refreshSelect2Multiple();
});

/**
 * Select2 u prázdného vícenásobného výběru dopočítá šířku z obsahu.
 * Po doplnění položek nebo zobrazení skryté části formuláře ji srovná na rodiče.
 */
function refreshSelect2Multiple(context) {
  var $root = context ? $(context) : $(document);
  $root.find("select.select2-multiple").each(function () {
	var $el = $(this);
	if (!$el.hasClass("select2-hidden-accessible")) {
	  return;
	}
	var instance = $el.data("select2");
	if (!instance || !instance.$container || !instance.$container.is(":visible")) {
	  return;
	}
	instance.$container.css("width", "100%");
	if (instance.selection && typeof instance.selection.resizeSearch === "function") {
	  instance.selection.resizeSearch();
	}
  });
}

$(document).on("change", "form", function () {
  var form = this;
  setTimeout(function () {
	refreshSelect2Multiple(form);
  }, 0);
});

$(window).bind("beforeunload", function () {
  $(".ui-autocomplete-input").attr("autocomplete", "off");
});

$(function () {
  $("#frmlogin-loginForm-password").focus(function () {
	var hodnota = $("#frmlogin-loginForm-username").val();

	if (hodnota.length >= 2) {
	  $.ajax({
		url: BASE_URL + "check/default/users/",
		type: "POST",
		data: { name: hodnota },
		success: function (data, textStatus, jqXHR) {
		  if (data.indexOf("###UNLOCK###") !== -1) {
			$("#login_button").show();
			$("#wrong_login").hide();
			$("#code_box").hide();
		  } else if (data.indexOf("###TRUE###") !== -1) {
			$("#code_box").toggle();
		  } else if (data.indexOf("###BADLOGIN###") !== -1) {
			$("#login_button").toggle();
			$("#wrong_login").toggle();
		  } else if (data.indexOf("###DEACTIVE###") !== -1) {
			$("#login_button").toggle();
			$("#deactive_login").toggle();
		  } else {
			$("#login_button").show();
			$("#wrong_login").hide();
			$("#code_box").hide();
		  }
		},
	  });
	}
  });

  $("#sortable").sortable({
	axis: "y",
	update: function (event, ui) {
	  var data = $(this).sortable("serialize");

	  $.ajax({
		data: data,
		type: "POST",
		url: BASE_URL + "admin/schvalovani/sort",
	  });
	},
  });

  $("#copy-document, #copy-document-form").click(function (e) {
	$("#fade").css("display", "block");
	$("#ajax-spinner").show();
  });

  $("#admin-card .card").hover(
	function () {
	  $(this).addClass("shadow-lg");
	},
	function () {
	  $(this).removeClass("shadow-lg");
	}
  );

  /**
   * AJAX
   */
  // Nastaveni spinneru. Je vzdy pritomen, standardne ale je schovan.
  $('<div id="ajax-spinner"></div>').appendTo("body").hide();

  // $(document).on('click', 'a.ajax', ajaxAnchor);
  $(document).on("click", "a.ajax-dialog", ajaxDialog);

  $(document).ajaxStart(function () {
	if ($(document.activeElement).closest(".datagrid").length) return;
	$("#ajax-spinner").show();
  });
  $(document).ajaxStop(function () {
	// při události ajaxStop spinner schovám
	$("#ajax-spinner").hide();
  });

  $(document).ready(function () {
	const $dataTable = $("#table");
	$dataTable.on("sort.bs.table", function () {
	  $dataTable.find(".th-inner.sortable").css("pointer-events", "none");
	});
	$dataTable.on("post-body.bs.table", function () {
	  $dataTable.find(".th-inner.sortable").css("pointer-events", "auto");
	});
  });

  $(document).ajaxError(function (event, jqXHR, ajaxSettings, thrownError) {
	// Při spouštění plánovače nečekáme na odpověď
	if (ajaxSettings.url.indexOf("/cron/") != -1) return;

	// při chybě též spinner schovám, protože jQuery zdá se nevyvolá událost stop
	$("#ajax-spinner").hide();

	//odblokuji tlačítko s ochranou proti vícenásobnému kliknutí
	$(".preventedClick").removeProp("disabled").removeClass("preventedClick");
	$(".buttonLoading").remove();

	// Pozadavek muze byt zrusen bud skriptem nette.ajax.js nebo kdyz uzivatel
	// naviguje na jinou stranku, nez dele bezici pozadavek dokonci
	if (thrownError == "canceled" || thrownError == "abort") return;

	var msg =
	  "Je nám líto, asynchronní požadavek skončil s chybou:\n" + thrownError;
	if (jqXHR.responseText && $("#dialog").dialog("isOpen") === false)
	  msg = msg + "\n\n" + jqXHR.responseText;

	alert(msg);

	if (jqXHR.responseText && $("#dialog").dialog("isOpen") === true) {
	  $("#dialog").html("<pre>" + jqXHR.responseText + "</pre>");
	  dialogScrollUp();
	}
  });

  // Dialog
  $("#dialog").dialog({
	autoOpen: false,
	width: 800,
	height: 500,
	modal: true,
  });

  $("#napoveda").dialog({
	autoOpen: false,
	width: 900,
	height: 700,
	modal: true,
  });

  $("#dialog-uzivatel").click(function (event) {
	const type = $(this).data("type");
	let title = "Předat organizační jednotce";

	if (type !== "spis") {
	  title += " nebo zaměstnanci";
	}

	return dialog(this, title);
  });

  $("#dialog-uzivatel-notifikace").click(function (event) {
	return dialog(this, "Přidat zaměstnance pro notifikaci");
  });

  $("#dialog-workflow").click(function (event) {
	return dialog(this, "Přidat workflow");
  });

  $(".dialog-version").click(function (event) {
	return dialog(this, "Verze dokumentu");
  });

  $("#subjekt_pripojit_click").click(function (event) {
	$("#subjekt_pripojit").toggle();
	$("#subjekt_autocomplete").focus();
	return false;
  });

  $("#send_to_erp").click(function (event) {
	$("#send_to_erp_box").toggle();
	return false;
  });

  $("#spis_helios").click(function (event) {
	$("#spis_helios_box").toggle();
	return false;
  });

  $("#hide_box_link, #hide_box_icon").click(function (event) {
	$("#hide_box").toggle();
	return false;
  });

  if (
	document.getElementById("frmsettingsPrintersForm-show_zpl_form") !== null &&
	document.getElementById("frmsettingsPrintersForm-show_zpl_form").checked
  ) {
	$("#hide-box-zpl").show();
	$("#other-box-zpl").hide();
  } else {
	$("#hide-box-zpl").hide();
	$("#other-box-zpl").show();
  }

  if (
	document.getElementById("frmsettingsPrintersForm-show_spis_zpl_form") !== null &&
	document.getElementById("frmsettingsPrintersForm-show_spis_zpl_form").checked
  ) {
	$("#hide-box-zpl-spis").show();
	$("#other-box-zpl-spis").hide();
  } else {
	$("#hide-box-zpl-spis").hide();
	$("#other-box-zpl-spis").show();
  }

  $("#frmsettingsPrintersForm-show_zpl_form").click(function (e) {
	if (this.checked == true) {
	  $("#hide-box-zpl").show();
	  $("#other-box-zpl").hide();
	} else {
	  $("#hide-box-zpl").hide();
	  $("#other-box-zpl").show();
	}
  });

  $("#frmsettingsPrintersForm-show_spis_zpl_form").click(function (e) {
	if (this.checked == true) {
	  $("#hide-box-zpl-spis").show();
	  $("#other-box-zpl-spis").hide();
	} else {
	  $("#hide-box-zpl-spis").hide();
	  $("#other-box-zpl-spis").show();
	}
  });

  $("#dialog").on("submit", "#frm-searchForm", function (event) {
	postFormJ(this, function (data) {
	  if (data.redirect) window.location.href = data.redirect;
	  else {
		$("#dialog").html(data);
		dialogScrollUp();
	  }
	});
	return false;
  });

	function initAutoComplete() {
		$(".advancedAutoComplete").autoComplete({
			minLength: 3,
			resolver: "custom",
			resolverSettings: {
				requestThrottling: 100, //Default 500
			},
			noResultsText: "Nebyl nalezen žádný uživatel",
			formatResult: function (item) {
				let linkRemote = $(".advancedAutoComplete").data('remote');
				let url = '';
				if (linkRemote) {
					linkRemote = linkRemote.replace('<_userId>', item._userId ?? null)
					.replace('<_orgId>', item.org_jednotka ?? null);
				}

				let linkRemoteOrg = $(".advancedAutoComplete").data('remoteorg');
				if (linkRemoteOrg && (item._orgUnit ?? null)) {
					linkRemote = linkRemoteOrg.replace('<_orgUnit>', item._orgUnit ?? null);
				}

				if (linkRemote) {
					let u = new URL(linkRemote, window.location.origin);
					// projdeme parametry a smažeme ty, které mají hodnotu "null" nebo "undefined"
					for (const [key, value] of u.searchParams.entries()) {
						if (value === "null" || value === "undefined" || value === "") {
							u.searchParams.delete(key);
						}
					}
					url = (u.pathname + "?" + u.searchParams.toString()).substring(1);

					if (linkRemoteOrg && (item._orgUnit ?? null)) {
						url = (u.pathname + "?" + u.searchParams.toString());
					}
				}

				return {
					value: item.id,
					text: item.value,
					html: linkRemote && url ? '<a href="' + url + '" class="dropdown-item">' + item.value + '</a>' : undefined,
				};
			},
			events: {
				search: function (qry, callback) {
					$.ajax(BASE_URL + "uzivatel/seznam-ajax", {
						data: {term: qry, vcetneOjUzivatele: 1},
					}).done(function (res) {
						callback(res.results);
					});
				},
			},
		});

		$(".advancedAutoComplete").on("autocomplete.select", function (evt, item) {
			$(this).val("");

			if (item.id.substring(0, 1) == "u") {
				const uAndO = item.id.split(";");
				$("input[name=predano_user]").val(uAndO[0].substr(1));
				$("input[name=predano_org]").val(uAndO[1]);
				$("#predano").html("<p><strong>" + item.nazev + "</strong></p>");
			} else if (item.id.substring(0, 1) == "o") {
				$("input[name=predano_user]").val("");
				$("input[name=predano_org]").val(item.id.substr(1));
				$("#predano").html("<p><strong>" + item.nazev + "</strong></p>");
			}
			$("#zrusit_predani").css("display", "");
			$("#validatePredat").html("");
		});
	}

	initAutoComplete();


	// $(".advancedAutoComplete").keypress(function (event) {
	$(document).on('keydown', '.advancedAutoComplete', function (event) {
		// nacteni eventu pro dany prvek
		let evts = $._data($('.advancedAutoComplete')[0], 'events') || {};
		// pokud nejsou nacteny, inicializujeme naseptavani
		if (!evts || $.isEmptyObject(evts)) {
			initAutoComplete();
		}

		if (event.which == 13) {
			event.preventDefault();
		}
	});

  $("#frmaddUserForm-user").autoComplete({
	minLength: 3,
	resolver: "custom",
	resolverSettings: {
	  requestThrottling: 100, //Default 500
	},
	noResultsText: "Nebyl nalezen žádný subjekt",
	formatResult: function (item) {
	  return {
		value: item.id,
		text: item.value,
	  };
	},
	events: {
	  search: function (qry, callback) {
		$.ajax(BASE_URL + "uzivatel/seznam-ajax", {
		  data: { term: qry },
		}).done(function (res) {
		  callback(res.results);
		});
	  },
	},
  });

  $("#frmaddUserForm-user").on("autocomplete.select", function (evt, item) {
	$('#frm-addUserForm input[name="userToRole"]').val(item.id.substr(1));
	return false;
  });

  $("#opravneniUser").autoComplete({
	minLength: 3,
	resolver: "custom",
	resolverSettings: {
	  requestThrottling: 100, //Default 500
	},
	noResultsText: "Nebyl nalezen žádný subjekt",
	formatResult: function (item) {
	  return {
		value: item.id,
		text: item.value,
	  };
	},
	events: {
	  search: function (qry, callback) {
		$.ajax(BASE_URL + "uzivatel/seznam-ajax", {
		  data: { term: qry, odkudOpravneni: 1 },
		}).done(function (res) {
		  callback(res.results);
		});
	  },
	},
  });

  $("#opravneniUser").on("autocomplete.select", function (evt, item) {
	$('#frm-addUserForm input[name="userToRole"]').val(item.id.substr(1));
	return false;
  });

  $("#technicalNotifUser").autoComplete({
	minLength: 3,
	resolver: "custom",
	resolverSettings: {
	  requestThrottling: 100, //Default 500
	},
	noResultsText: "Nebyl nalezen žádný subjekt",
	formatResult: function (item) {
	  return {
		value: item.id,
		text: item.value,
	  };
	},
	events: {
	  search: function (qry, callback) {
		$.ajax(BASE_URL + "uzivatel/seznam-ajax", {
		  data: { term: qry },
		}).done(function (res) {
		  callback(res.results);
		});
	  },
	},
  });

  $("#technicalNotifUser").on("autocomplete.select", function (evt, item) {
	$('#frm-addTechnicalNotifUserForm input[name="userId"]').val(
	  item.id.slice(1)
	);
	return false;
  });

  $.widget( "custom.catcomplete", $.ui.autocomplete, {
	_create: function() {
	  this._super();
	  this.widget().menu( "option", "items", "> :not(.ui-autocomplete-category)" );
	},
	// jQuery UI při prázdném výsledku menu zavře a volbu noResultsText nezná.
	__response: function( content ) {
	  if ( (!content || !content.length) && this.options.noResultsText && !this.options.disabled && !this.cancelSearch ) {
		content = [{
		  label: this.options.noResultsText,
		  value: this.options.noResultsText,
		  _noResults: true
		}];
	  }
	  this._super( content );
	},
	_move: function( direction, event ) {
	  if ( !this.menu.element.find( ".ui-menu-item" ).length ) {
		return;
	  }
	  this._super( direction, event );
	},
	_renderMenu: function( ul, items ) {
	  if ( items.length === 1 && items[0]._noResults ) {
		$( "<li>" )
		  .addClass( "ui-autocomplete-category ui-autocomplete-no-results" )
		  .text( items[0].label )
		  .appendTo( ul );
		return;
	  }

	  let that = this,
		  currentCategory = "";
	  $.each( items, function( index, item ) {
		let li;
		if ( item.category !== currentCategory ) {
		  ul.append( "<li class='ui-autocomplete-category'>" + item.category_name + "</li>" );
		  currentCategory = item.category;
		}
		that._renderItemData( ul, item );
	  });
	},
	_renderItem: function(ul, item) {
		return $("<li>")
			.append("<div>" + item.value + "</div>")
			.appendTo(ul);
	}
  });

  $(".subjectAutoCompleteDocument").catcomplete({
	minLength: subjectAutocompleteMinLength,
	resolver: "custom",
	resolverSettings: {
	  requestThrottling: 100, //Default 500
	},
	noResultsText: "Nebyl nalezen žádný subjekt",
	source: function( request, response ) {
	  if(xhr && xhr.readystate != 4){
		xhr.abort();
	  }
	  window.clearTimeout(xhrTimer);
	  xhrTimer = window.setTimeout(function(){
		  xhr = $.ajax( {
			url: BASE_URL + "subjekty/seznam-ajax",
			data: {
			  term: request.term,
			  counts: 0
			},
			success: function( data ) {
			  response( data.results );
			}
		  } );
	  },xhrTimeout);
	},
	focus: function(event, ui) {
		event.preventDefault();
	},
	select: function(event, ui) {
		event.preventDefault();
		$('.subjectAutoCompleteDocument').val('');

		let item = ui.item;

		switch (item.type) {
		  case "subjekt":
			// Nasledujici kod zajistuje automaticke urceni typu pripojeni subjektu
			let typ_id = $("#frmnovyForm-dokument_typ_id").val();
			if (typeof typ_id == "undefined")
			  typ_id = $("#frmmetadataForm-dokument_typ_id").val();
			if (typeof typ_id == "undefined")
			  typ_id = $("#frmodpovedForm-dokument_typ_id").val();
			if (typeof typ_id == "undefined") typ_id = typ_dokumentu_id;

			let typ_code;
			if (
			  typeof typ_id != "undefined" &&
			  typeof smer_typu_dokumentu != "undefined"
			)
			  typ_code = Number(smer_typu_dokumentu[typ_id]) === 0 ? "O" : "A";
			else {
			  typ_code = "AO";
			}

			url =
			  BASE_URL +
			  "subjekty/" +
			  item.id +
			  "/vybrano?dok_id=" +
			  DOKUMENT_ID +
			  "&typ=" +
			  typ_code +
			  "&autocomplete=1";

			break;

		  case "adresni_skupina":
			url =
			  BASE_URL +
			  "adresni-skupiny/?do=priraditkdokumentu&skupina_id=" +
			  item.id +
			  "&dok_id=" +
			  DOKUMENT_ID +
			  "&autocomplete=1";
			break;
		}

		$.get(url, function (data) {
		  if (data.indexOf("###vybrano###") !== -1) {
			$("#validateAdresat").html("");
			renderSubjekty('document');
		  } else {
			alert(data);
		  }
		});

	}
  });

  // naseptavani kontaktu u adresnich skupin
  $(".kontaktAutoCompleteDocument").catcomplete({
	minLength: 3,
	resolver: "custom",
	resolverSettings: {
	  requestThrottling: 100,
	},
	noResultsText: "Nebyl nalezen žádný kontakt",
	source: function( request, response ) {
		$.ajax( {
		  url: BASE_URL + "admin/adresni-skupiny/seznam-ajax",
		  data: {
			term: request.term
		  },
		  success: function( data ) {
			response( data.results );
		  }
		} );
	},
	select: function(event, ui) {
		event.preventDefault();
		$(this).val("");
		let item = ui.item;
		pridejKontaktDoAdresniSpookyny(ADRESNI_SKUPINA_ID, item.id);
		return false;
	}

  });
  // naseptavani kontaktu u adresnich skupin konec

  // smazani kontaktu u adresni skupiny
  $(document).on("click", ".smazKontaktZAdresniSkupiny", function (evt, item) {
	evt.preventDefault();
	url = $(this).data("url");
	$.get(url, function (data) {
	  renderKontakty("AdresniSkupinaDetail");
	});

	return false;
  });
  // smazani kontaktu u adresni skupiny konec

  $(".subjectAutoCompleteSpis").catcomplete({
	minLength: subjectAutocompleteMinLength,
	resolver: "custom",
	resolverSettings: {
	  requestThrottling: 100, //Default 500
	},
	noResultsText: "Nebyl nalezen žádný subjekt",
	source: function( request, response ) {
	  if(xhr && xhr.readystate != 4){
		xhr.abort();
	  }
	  window.clearTimeout(xhrTimer);
	  xhrTimer = window.setTimeout(function(){
		  xhr = $.ajax( {
			url: BASE_URL + "subjekty/seznam-ajax",
			data: {
			  term: request.term,
			  counts: 0
			},
			success: function( data ) {
			  response( data.results );
			}
		  } );
	  },xhrTimeout);
	},
	focus: function(event, ui) {
		event.preventDefault();
	},
	select: function(event, ui) {
		event.preventDefault();
		$('.subjectAutoCompleteSpis').val('');

		let item = ui.item;

		switch (item.type) {
		  case "subjekt":
			url =
			  BASE_URL +
			  "subjekty/" +
			  item.id +
			  "/vybrano-pro-spis?spis_id=" +
			  SPIS_ID +
			  "&autocomplete=1";

			break;

		  case "adresni_skupina":
			url =
			  BASE_URL +
			  "adresni-skupiny/?do=priraditkespisu&skupina_id=" +
			  item.id +
			  "&spis_id=" +
			  SPIS_ID +
			  "&autocomplete=1";
			break;
		}

		$.get(url, function (data) {
		  if (data.indexOf("###vybrano###") !== -1) {
			renderSubjekty('spis');
		  } else {
			alert(data);
		  }
		});

	}
  });


	$("#frmexportBatchForm-puvodce").catcomplete({
		minLength: subjectAutocompleteMinLength,
		resolver: "custom",
		resolverSettings: {
			requestThrottling: 100, //Default 500
		},
		noResultsText: "Nebyl nalezen žádný subjekt",
		source: function( request, response ) {
			if(xhr && xhr.readystate != 4){
			  xhr.abort();
			}
			  window.clearTimeout(xhrTimer);
			  xhrTimer = window.setTimeout(function(){
				xhr = $.ajax( {
					url: BASE_URL + "subjekty/seznam-ajax",
					data: {
						term: request.term,
						counts: 0
					},
					success: function( data ) {
						response( data.results );
					}
				} );
			  },xhrTimeout);
		},
		focus: function(event, ui) {
			event.preventDefault();
			$('input[name=owner]').val(ui.item.id);			
			let subject = stripHtml(ui.item.category_name);
			$(this).val(subject);
		},

		select: function(event, ui) {
			event.preventDefault();
			$('input[name=owner]').val(ui.item.id);
			let subject = stripHtml(ui.item.category_name);
			$(this).val(subject);
		}
	});

	$("#frmexportBatchForm-puvodce").on('input', function() {
		if ($(this).val() === '') {
			$('input[name=owner]').val('');
		}
	});

	function stripHtml(html)
	{
		let tmp = document.createElement("DIV");
		tmp.innerHTML = html;
		return tmp.textContent || tmp.innerText || "";
	}

  $(".peventMultiCklick").on("click", function(e){
	  if($(this).hasClass("preventedClick")){
		  e.preventDefault();
		  e.stopPropagation();
		  return false;
	  }
	  else{
		  $(this).addClass("preventedClick").prop("disabled", true);
		  $(this).before('<span class="buttonLoading spinner-border spinner-border-sm" role="status"></span>');

		  setTimeout(function () {
			$(".preventedClick").removeProp("disabled").removeClass("preventedClick");
			$(".buttonLoading").remove();
		  }, 5000);
	  }
  });

  $(".peventMultiCklickForm").on("submit", function(e){
	$(this).find("input[type='submit']").addClass("preventedClick").prop("disabled", true);
	$(this).find("input[type='submit']").before('<span class="buttonLoading spinner-border spinner-border-sm" role="status"></span>');
  });

  $(function () {

	// Načtený app.js musí umět sebrat ID i když šablona funkci ještě nemá.
	$(document).on("click", "#documentsGridGroupActionInsertIntoSpis, [data-testid='button-vlozit-do-spisu']", function (e) {
	  if (typeof documentsGridInsertIntoSpis === "function") {
		return documentsGridInsertIntoSpis(e, this);
	  }

	  e.preventDefault();
	  e.stopImmediatePropagation();

	  var selections = [];
	  var root = this.closest ? (this.closest(".datagrid") || document) : document;
	  root.querySelectorAll('input[type="checkbox"][name*="_group_action_item"]:checked').forEach(function (input) {
		var match = String(input.name || "").match(/\[(\d+)\]/);
		if (match) {
		  selections.push(match[1]);
		}
	  });

	  if (selections.length === 0) {
		return false;
	  }

	  window.DOCUMENT_IDS = selections.join("-");
	  var url = this.getAttribute("data-vyber-url") || (BASE_URL + "spisy/vyber");
	  url += (url.indexOf("?") === -1 ? "?" : "&") + "documentIds=" + encodeURIComponent(window.DOCUMENT_IDS);

	  $.ajax({
		url: url,
		type: "post",
		success: function (response) {
		  var $modal = $("#theModal");
		  $modal.find(".modal-body").html(response);
		  $modal.find(".modal-title").text("Výběr spisu");
		  $modal.find(".modal-dialog").addClass("modal-xl");
		  $modal.modal("show");
		},
		error: function () {
		  window.location.href = url;
		},
	  });

	  return false;
	});

	$("#bulkAction").submit(function () {
	  var dataArray = $(this).serializeArray();
	  var action = null;
	  var selections = [];

	  for (var i = 0; i < dataArray.length; i++) {
		if (dataArray[i].name === "action") {
		  var action = dataArray[i].value;
		}

		if (dataArray[i].name === "selection[]") {
		  selections.push(dataArray[i].value);
		}
	  }

	  if (action === "vlozit_do_spisu" && selections.length > 0) {
		var url = BASE_URL + "spisy/vyber?documentIds=" + selections.join("-");
		$.ajax({
		  url: url,
		  type: "post",
		  success: function (response) {
			$(".modal-body").html(response);
			$("#theModal").modal("show");
			$(".modal-title").text("Výběr spisu");
			$(".modal-dialog").addClass("modal-xl");
		  },
		});

		return false;
	  }

	  if (action === "vratit" && selections.length > 0) {
		var url = BASE_URL + "vypravna/vratit?doIds=" + selections.join("-");
		$.ajax({
		  url: url,
		  type: "post",
		  success: function (response) {
			$(".modal-body").html(response);
			$("#theModal").modal("show");
			$(".modal-title").text("Důvod vrácení");
		  },
		});

		return false;
	  }
	});

	$("#bulkActionPAListinne").submit(function () {
	  var dataArray = $(this).serializeArray();
	  var action = null;
	  var selections = [];

	  for (var i = 0; i < dataArray.length; i++) {
		if (dataArray[i].name === "action") {
		  var action = dataArray[i].value;
		}

		if (dataArray[i].name === "selection[]") {
		  selections.push(dataArray[i].value);
		}
	  }

	  if (action === "vratit" && selections.length > 0) {
		var url = BASE_URL + "vypravna/vratit?doIds=" + selections.join("-");
		$.ajax({
		  url: url,
		  type: "post",
		  success: function (response) {
			$(".modal-body").html(response);
			$("#theModal").modal("show");
			$(".modal-title").text("Důvod vrácení");
		  },
		});

		return false;
	  }
	});
  });

  $("#tp_subjekt_id2").autocomplete({
	minLength: subjectAutocompleteMinLength,
	resolver: "custom",
	resolverSettings: {
	  requestThrottling: 100, //Default 500
	},
	noResultsText: "Nebyl nalezen žádný subjekt",
	formatResult: function (item) {
	  return {
		value: item.id,
		text: item.value,
	  };
	},
	events: {
	  search: function (qry, callback) {
		if(xhr && xhr.readystate != 4){
		  xhr.abort();
		}
		  window.clearTimeout(xhrTimer);
		  xhrTimer = window.setTimeout(function(){
			xhr = $.ajax(BASE_URL + "subjekty/seznam-ajax", {
			  data: {
					term: qry,
					counts: 0
			  },
			}).done(function (res) {
			  callback(res.results);
			});
		  },xhrTimeout);
	  },
	},
  });

  $("#tp_subjekt_id2").on("autocomplete.select", function (evt, item) {
	$(this).val("");

	url = BASE_URL + "admin/nastaveni/vybrano/" + item.id + "?autocomplete=1";

	$.get(url, function (data) {
	  if (data.indexOf("###vybrano###") != -1) {
		url = BASE_URL + "admin/nastaveni/nacti/" + item.id;

		$.get(url, function (data) {
		  $("#dok-subjekty").html(data);
		  $("#tp_subjekt_id2").val(item.id);
		  $("#tp_subjekt_id2").hide();
		});

		return false;
	  } else {
		alert(data);
	  }
	});

	return false;
  });

  $("#subjekt_autocomplete, #tp_subjekt_id2").keypress(function (event) {
	if (event.which == 13) {
	  event.preventDefault();
	}
  });

  const formsWithDisabledSubmitsAfterSubmit = [
	/*
	"frm-odeslatForm",
	"frm-doplnkovaMetadata-form",
	"frm-vyrizovaniForm",
	"frm-novyForm",
	"frm-upravitForm",
	"frm-novaSlozkaForm",
	"frm-noteOpenForm",
	"subjekt-vytvorit",
	"frm-kontaktForm-form",
	*/
  ];
  formsWithDisabledSubmitsAfterSubmit.forEach(disableSubmitButtons);

  const formsWithDisabledSubmitsAfterSubmitHard = [];
  formsWithDisabledSubmitsAfterSubmitHard.forEach(disableSubmitButtonsHard);

  const disableLinkOnClickEndsOn = ["uzavrit"];
  disableLinkOnClickEndsOn.forEach(disableLink);

  // it needs to be delegated (because there are cases that those buttons/links are generated dynamically)
  $(document).ready(function () {
	$(document).on("click", ".one-click-link", function () {
	  const link = $(this).prop("href");
	  $(this).attr("href", "javascript:void(0)");
	  $(this).attr("onclick", "javascript:void(0)");
	  window.location.href = link;
	});
  });

   $(".confirmButton").on("click",function(e){
	e.preventDefault();
	var link = this;
	var question = $(this).data("confirm");
	if (confirm(question)) {
		if($(this).hasClass("ajaxed")){
			$.ajax({
				url: link.href
			}).done(function() {
				if($(".refreshContacts").length>0){
					$(".refreshContacts").trigger("click");
				}
			});
		}
		else{
			window.location.href = link.href;
		}
	}
	else{
		return false;
	}
	});

});

/*
 *  Vyvolani dialogu
 *
 *
 */
dialog = function (elm, title, url) {
  // jQuery UI bug - je-li title prázdný, rozhodí se layout dialogu
  if (typeof title == "null" || title == "") title = "Dialogové okno";

  $("#dialog").dialog("option", "title", title);
  $("#dialog").html("");
  $("#dialog").dialog("open");

  var postdata = false;
  if (elm) {
	if (!(elm instanceof jQuery)) elm = $(elm);

	postdata = elm.attr("data-postdata");
	if (postdata) postdata = $.parseJSON(postdata);
  }
  if (typeof url == "undefined") url = elm.attr("href");
  var jqXHR;
  var successFunction = function (data) {
	if (typeof data !== "string") {
	  console.log("Nacitam data z URL: " + url);
	  console.log("--- START URL_DATA ---");
	  console.log(data);
	  console.log("--- KONEC URL_DATA ---");
	  data =
		'<br><div class="flash_message flash_error">Omlouváme se, ale došlo k chybě - obsah není přístupný.</div>';
	}
	$("#dialog").html(data);
  };
  if (postdata) jqXHR = $.post(url, $.param(postdata), successFunction);
  else jqXHR = $.get(url, successFunction);

  jqXHR.fail(function (jqXHR) {
	// Následující akce nyní provádí globální handler:
	// alert('Při načítání obsahu okna došlo k vážné chybě.');
	// $('#dialog').html('<pre>' + jqXHR.responseText);
  });

  return false;
};

reloadDialog = function (elm) {
  $.get(elm.href, function (data) {
	$("#dialog").html(data);
  });

  return false;
};

reloadModal = function (elm) {
  const target = elm.attributes.href.value;
  const title = elm.dataset.title;

  if(title !== undefined){
	  $("#theModal .modal-title").text(title);
  }

  $("#theModal .modal-body").load(target, function () {
	var $modal = $("#theModal");
	$modal.removeClass("modalhidden");
	if ($modal.hasClass("show")) {
	  $("body").addClass("modal-open");
	  $modal.show();
	} else {
	  $modal.css("display", "");
	  $modal.modal("show");
	}
  });
};

closeDialog = function () {
  $("#theModal").modal("hide");
  $("#ajax-spinner").hide();
  return false;
};
restoreParentModal = function (reload) {
  var $parent = $("#theModal.modalhidden");
  if ($parent.length === 0) {
	$parent = $(".modalhidden").first();
  }
  if ($parent.length === 0) {
	return;
  }
  $parent.removeClass("modalhidden");
  if (reload && reload.nodeType && reload.getAttribute("href")) {
	reloadModal(reload);
	return;
  }
  // Třída show zůstala: dialog jen schoval jQuery. Jinak ho zavřel Bootstrap 5 a je potřeba ho znovu otevřít.
  if ($parent.hasClass("show")) {
	$("body").addClass("modal-open");
	$parent.show();
  } else {
	$parent.css("display", "");
	$parent.modal("show");
  }
};

closeDialog2 = function (reload = false) {
  var $modal2 = $("#theModal2");
  var shouldRestore = $(".modalhidden").length > 0;
  $("#ajax-spinner").hide();
  var finish = function () {
	if (shouldRestore) {
	  restoreParentModal(reload);
	}
  };
  if ($modal2.hasClass("show")) {
	$modal2.one("hidden.bs.modal", finish);
	$modal2.modal("hide");
  } else {
	$modal2.modal("hide");
	finish();
  }
  return false;
};


dialogScrollUp = function () {
  $("#dialog").scrollTop("0");
};

showRow = function (id) {
  $("#row" + id).toggle();
};

showItems = function (ids) {

  $("#row" + id).toggle();
};


/*
 * ARES
 *
 */
aresSubjekt = function (withDS = 0, allowValidation = false) {
  var mapovani = {};
  var mapovaniSimple = {};
  var pojmenovani = {};
  var mapovaniDS = {};
  var mapovaniJenConfirm = {};
  var mapovaniJenUlozit = {};
	mapovani["ico"] 				= "input[name='ic']";
	mapovani["dic"] 				= "input[name='dic']";
	mapovani["nazev"] 				= "input[name='nazev_subjektu']";
	mapovani["ulice"] 				= "input[name='firma_adresa_ulice']";
	mapovani["cislo_popisne"] 		= "input[name='firma_adresa_cp']";
	mapovani["cislo_orientacni"] 	= "input[name='firma_adresa_co']";
	mapovani["mesto"] 				= "input[name='firma_adresa_mesto']";
	mapovani["psc"] 				= "input[name='firma_adresa_psc']";
	mapovaniJenConfirm["type_name"] = "select[name='type']";
	mapovaniJenUlozit["type"] 		= "select[name='type']";
	mapovaniDS["id_isds"] 			= ".firstDSRow input";
	mapovaniDS["postovnidz"] 		= "input[name='firma_postovnidz']";
	mapovaniJenConfirm["registrace_typ"]	= "select[name='pravni_forma']";
	mapovaniJenUlozit["registrace_typ_id"] 	= "select[name='pravni_forma']";

	pojmenovani["ico"] 				= "IČO";
	pojmenovani["dic"] 				= "DIČ";
	pojmenovani["nazev"] 			= "Název subjektu";
	pojmenovani["ulice"] 			= "Ulice";
	pojmenovani["cislo_popisne"] 	= "Číslo popisné";
	pojmenovani["cislo_orientacni"] = "Číslo orientační";
	pojmenovani["mesto"] 			= "Město";
	pojmenovani["psc"] 				= "PSČ";
	pojmenovani["type_name"] 		= "Typ subjektu";
	pojmenovani["type"] 			= "Typ subjektu";
	pojmenovani["id_isds"] 			= "ID datové schránky";
	pojmenovani["postovnidz"] 		= "Přijímá poštovní DZ";
	pojmenovani["registrace_typ"] 	= "Právní forma";
	pojmenovani["registrace_typ_id"] = "Právní forma";

	mapovaniSimple["ulice"] 			= "input[name='adresa_ulice']";
	mapovaniSimple["cislo_popisne"] 	= "input[name='adresa_cp']";
	mapovaniSimple["cislo_orientacni"] 	= "input[name='adresa_co']";
	mapovaniSimple["mesto"] 			= "input[name='adresa_mesto']";
	mapovaniSimple["psc"] 				= "input[name='adresa_psc']";



  var inputEl = $("input[name=ic]");
  var inputElDic = $("input[name=dic]");
  var IC = inputEl.val();
  var DIC = inputElDic.val();
  if (!IC && !DIC) {
	alert("Vyplňte IČ nebo DIČ subjektu.");
	inputEl.focus();
	return false;
  }
  if(IC){
	  if(parseInt(IC) != IC){
		alert("IČ subjektu může obsahovat pouze číslice.");
		inputEl.focus();
		return false;
	  }
  }
  else if(DIC){
	  IC = DIC.replace("CZ", "");
  }
  //var inputSelector = inputEl.attr("id");
  //inputSelector = "#" + inputSelector.replace("-ic", "");

  var url = BASE_URL + "subjekty/ares?ic=" + IC + "&withDs=" + withDS;

  $.getJSON(url, function (data) {
	if (data.error) {
	  alert(data.error);
	} else {
	  if (data.dic == "Skupinove_DPH") {
		data.dic = "Skup_DPH";
	  }
	  var output = "Převzít následující údaje Z ARES?<br><br><table class='table table-striped'><tbody>";
	  $.each(mapovani, function(index, value){
		  if (data.hasOwnProperty(index)) {
			output = output + "<tr><td class='text-right'>" + pojmenovani[index] + ":</td><td>" + data[index] + "</td></tr>";
		  }

	  });
	  $.each(mapovaniJenConfirm, function(index, value){
		  if (data.hasOwnProperty(index)) {
			output = output + "<tr><td class='text-right'>" + pojmenovani[index] + ":</td><td>" + data[index] + "</td></tr>";
		  }

	  });
	  if (data.hasOwnProperty("id_isds")) {
		  $.each(mapovaniDS, function(index, value){
			  if (data.hasOwnProperty(index)) {
				output = output + "<tr><td class='text-right'>" + pojmenovani[index] + ":</td><td>" + data[index] + "</td></tr>";
			  }

		  });
	  }
	  output = output + "</tbody></table>";

	  $("#confirmModal .modal-title").html("Načtení údajů z ARES");
	  $("#confirmModal .modal-body").html(output);
	  $("#confirmModal").modal("show");

	  $('#confirmModal .modal-footer #modalConfirmYes.ajaxed').on('click', function(event) {
		  event.preventDefault();
		  return false;
		  $.ajax({
			url: $(this).attr("href"),
			type: "get",
			success: function (data) {
				$("#confirmModal").modal("hide");
				$(".subjectsRefreshButton").trigger("click");
			}
		  });
	  });
	  $("#confirmModal").on("hidden.bs.modal", function(){
		  setTimeout(function(){
			if ($('.modal:visible').length) {
			  $('body').addClass('modal-open');
			}
		  }, 500);
	  });
	  $('#confirmModal .modal-footer #modalConfirmYes').on('click', function(event) {
		  $.each(mapovani, function(index, value){
			  if (data.hasOwnProperty(index)) {
				 $(value).val(data[index]);
			  }

		  });
		  $.each(mapovaniJenUlozit, function(index, value){
			  if (data.hasOwnProperty(index)) {
				 $(value).val(data[index]);
			  }

		  });
		  if (data.hasOwnProperty("id_isds")) {
			  $.each(mapovaniDS, function(index, value){
				  if (data.hasOwnProperty(index)) {
					 $(value).val(data[index]);
				  }

			  });
		  }
		  if($("input[name='firma_adresa_ulice']:visible").length==0){
			  $.each(mapovaniSimple, function(index, value){
				  if (data.hasOwnProperty(index)) {
					 $(value).val(data[index]);
				  }

			  });
		  }
		  $("input[name='agenda']").val("ARES");
		  $("input[name='aifo']").val(data["ico"]);
		  var datetime = formatCurrentDate();
		  $("input[name='datum_cas_ztotozneni']").val(datetime);
		  $("input[name='aifo']").trigger("change");
		  var form = document.getElementById("subjekt-vytvorit");
		  var el = document.getElementById("frmnovySubjektForm-form-type");
		  Nette.toggleForm(form, el);
		  $("#confirmModal").modal("hide");
		  setTimeout(function(){
			if ($('.modal:visible').length) {
			  $('body').addClass('modal-open');
			}
		  }, 500);

		  if (allowValidation) {
			  var type=$("select[name='type']").val();
			  if (type == "PO" || type == "PFO") {
				  searchRuianSidlo();
			  } else {
				  searchRuianPobyt();
			  }
		  }
	  });


	  /*
	  if(confirm(output)){
		  $.each(mapovani, function(index, value){
			  if (data.hasOwnProperty(index)) {
				 $(value).val(data[index]);
			  }

		  });
		  $.each(mapovaniJenUlozit, function(index, value){
			  if (data.hasOwnProperty(index)) {
				 $(value).val(data[index]);
			  }

		  });
		  if (data.hasOwnProperty("id_isds")) {
			  $.each(mapovaniDS, function(index, value){
				  if (data.hasOwnProperty(index)) {
					 $(value).val(data[index]);
				  }

			  });
		  }
		  var form = document.getElementById("subjekt-vytvorit");
		  var el = document.getElementById("frmnovySubjektForm-form-type");
		  Nette.toggleForm(form, el);

	  }
	  */
	  /*
	  $(inputSelector + "-ic").val(data.ico);
	  $(inputSelector + "-dic").val(data.dic);
	  $(inputSelector + "-nazev_subjektu").val(data.nazev);
	  $(inputSelector + "-firma_adresa_ulice").val(data.ulice);
	  $(inputSelector + "-firma_adresa_cp").val(data.cislo_popisne);
	  $(inputSelector + "-firma_adresa_co").val(data.cislo_orientacni);
	  $(inputSelector + "-firma_adresa_mesto").val(data.mesto);
	  $(inputSelector + "-firma_adresa_psc").val(data.psc);
	  $(inputSelector + "-firma_adresa_stat").val("CZE");
	  $(inputSelector + "-stat_narozeni").val("CZE");
	  if (data.hasOwnProperty("id_isds")) {
		$(".firstDSRow input").val(data.id_isds);
		$(inputSelector + "-type").val(data.type);
		$(inputSelector + "-firma_postovnidz").prop("checked", data.postovnidz);
	  }
	  $(inputSelector + "-ic").trigger("change");
	  */
	}
  });

  return false;
};

/*
 * ISDS - vyhledat subjekt na zaklade id  schranky
 *
 */
isdsSubjekt = function (link, page = 0, prefix = "") {
  if (prefix != "") {
	var inputSelector = prefix;
	var ID = "";
  } else {
	var inputEl = $(link).closest(".isdsBlock").find(".firstDSRow input") //old version $(link).prev();
	var ID = inputEl.val();
	var inputSelector = inputEl.attr("id");
  }

  var inputSelectorJ = inputSelector.replace("-dss-0", "");
  inputSelector = "#" + inputSelector.replace("-dss-0", "");

  var typ = $(inputSelector + "-type").val();

  if (typ == "FO") {
	var ic = null;
	var subjekt = null;
  } else {
	var ic = $(inputSelector + "-ic").val();
	var subjekt = $(inputSelector + "-nazev_subjektu").val();
  }

  var jmeno = $(inputSelector + "-adresa_jmeno").val();
  if (!jmeno) {
	jmeno = $(inputSelector + "-jmeno").val();
  }
  var prijmeni = $(inputSelector + "-adresa_prijmeni").val();
  if (!prijmeni) {
	prijmeni = $(inputSelector + "-prijmeni").val();
  }
  var adresa_mesto = $(inputSelector + "-firma_adresa_mesto").val();
  if (!adresa_mesto) {
	adresa_mesto = $(inputSelector + "-misto_narozeni").val();
  }
  var adresa_ulice = $(inputSelector + "-firma_adresa_ulice").val();
  if ($(inputSelector + "-type")) {
	var type = $(inputSelector + "-type").val();
  } else {
	var type = "";
  }

  if (!ID && !ic && !subjekt && !prijmeni) {
	alert(
	  "Zadejte ID datové schránky, Název subjektu, IČ subjektu nebo Příjmení"
	);
	return false;
  }

  var url = BASE_URL + "subjekty/isds?box=" + ID;
  $.getJSON(
	url,
	{
	  ic: ic,
	  subjekt: subjekt,
	  jmeno: jmeno,
	  prijmeni: prijmeni,
	  adresa_mesto: adresa_mesto,
	  adresa_ulice: adresa_ulice,
	  type: type,
	  page: page,
	},

	function (data) {
	  if (data == null) {
		$("#vice_vysledku").css("display", "");
		$("#vice_vysledku_detail").html(
		  "<p class='text-danger'>Záznam neexistuje nebo bylo zadáno chybné ID datové schránky.</p>"
		);
	  } else if (data.error && data.error.trim() == "-") {
		$("#vice_vysledku").css("display", "");
		$("#vice_vysledku_detail").html(
		  "<p class='text-danger'>Číslo datové schránky nenalezeno.</p>"
		);
	  } else if (data.error) {
		$("#vice_vysledku").css("display", "");
		$("#vice_vysledku_detail").html(
		  "<p class='text-danger'>" + data.error + "</p>"
		);
	  } else if (data.vice_vysledku) {
		// rozdeleni pokud nam vyhledavani vraci vice vysledku, nebo jen jeden konkretni
		$("#vice_vysledku").css("display", "");
		vystup =
		  '<table class="table seznam table-striped table-hover table-bordered">';

		vystup =
		  vystup +
		  '<tr><td colspan="7"><strong><u>Vyhledano dle:</u></strong> ' +
		  data.filtr +
		  "</td></tr>";

		vystup =
		  vystup +
		  "<tr><th>Subjekt</th><th>Identifikátor</th><th>Adresa</th><th>IČO</th><th>Právní forma</th><th>Datum narození</th><th>Příjem PDZ</th></tr>";

		pouzito_oddeleni = false;
		for (const [key, value] of Object.entries(data.vice_vysledku)) {
		  //pokud jsme hledali prijmeni a vratili se nam zaznamy, kde je prijmeni uvedeno v nazvu ulice ci mesta,
		  // tak udelame oddeleni (datovky nejdriv vraci vysledky kde hledany reteyec je v prijmeni/jmenu/nazvu a pote kde j v ulici/mestu
		  /*
		  if (
			((prijmeni &&
			  value.dbName.toLowerCase().indexOf(prijmeni.toLowerCase()) ===
				-1) ||
			  (subjekt &&
				value.dbName.toLowerCase().indexOf(subjekt.toLowerCase()) ===
				  -1)) &&
			!pouzito_oddeleni
		  ) {
			pouzito_oddeleni = true;
			vystup =
			  vystup +
			  '<tr><td colspan="7">Následující výsledky mají hledané příjmení či název v adrese</td></tr>';
		  }
		  */

		  var dbType = null;
		  const result = [];

		  if (value.dbType) {
			if (value.dbType == "Fyzická osoba") {
			  var dbType = "FO";
			  const splitDbName = value.dbName.split(" ");
			  if (splitDbName.length == 2) {
				result[inputSelector + "-nazev_subjektu"] = "";
				result[inputSelector + "-jmeno"] = splitDbName[0];
				result[inputSelector + "-prijmeni"] = splitDbName[1];
			  }
			} else if (value.dbType == "Podnikající fyzická osoba") {
			  var dbType = "PFO";
			  const splitDbName = value.dbName.split(" ");
			  if (splitDbName.length == 2) {
				result[inputSelector + "-nazev_subjektu"] = "";
				result[inputSelector + "-jmeno"] = splitDbName[0];
				result[inputSelector + "-prijmeni"] = splitDbName[1];
			  } else {
				result[inputSelector + "-nazev_subjektu"] = value.dbName;
				result[inputSelector + "-jmeno"] = "";
				result[inputSelector + "-prijmeni"] = "";
			  }
			} else if (value.dbType == "Orgán veřejné moci") {
			  var dbType = "OVM";
			  result[inputSelector + "-nazev_subjektu"] = value.dbName;
			  result[inputSelector + "-jmeno"] = "";
			  result[inputSelector + "-prijmeni"] = "";
			} else if (value.dbType == "Právnická osoba") {
			  var dbType = "PO";
			  result[inputSelector + "-nazev_subjektu"] = value.dbName;
			  result[inputSelector + "-jmeno"] = "";
			  result[inputSelector + "-prijmeni"] = "";
			}
		  }

		  result[inputSelector + "-type"] = dbType;
		  result[inputSelector + "-ic"] = value.dbICO ?? null;
		  result[inputSelector + "-id_isds"] = value.dbID ?? null;

		  const jsonResult = JSON.stringify(Object.assign({}, result));

		  vystup =
			vystup +
			'<tr><td><a href="#" data-values=\'' +
			jsonResult +
			'\' onClick="setSubjektFormValuesByISDS(this)";>' +
			value.dbName +
			"</a></td><td>" +
			value.dbID +
			"</td><td>" +
			value.dbAddress +
			"</td><td>" +
			value.dbICO +
			"</td><td>" +
			value.dbType +
			"</td><td>" +
			value.dbBiDate +
			"</td><td>" +
			value.dbSendOptions +
			"</td></tr>";
		}

		vystup =
		  vystup +
		  "<tr><th> Celkem nalezeno " +
		  data.pocet_vysledku +
		  " záznamů " +
		  '</th><th colspan="6" style="max-width: 300px; word-wrap: break-word;" class="paginator">';
		// pokud bylo více stran vysledku
		if (data.vice_stran) {
		  vystup = vystup + "Stránky s výsledky: ";
		  for (ii = 0; ii < data.pocet_stran; ii++) {
			odkaz =
			  "<a onClick=\"return isdsSubjekt('vyhledani-isds'" +
			  "," +
			  ii +
			  ",'" +
			  inputSelectorJ +
			  '\');" href="#"';
			if (data.aktualni_strana == ii) {
			  odkaz = odkaz + ' class="current" ';
			}
			odkaz = odkaz + ">" + (ii + 1) + "</a>";
			if (ii + 1 != data.pocet_stran) {
			  odkaz = odkaz + "";
			}
			vystup = vystup + odkaz;
		  }
		}
		vystup = vystup + "</th></tr>";
		vystup = vystup + "</table>";

		$("#vice_vysledku_detail")
		  .html(vystup)
		  .prepend(
			"<div class='clearfix'></div><h4>Bylo nalezeno více subjektů, kliknutím na konkrétní se doplní jeho údaje</h4>"
		  );
	  } else {
		$("#vice_vysledku").css("display", "");
		const result = [];
		const addressPrefix = '';
		if(data.dbType !== 'FO'){
			addressPrefix = 'firma_';
		}
		result[inputSelector + "-type"] = data.dbType ?? null;
		result[inputSelector + "-ic"] = data.ic ?? null;
		result[inputSelector + "-dic"] =
		  data.dic && data.dic.length > 4 ? data.dic : null;
		result[inputSelector + "-id_isds"] = data.dbID ?? null;
		result[inputSelector + "-nazev_subjektu"] = data.firmName ?? null;
		result[inputSelector + "-adresa_jmeno"] = data.pnFirstName ?? null;
		result[inputSelector + "-jmeno"] = data.pnFirstName ?? null;
		result[inputSelector + "-prostredni_jmeno"] = data.pnMiddleName ?? null;
		result[inputSelector + "-adresa_prijmeni"] = data.pnLastName ?? null;
		result[inputSelector + "-prijmeni"] = data.pnLastName ?? null;
		//result[inputSelector + "-misto_narozeni"] = data.adCity ?? null;
		result[inputSelector + "-"+addressPrefix+"adresa_ulice"] = data.adStreet ?? null;
		result[inputSelector + "-"+addressPrefix+"adresa_cp"] =
		  data.adNumberInMunicipality ?? null;
		result[inputSelector + "-"+addressPrefix+"adresa_co"] = data.adNumberInStreet ?? null;
		result[inputSelector + "-"+addressPrefix+"adresa_mesto"] = data.adCity ?? null;
		result[inputSelector + "-"+addressPrefix+"adresa_psc"] = data.adZipCode ?? null;
		result[inputSelector + "-postovnidz"] = data.dbOpenAddressing ?? null;

		const jsonResult = JSON.stringify(Object.assign({}, result));

		vystup =
		  '<table class="table seznam table-striped table-hover table-bordered">';

		vystup =
		  vystup +
		  '<tr><td colspan="7"><strong><u>Vyhledano dle:</u></strong> ' +
		  data.filtr +
		  "</td></tr>";

		vystup =
		  vystup +
		  "<tr><th>Subjekt</th><th>Právní forma</th><th>Identifikátor</th><th>IČO</th><th>Jméno</th><th>Prostřední jméno</th><th>Příjmení</th></tr>";

		vystup =
		  vystup +
		  '<tr><td><a href="#" data-values=\'' +
		  jsonResult +
		  '\' onClick="setSubjektFormValuesByISDS(this)";>' +
		  (data.firmName !== null ? data.firmName : "") +
		  "</a></td><td>" +
		  (data.dbType !== null ? data.dbType : "") +
		  "</td><td>b" +
		  (data.dbID !== null ? data.dbID : "") +
		  "</td><td>" +
		  (data.ic !== null ? data.ic : "") +
		  "</td><td>" +
		  (data.pnFirstName !== null ? data.pnFirstName : "") +
		  "</td><td>" +
		  (data.pnMiddleName ? data.pnMiddleName : "") +
		  '<td><a href="#" data-values=\'' +
		  jsonResult +
		  '\' onClick="setSubjektFormValuesByISDS(this)";>' +
		  (data.pnLastName ? data.pnLastName : "") +
		  "</a></td></tr>";

		vystup = vystup + "<tr><th colspan='7'>Adresa</th></tr>";

		vystup =
		  vystup +
		  "<tr><td colspan='7'>" +
		  (data.adStreet !== null ? data.adStreet : "") +
		  " " +
		  (data.adNumberInMunicipality !== null
			? data.adNumberInMunicipality
			: "") +
		  (data.adNumberInStreet !== null ? data.adNumberInStreet : "") +
		  ", " +
		  (data.adZipCode !== null ? data.adZipCode : "") +
		  "  " +
		  (data.adCity !== null ? data.adCity : "");

		vystup = vystup + "</td></tr>";

		vystup = vystup + "</table>";

		$("#vice_vysledku_detail").html(vystup);
	  }
	}
  );

  return false;
};

/*
 * ISDS - vyhledat subjekt na zaklade vyhledávacího formuláře v ISDS
 *
 */
isdsSearch = function (page = 0, allowValidation = false) {

  var mapovani = {};
	mapovani["firmName"] 				= "Obchodní název";
	mapovani["dbID"] 					= "ID datové schránky";
	mapovani["dbType"] 					= "Typ subjektu";
	mapovani["ic"] 						= "IČO";
	mapovani["pnFirstName"] 			= "Jméno";
	mapovani["pnLastName"] 				= "Příjmení";
	mapovani["pnMiddleName"] 			= "Prostřední jméno";
	mapovani["pnLastNameAtBirth"] 		= "Rodné příjmení";
	mapovani["biDate"] 					= "Datum narození";
	mapovani["biCity"] 					= "Místo narození";
	//mapovani["biCounty"] 				= "IČO";
	//mapovani["biState"] 				= "IČO";
	mapovani["adCity"] 					= "Obec";
	mapovani["adStreet"] 				= "Ulice / část obce";
	mapovani["adNumberInStreet"] 		= "Číslo orientační";
	mapovani["adNumberInMunicipality"]	= "Číslo popisné";
	mapovani["adZipCode"] 				= "PSČ";
	//mapovani["adState"] 				= "IČO";
	//mapovani["nationality"] 			= "IČO";
	//mapovani["identifier"] 				= "IČO";
	//mapovani["registryCode"] 			= "IČO";
	//mapovani["dbState"] 				= "IČO";
	mapovani["dbEffectiveOVM"] 			= "OVM";
	//mapovani["dbOpenAddressing"] 		= "IČO";
	mapovani["postovnidz"] 				= "Příjem PDZ";

  var form = $(".ISDSForm");
  var ID = 			form.find("input[name=id_isds]").val();
  var subjekt = 	form.find("input[name=nazev]").val();
  var jmeno = 		form.find("input[name=jmeno]").val();
  var prijmeni = 	form.find("input[name=prijmeni]").val();
  var mesto = 		form.find("input[name=mesto]").val();
  var misto = 		form.find("input[name=misto]").val();
  var ic = 			form.find("input[name=ico]").val();
  var datum = 		form.find("input[name=datum]").val();

  if (!ID && !ic && !subjekt && !prijmeni) {
	alert(
	  "Zadejte ID datové schránky, Název subjektu, IČ subjektu nebo Příjmení"
	);
	return false;
  }

  var url = BASE_URL + "subjekty/isds?box=" + ID;
  $.getJSON(
	url,
	{
	  ic: ic,
	  subjekt: subjekt,
	  jmeno: jmeno,
	  prijmeni: prijmeni,
	  adresa_mesto: mesto,
	  misto_narozeni: misto,
	  datum_narozeni: datum,
	  page: page,
	  allowValidation: allowValidation
	},

	function (data) {
	  //console.log(data);
	  var resultsPlace = $("table.isdsResultsTable tbody");
	  if (data == null) {
		//$("#vice_vysledku").css("display", "");
		resultsPlace.html(
		  "<tr><td colspan='7'><p class='text-danger'>Nebyly nalezeny žádné výsledky.</p></td></tr>"
		);
	  } else if (data.error && data.error.trim() == "-") {
		//$("#vice_vysledku").css("display", "");
		resultsPlace.html(
		  "<tr><td colspan='7'><strong><u>Vyhledáno dle:</u></strong> " + data.filtr + "</td></tr>" +
		  "<tr><td colspan='7'><p class='text-danger'>Číslo datové schránky nenalezeno.</p></td></tr>"
		);
	  } else if (data.error) {
		//$("#vice_vysledku").css("display", "");
		resultsPlace.html(
		  "<tr><td colspan='7'><strong><u>Vyhledáno dle:</u></strong> " + data.filtr + "</td></tr>" +
		  "<tr><td colspan='7'><p class='text-danger'>" + data.error + "</p></td></tr>"
		);
	  } else if(data.vice_vysledku){
		// rozdeleni pokud nam vyhledavani vraci vice vysledku, nebo jen jeden konkretni
		//$("#vice_vysledku").css("display", "");
		vystup = '';

		vystup =
		  vystup +
		  "<tr><td colspan='7'><strong><u>Vyhledáno dle:</u></strong> " +
		  data.filtr +
		  "</td></tr>";

		pouzito_oddeleni = false;
		var i=0;
		for (const [key, value] of Object.entries(data.vice_vysledku)) {
			i=i+1;
		  //pokud jsme hledali prijmeni a vratili se nam zaznamy, kde je prijmeni uvedeno v nazvu ulice ci mesta,
		  // tak udelame oddeleni (datovky nejdriv vraci vysledky kde hledany reteyec je v prijmeni/jmenu/nazvu a pote kde j v ulici/mestu
		  /*
		  if (
			((prijmeni &&
			  value.dbName.toLowerCase().indexOf(prijmeni.toLowerCase()) ===
				-1) ||
			  (subjekt &&
				value.dbName.toLowerCase().indexOf(subjekt.toLowerCase()) ===
				  -1)) &&
			!pouzito_oddeleni
		  ) {
			pouzito_oddeleni = true;
			vystup =
			  vystup +
			  '<tr><td colspan="7">Následující výsledky mají hledané příjmení či název v adrese</td></tr>';
		  }
		  */
		  /*
		  var dbType = "NA";
		  const result = [];

		  if (value.dbType) {
			if (value.dbType == "Fyzická osoba" || value.dbType.startsWith("FO")) {
			  var dbType = "FO";
			  const splitDbName = value.dbName.split(" ");
			  if (splitDbName.length == 2) {
				result["nazev_subjektu"] = "";
				result["jmeno"] = splitDbName[0];
				result["prijmeni"] = splitDbName[1];
			  }
			} else if (value.dbType == "Podnikající fyzická osoba" || value.dbType.startsWith("PFO")) {
			  var dbType = "PFO";
			  const splitDbName = value.dbName.split(" ");
			  if (splitDbName.length == 2) {
				result["nazev_subjektu"] = value.dbName;
				result["jmeno"] = splitDbName[0];
				result["prijmeni"] = splitDbName[1];
			  } else {
				result["nazev_subjektu"] = value.dbName;
				result["jmeno"] = "";
				result["prijmeni"] = "";
			  }
			} else if (value.dbType == "Orgán veřejné moci") {
			  var dbType = "PO";
			  result["nazev_subjektu"] = value.dbName;
			  result["jmeno"] = "";
			  result["prijmeni"] = "";
			  result["ovm"] = "1";
			} else if (value.dbType == "Právnická osoba" || value.dbType.startsWith("PO")) {
			  var dbType = "PO";
			  result["nazev_subjektu"] = value.dbName;
			  result["jmeno"] = "";
			  result["prijmeni"] = "";
			}
		  }

		  result["type"] = dbType;
		  result["ic"] = value.dbICO ?? null;
		  result["id_isds"] = value.dbID ?? null;

		  const jsonResult = JSON.stringify(Object.assign({}, result));
		  */

		  //řádek do výpisu
		  vystup =
			vystup +
			"<tr class='resultsRow' data-id='" + i + "' data-idds='" + value.dbID + "'>"
			+ "<td class='text-wrap-break-subject'><i class='fas fa-chevron-right'></i><i class='fas fa-chevron-down'></i> " + (value.dbName ?? "") + "</td>"
			+ "<td>" + value.dbID + "</td>"
			+ "<td>" + (value.dbAddress ?? "") + "</td>"
			+ "<td>" + value.dbICO + "</td>"
			+ "<td>" + value.dbType + "</td>"
			+ "<td>" + value.dbBiDate + "</td>"
			+ "<td>" + value.dbSendOptions + "</td>"
			"</tr>";
		  //řádek detailu
		  vystup =
			vystup +
			"<tr class='resultsDetailRow detail" + i + "' style='display: none'><td colspan='7'>"
			+ "<div class='row detailsContent'><div class='col-12'><strong>Detaily subjektu</strong><br>Načítám...</div>";
		  vystup =
			vystup +
			"</div>"
			"</td></tr>";
		}

		vystup =
		  vystup +
		  "<tr><th colspan='2'> Celkem nalezeno " +
		  data.pocet_vysledku +
		  " záznamů " +
		  '</th><th colspan="5" style="max-width: 300px; word-wrap: break-word;" class="paginator">';
		// pokud bylo více stran vysledku
		if (data.vice_stran) {
		  vystup = vystup + "Stránky s výsledky: ";
		  for (ii = 0; ii < data.pocet_stran; ii++) {
			odkaz =
			  "<a onClick=\"return isdsSearch('" +
			  ii + '\');" href="#"';
			if (data.aktualni_strana == ii) {
			  odkaz = odkaz + ' class="current" ';
			}
			odkaz = odkaz + ">" + (ii + 1) + "</a>";
			if (ii + 1 != data.pocet_stran) {
			  odkaz = odkaz + "";
			}
			vystup = vystup + odkaz;
		  }
		}
		vystup = vystup + "</th></tr>";
		resultsPlace.html(vystup);
	  }
	  else{
		  //pouze jeden výsledek
		  var result = [];
		vystup = '';

		vystup =
		  vystup +
		  "<tr><td colspan='7'><strong><u>Vyhledáno dle:</u></strong> " +
		  data.filtr +
		  "</td></tr>";

		  loadSingleDSResult(data, result);

		  const jsonResult = JSON.stringify(Object.assign({}, result));

		  var subektType = "";
		  if(data.dbType=="FO"){
			  subektType = "Fyzická osoba";
			  data.firmName = data.pnFirstName + " " + data.pnLastName;
		  }
		  else if(data.dbType=="PFO"){
			  subektType = "Podnikající fyzická osoba";
		  }
		  else if(data.dbType=="PO"){
			  subektType = "Právnická osoba";
		  }
		  else{
			  subektType = "Neuveden / neznámý";
		  }
		  var subjektAdresa = "";
		  if(data.adStreet){
			  subjektAdresa = subjektAdresa + data.adStreet;
		  }
		  if(data.adNumberInStreet){
			  subjektAdresa = subjektAdresa + " " + data.adNumberInStreet;
		  }

		  if(data.adNumberInMunicipality){
			  subjektAdresa = subjektAdresa + " " + data.adNumberInMunicipality;
		  }

		  if(data.adZipCode){
			  if(subjektAdresa!=""){
				  subjektAdresa = subjektAdresa + ",";
			  }
			  subjektAdresa = subjektAdresa + " " + data.adZipCode;
		  }
		  if(data.adCity){
			  subjektAdresa = subjektAdresa + " " + data.adCity;
		  }

		  var subjektDatumNarozeni = "";
		  if(data.biDate){
			  var formatedDate = new Date(data.biDate);
			  subjektDatumNarozeni = formatedDate.toLocaleDateString('cs-CZ');
		  }

		  var subjektPDZ = "";
		  if(data.postovnidz && data.postovnidz == true){
			 subjektPDZ = "PDZ";
		  }



		  vystup =
			vystup +
			"<tr class='resultsRow' data-id='0' data-idds='" + data.dbID + "'>"
			+ "<td class='text-wrap-break-subject'><i class='fas fa-chevron-right'></i><i class='fas fa-chevron-down'></i> " + data.firmName + "</td>"
			+ "<td>" + data.dbID + "</td>"
			+ "<td>" + subjektAdresa + "</td>"
			+ "<td>" + (data.ic ?? "") + "</td>"
			+ "<td>" + subektType + "</td>"
			+ "<td>" + subjektDatumNarozeni + "</td>"
			+ "<td>" + subjektPDZ + "</td>"
			"</tr>";
		  //řádek detailu
		  vystup =
			vystup +
			"<tr class='resultsDetailRow detail0' style='display: none'><td colspan='7'>"
			+ "<div class='row'><div class='col-12'><strong>Detaily subjektu</strong></div>";
		  $.each(mapovani, function(index, value){
			  newValue = formatDSDetailsOutput(index, data[index]);
			  if(newValue){
				  vystup = vystup + "<div class='col-3 text-right'>" + value + ":</div><div class='col-3'><b>" + 	newValue + "</b></div>";
			  }
		  });
		  var useLink = makeDSgetLink(jsonResult, allowValidation);
		  vystup =
			vystup +
			"<div class='col-12 text-right'>" + useLink + "</div>"
			+ "</div>"
			"</td></tr>";

		resultsPlace.html(vystup);
	  }
	}
  );
	//make rows expadnable
	$(".isdsResultsTable").undelegate("tr.resultsRow", "click");
	$(".isdsResultsTable").delegate("tr.resultsRow", "click", function(e){
		e.preventDefault()
		var rowId =  $(this).data("id");
		window.rowId = rowId;
		var rowIdds =  $(this).data("idds");

		if($(this).hasClass("expanded")){
			//close expanded row
			$(this).removeClass("expanded");
			$(".resultsDetailRow.detail"+rowId).fadeOut();
		}
		else{
			//close others rows
			$(".resultsRow").removeClass("expanded");
			$(".resultsDetailRow").fadeOut();

			//open actual row
			$(this).addClass("expanded");
			$(".resultsDetailRow.detail"+rowId+" .detailsContent").html("<div class='col-12'><strong>Detaily subjektu</strong><br>Načítám...</div>");
			$(".resultsDetailRow.detail"+rowId).fadeIn();
			  //load detail of selected row
			  var url = BASE_URL + "subjekty/isds?box=" + rowIdds;
			  $.getJSON(
				url,
				{
				  page: 1,
				},
				function (data) {
				  //console.log(data);
				  var resultsPlace = $(".resultsDetailRow.detail"+window.rowId+" .detailsContent");
				  if (data == null) {
					//$("#vice_vysledku").css("display", "");
					resultsPlace.html(
					  "<p class='text-danger'>Nebyly nalezeny žádné výsledky.</p>"
					);
				  } else if (data.error && data.error.trim() == "-") {
					//$("#vice_vysledku").css("display", "");
					resultsPlace.html(
					  "<p class='text-danger'>Číslo datové schránky nenalezeno.</p>"
					);
				  } else if (data.error) {
					//$("#vice_vysledku").css("display", "");
					resultsPlace.html(
					  "<p class='text-danger'>" + data.error + "</p>"
					);
				  } else {
					  var result = {};
					  vystup = '';
					  loadSingleDSResult(data, result);
					  const jsonResult = JSON.stringify(Object.assign({}, result));

					  vystup =
						vystup + "<div class='col-12'><strong>Detaily subjektu</strong></div>";
					  $.each(mapovani, function(index, value){
						  newValue = formatDSDetailsOutput(index, data[index]);
						  if(newValue){
							  vystup = vystup + "<div class='col-3 text-right'>" + value + ":</div><div class='col-3'><b>" + 	newValue + "</b></div>";
						  }
					  });
					  var useLink = makeDSgetLink(jsonResult, allowValidation);
					  vystup =
						vystup +
						"<div class='col-12 text-right'>" + useLink + "</div>";

					resultsPlace.html(vystup);
					}
				}
			  );
		}

	});
  return false;
};

function loadSingleDSResult(data, result){

	if (data.dbType) {
		if (data.dbType == "FO") {
			result["jmeno"] = data.pnFirstName;
			result["prijmeni"] = data.pnLastName;
			result["prostredni_jmeno"] = data.pnMiddleName;
			result["rodne_prijmeni"] = data.pnLastNameAtBirth;
			result["datum_narozeni"] = data.biDate;
			result["misto_narozeni"] = data.biCity;
			//result["stat_narozeni"] = data.biCounty;
			//result["prijmeni"] = data.biState;
			result["adresa_mesto"] = data.adCity;
			result["adresa_ulice"] = data.adStreet;
			result["adresa_cp"] = data.adNumberInMunicipality;
			result["adresa_co"] = data.adNumberInStreet;
			result["adresa_psc"] = data.adZipCode;
			//result["adresa_stat"] = data.adState;
		} else if (data.dbType == "PFO") {
			result["nazev_subjektu"] = data.firmName;
			result["jmeno"] = data.pnFirstName;
			result["prijmeni"] = data.pnLastName;
			result["prostredni_jmeno"] = data.pnMiddleName;
			result["rodne_prijmeni"] = data.pnLastNameAtBirth;
			result["datum_narozeni"] = data.biDate;
			result["misto_narozeni"] = data.biCity;
			//result["stat_narozeni"] = data.biCounty;
			//result["prijmeni"] = data.biState;
			result["firma_adresa_mesto"] = data.adCity;
			result["firma_adresa_ulice"] = data.adStreet;
			result["firma_adresa_cp"] = data.adNumberInMunicipality;
			result["firma_adresa_co"] = data.adNumberInStreet;
			result["firma_adresa_psc"] = data.adZipCode;
			//result["firma_adresa_stat"] = data.adState;
			result["ovm"] = data.dbEffectiveOVM;
		} else if (data.dbType == "PO") {
			result["nazev_subjektu"] = data.firmName;
			result["firma_adresa_mesto"] = data.adCity;
			result["firma_adresa_ulice"] = data.adStreet;
			result["firma_adresa_cp"] = data.adNumberInMunicipality;
			result["firma_adresa_co"] = data.adNumberInStreet;
			result["firma_adresa_psc"] = data.adZipCode;
			result["ovm"] = data.dbEffectiveOVM;
			//result["firma_adresa_stat"] = data.adState;
		} else {
			result["nazev_subjektu"] = data.firmName;
			result["jmeno"] = data.pnFirstName;
			result["prijmeni"] = data.pnLastName;
			result["prostredni_jmeno"] = data.pnMiddleName;
			result["rodne_prijmeni"] = data.pnLastNameAtBirth;
			result["datum_narozeni"] = data.biDate;
			result["misto_narozeni"] = data.biCity;
			//result["stat_narozeni"] = data.biCounty;
			//result["prijmeni"] = data.biState;
			result["firma_adresa_mesto"] = data.adCity;
			result["firma_adresa_ulice"] = data.adStreet;
			result["firma_adresa_cp"] = data.adNumberInMunicipality;
			result["firma_adresa_co"] = data.adNumberInStreet;
			result["firma_adresa_psc"] = data.adZipCode;
			//result["firma_adresa_stat"] = data.adState;
			result["ovm"] = data.dbEffectiveOVM;
			data.dbType = "NA";
		}
	}
	else{
		data.dbType = "NA";
		result["nazev_subjektu"] = data.firmName;
		result["jmeno"] = data.pnFirstName;
		result["prijmeni"] = data.pnLastName;
		result["prostredni_jmeno"] = data.pnMiddleName;
		result["rodne_prijmeni"] = data.pnLastNameAtBirth;
		result["datum_narozeni"] = data.biDate;
		result["misto_narozeni"] = data.biCity;
		//result["stat_narozeni"] = data.biCounty;
		//result["prijmeni"] = data.biState;
		result["firma_adresa_mesto"] = data.adCity;
		result["firma_adresa_ulice"] = data.adStreet;
		result["firma_adresa_cp"] = data.adNumberInMunicipality;
		result["firma_adresa_co"] = data.adNumberInStreet;
		result["firma_adresa_psc"] = data.adZipCode;
		//result["firma_adresa_stat"] = data.adState;
		result["ovm"] = data.dbEffectiveOVM;
	}

  result["type"] = data.dbType;
  result["ic"] = data.ic ?? null;
  result["id_isds"] = data.dbID ?? null;
  result["postovnidz"] = data.postovnidz ?? false;
}

function formatDSDetailsOutput(index, value){
	if(value=='*'){
	  return null;
  }
  else if(index=='biDate' && value){
	  var formatedDate = new Date(value);
	  return formatedDate.toLocaleDateString('cs-CZ');
  }
  else if(index=='postovnidz' && value==true){
	  return "PDZ";
  }
  else if(index=='dbEffectiveOVM' && value==true){
	  return "Ano";
  }
  else if(index=='dbType'){
	  if(value=="FO"){
		  return "Fyzická osoba";
	  }
	  else if(value=="PFO"){
		  return "Podnikající fyzická osoba";
	  }
	  else if(value=="PO"){
		  return "Právnická osoba";
	  }
	  else{
		  return "Neuveden / neznámý";
	  }
  }
  else{
	  return value;
  }
}

function makeDSgetLink(jsonResult, allowValidation = false) {
	if ($(".newSubject").length > 0) {
		var link = $(".newSubject").data("remote");
	} else if ($(".newSubjectFromDoc").length > 0) {
		var link = $(".newSubjectFromDoc").data("remote");
	} else if ($(".newSubjectFromSpis").length > 0) {
		var link = $(".newSubjectFromSpis").data("remote");
	} else {
		var link = $("form.ISDSForm").data("link");
	}
	jsonResultObj = JSON.parse(jsonResult);
	jsonResultObj.agenda = "ISDS";
	jsonResultObj.aifo = jsonResultObj.id_isds;
	var datetime = formatCurrentDate();
	jsonResultObj.datum_cas_ztotozneni = datetime;
	jsonResult = JSON.stringify(jsonResultObj);
	jsonResultObj.jineIdentifikace = jsonResultObj.nazev_subjektu;
	jsonResultContact = JSON.stringify(jsonResultObj);
	var jsonResultObjISDS = new Object();
	jsonResultObjISDS.id_isds = jsonResultObj.id_isds;
	var jsonResultISDS = JSON.stringify(jsonResultObjISDS);
	var isUpdate = parseInt($("table.isdsResultsTable").data("update"));
	var isInModal = parseInt($("table.isdsResultsTable").data("inmodal"));
	var onlyBasic = parseInt($("table.isdsResultsTable").data("basic"));
	var isNewSubject = ($(".refreshContacts").length == 0);
	if (isUpdate == 1) {
		//v zalozeni/editaci subjektu ve jmennem rejstriku
		$ret = "<a class='btn btn-sm btn-info updateDataByDSsearch' href='#' onclick='try{updateDataByDSSearch(this, " + allowValidation + ");}finally{closeDialog2();}return false;' data-update='" + jsonResult + "'>Převzít všechny údaje</a>";
		$ret = $ret + " <a class='btn btn-sm btn-info updateDataByDSsearch' href='#' onclick='try{updateDataByDSSearch(this, " + allowValidation + ");}finally{closeDialog2();}return false;' data-update='" + jsonResultISDS + "'>Převzít pouze DS</a>";
		if (isNewSubject) {
			$ret = $ret + " <a class='btn btn-sm btn-info newContactByDSsearch' href='#' onclick='try{newContactByDSSearch(this);}finally{closeDialog2();}return false;' data-update='" + jsonResultContact + "'>Nový kontakt</a>";
		} else {
			$ret = $ret + " <a class='btn btn-sm btn-info addContactByDSsearch' href='#' onclick='try{addContactByDSSearch(this);}finally{closeDialog2();}return false;' data-update='" + jsonResultContact + "'>Nový kontakt</a>";
		}
		return $ret;
	} else if (isInModal == 1) {
		//v zalozeni subjektu v dialogu (z dokumentu/epodatelny)
		jsonResult = jsonResult.replace(/ /g, "%20");
		$ret = "<a class='btn btn-sm btn-info' href='" + link + "?ajax=true&data=" + jsonResult + "' onclick='closeDialog2(this); return false;'>Převzít všechny údaje</a>";
		$ret = $ret + " <a class='btn btn-sm btn-info' href='" + link + "?ajax=true&data=" + jsonResultISDS + "' onclick='closeDialog2(this); return false;'>Převzít pouze DS</a>";
		if (isNewSubject) {
			$ret = $ret + " <a class='btn btn-sm btn-info newContactByDSsearch' href='' onclick='newContactByDSSearch(this);closeDialog2();return false;' data-update='" + jsonResultContact + "'>Nový kontakt</a>";
		}
		return $ret;
	} else {
		//vyhledani z prehledu subjektu
		return "<a class='btn btn-sm btn-outline-danger' href='" + link + "?data=" + jsonResult + "'>Použít tyto údaje</a>"
	}
}

function updateDataByDSSearch(el, allowValidation = false) {
	var data = $(el).data("update");
	if (!data || typeof data !== "object") {
		return;
	}
	var $form = $("#theModal form#subjekt-vytvorit");
	if ($form.length === 0) {
		$form = $("form#subjekt-vytvorit");
	}
	$.each(data, function (index, value) {
		if (typeof index !== "string") {
			return;
		}
		if (index.startsWith("firma_")) {
			if ($form.find("[name='" + index + "']").length == 0) {
				index = index.replace("firma_", "");
			}
		}
		if (value != '*') {
			$form.find("[name='" + index + "']").val(value);
		}
		if (index == 'ovm' || index == 'postovnidz') {
			$form.find("[name='" + index + "']").prop('checked', value);
		}
		if (index == 'id_isds') {
			$form.find("[name='dss[0]']").val(value);
			$form.find("[name='id_isds']").val(value);
		}
	});
	var form = $form.get(0) || document.getElementById("subjekt-vytvorit");
	var typeEl = document.getElementById("frmnovySubjektForm-form-type");
	if (form && window.Nette && typeof Nette.toggleForm === "function") {
		Nette.toggleForm(form, typeEl);
	}
	$form.find(".firstDSRow input").trigger("change");
	$form.find("input[name='aifo']").trigger("change");

	if (allowValidation) {
		var type = $form.find("select[name='type']").val();
		if (type == "PO" || type == "PFO") {
			// searchRuianSidlo();
			searchRuianPobyt();
		} else {
			searchRuianPobyt();
		}
	}
}

function newContactByDSSearch(el){
	var data = $(el).data("update");
	//var data2 = $.parseJSON(data);
	//console.log(data2);
	//prpare data for nwe contact
	master = 0;
	stav = 1;
	contact_type = "6";
	contact_typeText = "Neurčeno";
	kod_adresniho_mista = "";
	jine_identifikace = data.jineIdentifikace??data.jineIdentifikace??"";
	adresa_mesto = data.firma_adresa_mesto??data.adresa_mesto??"";
	adresa_ulice = data.firma_adresa_ulice??data.adresa_ulice??"";
	adresa_cp = data.firma_adresa_cp??data.adresa_cp??"";
	adresa_co = data.firma_adresa_co??data.adresa_co??"";
	adresa_psc = data.firma_adresa_psc??data.adresa_psc??"";
	adresa_jmeno = data.jmeno??"";
	adresa_prijmeni = data.prijmeni??"";
	id_isds = data.id_isds??"";
	postovnidz = data.pdz??"";
	ovm = data.ovm??"";

	//create new contact
	var lastId = $(".contactItem:last").data("id");
	if(typeof lastId == 'undefined'){
		var nextId = 1;
	}
	else{
		var nextId = parseInt(lastId)+1;
	}
	var output = "<tr data-id='" + nextId + "' class='contactItem item" + nextId + "'>";
	output = output + "<td class='contact_typeText'>" + contact_typeText + "</td>";
	output = output + "<td class='jmeno_a_prijmeni'>" + adresa_jmeno + " " + adresa_prijmeni + "</td>";
	output = output + "<td class='kod_adresniho_mista'>" + kod_adresniho_mista + "</td>";
	output = output + "<td class='adresa_psc'>" + adresa_psc + "</td>";
	output = output + "<td class='adresa_mesto'>" + adresa_mesto + "</td>";
	output = output + "<td class='adresa_ulice'>" + adresa_ulice + "</td>";
	output = output + "<td class='jine_identifikace'>" + jine_identifikace + "</td>";
	output = output + "<td>";
	output = output + "<a href='#theModal2' class='btn btn-info btn-sm' data-size='modal-xl' style='margin-top:6px;' data-title='Úprava kontaktu' data-remote='/admin/subjekty/novy-subjekt-kontakt/?ajax=true&contact="+nextId+"' data-bs-toggle='modal' data-bs-target='#theModal2' title='upravit'><i class='fa-solid fa-pencil'></i></a>";
	output = output + " <a href='#' onclick='removeContactRow(this);return false;' class='removeContactRow btn btn-sm btn-danger' style='margin-top:6px;' title='smazat'><i class='fa-solid fa-trash'></i></a>";
	output = output + "<input type='hidden' class='stav' name='stavContacts[]' value='" + stav + "' />";
	output = output + "<input type='hidden' class='master' name='masterContacts[]' value='" + master + "' />";
	output = output + "<input type='hidden' class='contact_type' name='contact_typeContacts[]' value='" + contact_type + "' />";
	output = output + "<input type='hidden' class='adresa_ulice' name='adresa_uliceContacts[]' value='" + adresa_ulice + "' />";
	output = output + "<input type='hidden' class='adresa_cp' name='adresa_cpContacts[]' value='" + adresa_cp + "' />";
	output = output + "<input type='hidden' class='adresa_co' name='adresa_coContacts[]' value='" + adresa_co + "' />";
	output = output + "<input type='hidden' class='adresa_mesto' name='adresa_mestoContacts[]' value='" + adresa_mesto + "' />";
	output = output + "<input type='hidden' class='adresa_psc' name='adresa_pscContacts[]' value='" + adresa_psc + "' />";
	output = output + "<input type='hidden' class='adresa_jmeno' name='adresa_jmenoContacts[]' value='" + adresa_jmeno + "' />";
	output = output + "<input type='hidden' class='adresa_prijmeni' name='adresa_prijmeniContacts[]' value='" + adresa_prijmeni + "' />";
	output = output + "<input type='hidden' class='id_isds' name='id_isdsContacts[]' value='" + id_isds + "' />";
	output = output + "<input type='hidden' class='postovnidz' name='postovnidzContacts[]' value='" + postovnidz + "' />";
	output = output + "</td>";
	output = output + "</tr>";
	$("table.contactsTable tbody").append(output);
}

function addContactByDSSearch(el){
	var data = $(el).data("update");
	var subjectId = $("#subjekt-vytvorit input[name='id']").val();
	$.nette.ajax({
		type: 'GET',
		url: "/admin/subjekty/novy-kontakt-z-dat/"+subjectId,
		data: data,
		complete: function(data){
			$(".refreshContacts").trigger("click");
		}
	});

}

setSubjektFormValuesByISDS = function (el) {
  const values = $(el).data("values");
  $.each(values, function (key, value) {
	if(key=='#frmnovySubjektForm-form-type' && value!='FO' && value!='PO' && value!='PFO'){
	  $(key).val('NA');
	}
	else{
		$(key).val(value).trigger("change");
	}
	if(key=='#frmnovySubjektForm-form-id_isds'){
	  $("#frmnovySubjektForm-form-dss-0").val(value).trigger("change");
	}
	var form = document.getElementById("subjekt-vytvorit");
	var el = document.getElementById("frmnovySubjektForm-form-type");
	Nette.toggleForm(form, el);
  });
};

function searchZRbyICO(){
  var inputEl = $("input[name=ic]");
  var IC = inputEl.val();
  if (!IC) {
	alert("Vyplňte IČ subjektu.");
	inputEl.focus();
	return false;
  }
  if(parseInt(IC) != IC){
	alert("IČ subjektu může obsahovat pouze číslice.");
	inputEl.focus();
	return false;
  }

  var url = BASE_URL + "subjekty/search-zr-by-ic?ic=" + IC;

  $.getJSON(url, function (data) {
	if (data.error) {
		alert(data.error);
	} else {
		$.each(data, function(index, value){
			if(index == 'id_isds'){
				$(".firstDSRow input").val(value).trigger("change");
			}
			else if(index == 'ovm'){
				$("input[name='"+index+"']").prop("checked", value);
			}
			else{
				if($("select[name='type']").hasClass("withContact")){
					index = index.replace("firma_", "");
				}
				$("input[name='"+index+"'],select[name='"+index+"']").val(value).trigger("change");
			}
		});
		if(data.aifo){
			$("input[name='agenda']").val("ROS");
			var datetime = formatCurrentDate();
			$("input[name='datum_cas_ztotozneni']").val(datetime);
			$("input[name='aifo']").trigger("change");

			// Předání dat o ztotožnění pro nový kontakt subjektu
			$("input[name='ztotozneniData']").val(JSON.stringify(data)).trigger('input');
		}
		var form = document.getElementById("subjekt-vytvorit");
		var el = document.getElementById("frmnovySubjektForm-form-type");
		Nette.toggleForm(form, el);
		if($("input[name=firma_adresa_ulice]").is(":visible")){
			searchRuianSidlo();
		}
		else{
			searchRuianPobyt();
		}
	}
  });
  return false;
};

function searchZRbyDS(){
  var inputEl = $(".firstDSRow input");
  var DS = inputEl.val();
  if (!DS) {
	alert("Vyplňte ID datové schránky.");
	inputEl.focus();
	return false;
  }
  var url = BASE_URL + "subjekty/search-zr-by-ds?ds=" + DS;

  $.getJSON(url, function (data) {
	if (data.error) {
		alert(data.error);
	} else {
		$.each(data, function(index, value){
			if(index == 'id_isds'){
				$(".firstDSRow input").val(value).trigger("change");
			}
			else{
				if($("select[name='type']").hasClass("withContact")){
					index = index.replace("firma_", "");
				}
				$("input[name='"+index+"'],select[name='"+index+"']").val(value).trigger("change");
			}
		});
		if(data.aifo){
			//$("input[name='agenda']").val("ROS");
			var datetime = formatCurrentDate();
			$("input[name='datum_cas_ztotozneni']").val(datetime);
			$("input[name='aifo']").trigger("change");
		}
		var form = document.getElementById("subjekt-vytvorit");
		var el = document.getElementById("frmnovySubjektForm-form-type");
		Nette.toggleForm(form, el);
		if($("input[name=firma_adresa_ulice]").is(":visible")){
			searchRuianSidlo();
		}
		else{
			searchRuianPobyt();
		}
	}
  });
  return false;
};

$(document).ready(function(){
	var searchDelay = 300;
	var ruianTimer1;
	var ruianTimer2;
	/*
	$("input[name=adresa_mesto],input[name=adresa_ulice],input[name=adresa_cp],input[name=adresa_co],input[name=adresa_psc]").on("keyup", function(){
		var stat = $("select[name=adresa_stat]").val();
		if(stat == 'CZE'){
			clearTimeout(ruianTimer1);
			ruianTimer1 = setTimeout(function(){
				searchRuianPobyt();
			}, searchDelay);
		}
	});
	$("input[name=firma_adresa_mesto],input[name=firma_adresa_ulice],input[name=firma_adresa_cp],input[name=firma_adresa_co],input[name=firma_adresa_psc]").on("keyup", function(){
		var stat = $("select[name=firma_adresa_stat]").val();
		if(stat == 'CZE'){
			clearTimeout(ruianTimer2);
			ruianTimer2 = setTimeout(function(){
				searchRuianSidlo();
			}, searchDelay);
		}
	});
	*/
});

function searchRuianPobyt(){
  var mesto = $("input[name=adresa_mesto]").val();
  var ulice = $("input[name=adresa_ulice]").val();
  var cp = $("input[name=adresa_cp]").val();
  var co = $("input[name=adresa_co]").val();
  var psc = $("input[name=adresa_psc]").val().replace(" ", "");
  var resultBox = $(".ruianResults");

	var url = BASE_URL + "subjekty/search-ruian?obec=" + mesto + "&ulice=" + ulice + "&psc=" + psc + "&cp=" + cp + "&co=" + co;

  $.getJSON(url, function (data) {
	if (data.error) {
		resultBox.html("<span class='alert alert-danger'>" + data.error + "</span>");
		$("input[name=kod_adresniho_mista]").val("");
	} else {
		var adresy = data.adresy;
		let count = Object.keys(adresy).length;
		if(count === 0){
			resultBox.html("<span class='alert alert-danger'>Adresa nebla nalezena</span>");
			$("input[name=kod_adresniho_mista]").val("");
		}
		else if(count > 1){
			resultBox.html("<span class='alert alert-danger'>Upřesněte adresu</span>");
			$("input[name=kod_adresniho_mista]").val("");
		}
		else{
			$("input[name=kod_adresniho_mista]").val(adresy[0].adresniMistoKod);
			$("input[name=adresa_mesto]").val(adresy[0].obecNazev);
			$("input[name=adresa_ulice]").val(adresy[0].uliceNazev);
			$("input[name=adresa_co]").val(adresy[0].cisloOrientacni);
			$("input[name=adresa_cp]").val(adresy[0].cisloDomovni);
			$("input[name=adresa_psc]").val(adresy[0].postaKod);
			resultBox.html("<span class='alert alert-success'>Adresa nalezena</span>");
		}
	}
  });
  return false;
};

function searchRuianSidlo(){
  var mesto = $("input[name=firma_adresa_mesto]").val();
  var ulice = $("input[name=firma_adresa_ulice]").val();
  var cp = $("input[name=firma_adresa_cp]").val();
  var co = $("input[name=firma_adresa_co]").val();
  var psc = $("input[name=firma_adresa_psc]").val().replace(" ", "");
  var resultBox = $(".ruianResultsCompany");

	var url = BASE_URL + "subjekty/search-ruian?obec=" + mesto + "&ulice=" + ulice + "&psc=" + psc + "&cp=" + cp + "&co=" + co;

  $.getJSON(url, function (data) {
	if (data.error) {
		resultBox.html("<span class='alert alert-danger'>" + data.error + "</span>");
		$("input[name=kod_adresniho_mista]").val("");
	} else {
		var adresy = data.adresy;
		let count = Object.keys(adresy).length;
		if(count === 0){
			resultBox.html("<span class='alert alert-danger'>Adresa nebla nalezena</span>");
			$("input[name=kod_adresniho_mista]").val("");
		}
		else if(count > 1){
			resultBox.html("<span class='alert alert-danger'>Upřesněte adresu</span>");
			$("input[name=kod_adresniho_mista]").val("");
		}
		else{
			$("input[name=firma_kod_adresniho_mista]").val(adresy[0].adresniMistoKod);
			$("input[name=firma_adresa_mesto]").val(adresy[0].obecNazev);
			$("input[name=firma_adresa_ulice]").val(adresy[0].uliceNazev);
			$("input[name=firma_adresa_co]").val(adresy[0].cisloOrientacni);
			$("input[name=firma_adresa_cp]").val(adresy[0].cisloDomovni);
			$("input[name=firma_adresa_psc]").val(adresy[0].postaKod);
			resultBox.html("<span class='alert alert-success'>Adresa nalezena</span>");
		}
	}
  });
  return false;
};

/*--- Search ZR for PO ---*/
function searchPOinZR(){
  var subjectName = $("input[name='nazev_subjektu']");
  var subjectForm = $("select[name='pravni_forma']");
  if (!subjectName.val() || !subjectForm.val()) {
	alert("Vyplňte název nebo označení subjektu a právní formu.");
	if(!subjectName.val()){
		subjectName.focus();
	}
	else if(!subjectForm.val()){
		subjectForm.focus();
	}
	return false;
  }

  var url = BASE_URL + "subjekty/search-ros-zr"
	+ "?name=" + subjectName.val()
	+ "&form=" + subjectForm.val()
  ;
  if($("input[name=ic]").val() != ''){
	  url = url + "&ic=" + $("input[name=ic]").val();
  }
  if($(".firstDSRow input").val() != ''){
	  url = url + "&ds=" + $(".firstDSRow input").val();
  }
  if($(".mailRow:first input").val() != ''){
	  //TBF url = url + "&email=" + $(".mailRow:first input").val();
  }
  if($("input[name='firma_kod_adresniho_mista']").val() != ''){
	  url = url + "&place=" + $("input[name='firma_kod_adresniho_mista']").val();
  }

  $.getJSON(url, function (data) {
	if (data.error) {
		alert(data.error);
	} else {
		$.each(data, function(index, value){
			if(index == 'id_isds'){
				$(".firstDSRow input").val(value).trigger("change");
			}
			else if(index == 'ovm'){
				$("input[name='"+index+"']").prop("checked", value);
			}
			else{
				if($("select[name='type']").hasClass("withContact")){
					index = index.replace("firma_", "");
				}
				$("input[name='"+index+"'],select[name='"+index+"']").val(value).trigger("change");
			}
		});
		if(data.aifo){
			$("input[name='agenda']").val("ROS");
			var datetime = formatCurrentDate();
			$("input[name='datum_cas_ztotozneni']").val(datetime);
			$("input[name='aifo']").trigger("change");

			// Předání dat o ztotožnění pro nový kontakt subjektu
			$("input[name='ztotozneniData']").val(JSON.stringify(data)).trigger('input');
		}
		var form = document.getElementById("subjekt-vytvorit");
		var el = document.getElementById("frmnovySubjektForm-form-type");
		Nette.toggleForm(form, el);
		if($("input[name=firma_adresa_ulice]").is(":visible")){
			searchRuianSidlo();
		}
		else{
			searchRuianPobyt();
		}
	}
  });
  return false;
};

/*--- Search ZR for PFO ---*/
function searchPFOinZR(){
  var personName = $("input[name='jmeno']");
  var personSurname = $("input[name='prijmeni']");
  var birthdate = $("input[name='datum_narozeni']");
  var subjectAddress = $("input[name='firma_kod_adresniho_mista']");
  if($("select[name='type']").hasClass("withContact")){
	  var subjectAddress = $("input[name='kod_adresniho_mista']");
  }
  var subjectForm = $("select[name='pravni_forma']");
  if (!personName.val() || !personSurname.val() || !birthdate.val() || !subjectAddress.val() || !subjectForm.val()) {
	alert("Vyplňte jméno, příjmení, datum narození, kód adresy sídla a právní formu.");
	if(!personName.val()){
		personName.focus();
	}
	else if(!personSurname.val()){
		personSurname.focus();
	}
	else if(!birthdate.val()){
		birthdate.focus();
	}
	else if(!subjectAddress.val()){
		subjectAddress.focus();
	}
	else if(!subjectForm.val()){
		subjectForm.focus();
	}
	return false;
  }

  var url = BASE_URL + "subjekty/search-ros-rob-zr"
	+ "?firstname=" + personName.val()
	+ "&surname=" + personSurname.val()
	+ "&birthdate=" + birthdate.val()
	+ "&place=" + subjectAddress.val()
	+ "&form=" + subjectForm.val()
  ;
  if($("input[name='nazev_subjektu']").val() != ''){
	  url = url + "&name=" + $("input[name='nazev_subjektu']").val();
  }
  if($("input[name=ic]").val() != ''){
	  url = url + "&ic=" + $("input[name=ic]").val();
  }
  if($(".firstDSRow input").val() != ''){
	  url = url + "&ds=" + $(".firstDSRow input").val();
  }
  if($("input[name='rodne_prijmeni']").val() != ''){
	  url = url + "&birthname=" + $("input[name='rodne_prijmeni']").val();
  }
  if($("select[name='pohlavi']").val() != ''){
	  //TBF url = url + "&sex=" + $("select[name='pohlavi']").val();
  }
  if($("input[name='cislo_op']").val() != ''){
	  //TBF url = url + "&license=" + $("input[name='cislo_op']").val();
  }
  if($(".mailRow:first input").val() != ''){
	  //TBF url = url + "&email=" + $(".mailRow:first input").val();
  }

  $.getJSON(url, function (data) {
	if (data.error) {
		alert(data.error);
	} else {
		$.each(data, function(index, value){
			if(index == 'id_isds'){
				$(".firstDSRow input").val(value).trigger("change");
			}
			else if(index == 'ovm'){
				$("input[name='"+index+"']").prop("checked", value);
			}
			else{
				if($("select[name='type']").hasClass("withContact")){
					index = index.replace("firma_", "");
				}
				$("input[name='"+index+"'],select[name='"+index+"']").val(value).trigger("change");
			}
		});
		if(data.aifo){
			$("input[name='agenda']").val("ROS");
			var datetime = formatCurrentDate();
			$("input[name='datum_cas_ztotozneni']").val(datetime);
			$("input[name='aifo']").trigger("change");

			// Předání dat o ztotožnění pro nový kontakt subjektu
			$("input[name='ztotozneniData']").val(JSON.stringify(data)).trigger('input');
		}
		var form = document.getElementById("subjekt-vytvorit");
		var el = document.getElementById("frmnovySubjektForm-form-type");
		Nette.toggleForm(form, el);
		if($("input[name=firma_adresa_ulice]").is(":visible")){
			searchRuianSidlo();
		}
		else{
			searchRuianPobyt();
		}
	}
  });
  return false;
};

/*--- Search ZR for FO ---*/
function searchFOinZR(){
  var personName = $("input[name='jmeno']");
  var personSurname = $("input[name='prijmeni']");
  var birthdate = $("input[name='datum_narozeni']");
  var subjectAddress = $("input[name='kod_adresniho_mista']");
  if (!personName.val() || !personSurname.val() || !birthdate.val() || !subjectAddress.val()) {
	alert("Vyplňte jméno, příjmení, datum narození a kód adresy trvalého bydliště.");
	if(!personName.val()){
		personName.focus();
	}
	else if(!personSurname.val()){
		personSurname.focus();
	}
	else if(!birthdate.val()){
		birthdate.focus();
	}
	else if(!subjectAddress.val()){
		subjectAddress.focus();
	}
	return false;
  }

  var url = BASE_URL + "subjekty/search-rob-zr"
	+ "?firstname=" + personName.val()
	+ "&surname=" + personSurname.val()
	+ "&birthdate=" + birthdate.val()
	+ "&place=" + subjectAddress.val()
  ;
  if($(".firstDSRow input").val() != ''){
	  url = url + "&ds=" + $(".firstDSRow input").val();
  }
  if($("input[name='rodne_prijmeni']").val() != ''){
	  url = url + "&birthname=" + $("input[name='rodne_prijmeni']").val();
  }
  if($("select[name='pohlavi']").val() != ''){
	  //TBF url = url + "&sex=" + $("select[name='pohlavi']").val();
  }
  if($("input[name='cislo_op']").val() != ''){
	  //TBF url = url + "&license=" + $("input[name='cislo_op']").val();
  }
  if($(".mailRow:first input").val() != ''){
	  //TBF url = url + "&email=" + $(".mailRow:first input").val();
  }

  $.getJSON(url, function (data) {
	if (data.error) {
		alert(data.error);
	} else {
		$.each(data, function(index, value){
			if(index == 'id_isds'){
				$(".firstDSRow input").val(value).trigger("change");
			}
			else{
				if($("select[name='type']").hasClass("withContact")){
					index = index.replace("firma_", "");
				}
				$("input[name='"+index+"'],select[name='"+index+"']").val(value).trigger("change");
			}
		});
		if(data.aifo){
			$("input[name='agenda']").val("ROB");
			var datetime = formatCurrentDate();
			$("input[name='datum_cas_ztotozneni']").val(datetime);
			$("input[name='aifo']").trigger("change");

			// Předání dat o ztotožnění pro nový kontakt subjektu
			$("input[name='ztotozneniData']").val(JSON.stringify(data)).trigger('input');
		}
		var form = document.getElementById("subjekt-vytvorit");
		var el = document.getElementById("frmnovySubjektForm-form-type");
		Nette.toggleForm(form, el);
		if($("input[name=firma_adresa_ulice]").is(":visible")){
			searchRuianSidlo();
		}
		else{
			searchRuianPobyt();
		}
	}
  });
  return false;
};

function formatCurrentDate() {
  var currentdate = new Date;
  return currentdate.getFullYear() + "-" + String(currentdate.getMonth() + 1).padStart(2, '0') + "-" + String(currentdate.getDate()).padStart(2, '0') + " " + String(currentdate.getHours()).padStart(2, '0') + ":" + String(currentdate.getMinutes()).padStart(2, '0') + ":" + String(currentdate.getSeconds()).padStart(2, '0');
}

toggleWindow = function (elm) {
  //parent = $(elm).parent();

  //alert(parent.prop('tagName'));

  return false;
};

spisZobrazit = function (spis_id) {
  window.location.href = BASE_URL + "spisy/" + spis_id + "/";
};
spisZobrazitSpisovna = function (spis_id) {
  window.location.href = BASE_URL + "spisovna/spisy/" + spis_id + "/";
};
spisZobrazitAdministrace = function (spis_id) {
  window.location.href = BASE_URL + "admin/spisy/detail/" + spis_id + "/";
};

spisVlozitDokument = function (spis_id) {
  const spisLink = BASE_URL + "spisy/" + spis_id + "/";
  const href = spisLink + "vlozit-dokument?dok_id=" + DOKUMENT_ID;

  $.get(href, function (data) {
	if (data.spis) {
	  $("#dokument_skartacni_znak").html(data.spis.skartacni_znak);
	  $("#dokument_skartacni_lhuta").html(data.spis.skartacni_lhuta);
	  $("#dokument_skartacni_znak").show();
	  $("#dokument_skartacni_lhuta").show();
	}

	if (data.msg) {
	  alert(data.msg);
	} else {
	  location.reload();
	}
  });

  return false;
};

spisVlozitDokumenty = function (spis_id) {
  if (typeof DOCUMENT_IDS === "undefined") {
	return false;
  }
  const spisLink = BASE_URL + "spisy/" + spis_id + "/";
  const href = spisLink + "vlozit-dokument?documentIds=" + DOCUMENT_IDS;
  // volame neajaxove kvuli zobrazeni flash zpravy
  window.location.href = href;
  return false;
};

spisVyjmoutDokument = function () {
  if (confirm("Opravdu chcete vyjmout tento dokument ze spisu?")) {
	let url = BASE_URL + "spisy/vyjmout-dokument?dok_id=" + DOKUMENT_ID;

	$.getJSON(url, function (data) {
		if (data.ok) {
		  location.reload();
		} else {
		  alert(data.error);
		}
	});
  }
  return false;
};

stornoOdeslaniDokumentuPostou = function (id) {
  event.preventDefault();
  if (confirm("Opravdu chcete stornovat odeslání dokumentu?")) {
	let url =
	  BASE_URL + "dokumenty/storno-odeslani-dokumentu?typ=posta&odes_id=" + id;
	$.getJSON(url, function (data) {});
  }
  return false;
};

zjistiVahu = function (name) {
  let url = BASE_URL + "dokumenty/get-weight";
  $.ajax({
	url: url,
	type: "post",
	success: function (response) {
	  if (response["weight"] === false) {
		alert("Nepodařilo se načíst váhu");
	  } else {
		console.log(response["weight"]);
		document.getElementById(name).value = response["weight"];
	  }
	},
  });
};

addUserLink = function () {
  $("#add-user-box").toggle();
  return false;
};

showLinkBox = function () {
  $("#link-box").show();
  return false;
}


closeLinkBox = function () {
  $("#link-box").hide();
  $('#frm-odkazySearch-form input[name="spis"]').val('');
  $('#frm-odkazySearch-form input[name="dokument"]').val('');
  return false;
}


showLetterNumberBox = function (id) {
  $("#letter-number" + id).toggle();
  return false;
};

showDatumVraceniBox = function (id) {
  $("#datum-vraceni" + id).toggle();
  return false;
};

showInformaceOzasilceBox = function (id) {
  $("#info-vraceni" + id).toggle();
  return false;
};

showNoteOpen = function () {
  $("#spisNote").toggle();
  return false;
};

subjektVybran = function (elm) {
  var url = elm.href + "&dok_id=" + DOKUMENT_ID;

  $.get(url, function (data) {
	if (data.indexOf("###vybrano###") !== -1) {
	  closeDialog();
	  renderSubjekty('document');
	} else {
	  alert(data);
	}
  });

  return false;
};

subjektVybranProSpis = function (elm) {
  const url = elm.href + "?spis_id=" + SPIS_ID;
  console.log(url);
  $.get(url, function (data) {
	if (data.indexOf("###vybrano###") !== -1) {
	  closeDialog();
	  renderSubjekty('spis');
	} else {
	  alert(data);
	}
  });

  return false;
};

aktualizujSubjekt = function (elm) {
  const url = elm.href;

  $.get(url, function (data) {
	if (data.indexOf("###zmeneno###") !== -1) {
	  closeDialog();
	  renderSubjekty('document');
	} else {
	  alert(data);
	}
  });

  return false;
};

ulozRobRosSubjekt = function (id, dokId) {
  url = BASE_URL + "subjekty/uloz-rob-ros-subjekt?subjektid=" + id + "&dok_id=" + dokId;
  $.get(url, function (data) {
	if (data.status == "success") {
	  if (window.location.href.includes('evidence')) {
		closeDialog();
		const elements = document.querySelectorAll('.contacts' + id);
		elements.forEach(element => {
		  const originalId = element.id;
		  if (originalId && originalId.includes('subjekt-')) {
			const newId = originalId.replace('subjekt-', '');
			const checkboxSubjekt = document.querySelector(`input[name="subjekt[${newId}]"]`);
			const checkboxSubjektDotceny = document.querySelector(`input[name="subjektDotceny[${newId}]"]`);
			let isSubjektChecked = checkboxSubjekt ? checkboxSubjekt.checked : false;
			let isSubjektDotcenyChecked = checkboxSubjektDotceny ? checkboxSubjektDotceny.checked : false;
			renderEpodSubjekty(newId, false);
			setTimeout(() => {
			  const newCheckboxSubjekt = document.querySelector(`input[name="subjekt[${newId}]"]`);
			  const newCheckboxSubjektDotceny = document.querySelector(`input[name="subjektDotceny[${newId}]"]`);
			  if (newCheckboxSubjekt) {
				  newCheckboxSubjekt.checked = isSubjektChecked;
			  }

			  if (newCheckboxSubjektDotceny) {
				  newCheckboxSubjektDotceny.checked = isSubjektDotcenyChecked;
			  }
			}, 3000);
		  };
		});
	  } else if (window.location.href.includes('dokumenty')) {
		closeDialog();
		renderSubjekty('document');
	  } else {
		location.reload();
	  }
	} else {
	  alert(data.error);
	}
  });
}

renderComponentNameCheck = function () {
  url = BASE_URL + "prilohy/" + DOKUMENT_ID + "/check-name";
  $.get(url, function (data) {
	console.log(data);
  });
  return false;
};

// Objekt pro uložení stavu checkboxů
var checkedAttachments = {};

renderPrilohy = function (silent) {
  // Získání aktuální URL
	var currentUrl = window.location.href;
	var uzivatelskeTab = document.getElementById('uzivatelske-tab');

	// Vytvoření XMLHttpRequest objektu
	var xhr = new XMLHttpRequest();
	xhr.open('GET', currentUrl, true);

	xhr.onreadystatechange = function() {
	  if (xhr.readyState === 4 && xhr.status === 200) {
		// Načtená data
		var data = xhr.responseText;

		// Vytvoření dočasného elementu pro parsování HTML
		var tempDiv = document.createElement('div');
		tempDiv.innerHTML = data;

		// Najití požadovaného obsahu
		var newContent = tempDiv.querySelector('#dok-prilohy');
		var newContentTab = tempDiv.querySelector('#prilohy-tab');
		var newActionButtons = tempDiv.querySelector('#action-buttons');

		// Kontrola, zda byl nalezen obsah
		if (newContent) {
		  // Uložení aktuálního stavu checkboxů
		  var dokPrilohy = document.getElementById('dok-prilohy');
		  var prilohyTab = document.getElementById('prilohy-tab');
		  var actionButtons = document.getElementById('action-buttons');
		  var checkboxes = dokPrilohy.querySelectorAll('input[name^="prilohy["]');
		  checkboxes.forEach(function(checkbox) {
			var idMatch = checkbox.name.match(/\[(\d+)\]/); // Extrakce ID
			if (idMatch) {
			  var id = idMatch[1];
			  checkedAttachments[id] = checkbox.checked; // Uložení stavu
			}
		  });

		  // Nahrazení obsahu
		  dokPrilohy.innerHTML = newContent.innerHTML;
		  if (newContentTab && prilohyTab) {
			prilohyTab.innerHTML = newContentTab.innerHTML;
		  }

		  if (newActionButtons) {
			actionButtons.innerHTML = newActionButtons.innerHTML;
		  }

		  // Obnovení stavu checkboxů
		  checkboxes = dokPrilohy.querySelectorAll('input[name^="prilohy["]');
		  checkboxes.forEach(function(checkbox) {
			var idMatch = checkbox.name.match(/\[(\d+)\]/);
			if (idMatch) {
			  var id = idMatch[1];
			  if (checkedAttachments[id] !== undefined) {
				  checkbox.checked = checkedAttachments[id]; // Nastavení stavu checkboxu
			  }
			}
		  });

		  if (uzivatelskeTab && !uzivatelskeTab.classList.contains('active')) {
			var newUzivatelskeTab = document.getElementById('uzivatelske-tab');
			var newUzivatelske = document.getElementById('uzivatelske');
			var newSystemoveTab = document.getElementById('systemove-tab');
			var newSystemove = document.getElementById('systemove');
			newUzivatelskeTab.classList.remove('active');
			newUzivatelske.classList.remove('active', 'show')
			newUzivatelskeTab.setAttribute('aria-selected', false);
			newSystemoveTab.classList.add('active');
			newSystemove.classList.add('active', 'show');
			newSystemoveTab.setAttribute('aria-selected', true);

			var dokumentTab = document.getElementById('dokument-tab');
			var prilohaTab = document.getElementById('prilohy-tab');
			var subjektyTab = document.getElementById('subjekty-tab');
			var dokumentContent = document.getElementById('dokument');
			var prilohaContent = document.getElementById('prilohy');
			var subjektyContent = document.getElementById('subjekty');
			if (prilohaTab && !prilohaTab.classList.contains('active')) {
			  dokumentTab.classList.remove('active');
			  prilohaTab.classList.add('active');
			  subjektyTab.classList.remove('active');
			  dokumentContent.classList.remove('active', 'show');
			  prilohaContent.classList.add('active', 'show');
			  subjektyContent.classList.remove('active', 'show');
			}
		  }

		  if (typeof initializeDragAndDrop === 'function') {
			initializeDragAndDrop();
		  }
		  if ($('#prilohy-tab').length) {
			var tabLink = $('#prilohy-tab');
			var url = tabLink.data('url');
			loadTabContent(url, tabLink, silent);
		  } else if (typeof maybePollPdfMerge === 'function') {
			maybePollPdfMerge();
		  }
		}
	  } else if (xhr.readyState === 4) {
		console.error('Chyba při načítání dat:', xhr.statusText);
	  }
	};

	// Odeslání požadavku
	xhr.send();
};

loadTabContent = function(url, tabLink, silent) {
  $.ajax({
	url: url,
	type: 'GET',
	global: silent !== true,
	success: function(data) {
	  if (data.htmlContent) {
		$(data.targetId).html(data.htmlContent);
		// Označení záložky jako načtené
		tabLink.addClass('content-loaded');
	  }
	  $.nette.load();
	  if (typeof updateSloucitPrilohyButton === 'function') {
		updateSloucitPrilohyButton();
	  }
	  if (typeof maybePollPdfMerge === 'function') {
		maybePollPdfMerge();
	  }
	},
	error: function(jqXHR, textStatus, errorThrown) {
	  $(data.targetId).html('<div class="alert alert-danger">Chyba při načítání obsahu: ' + errorThrown + '</div>');
	  // Odstranit označení načteno, aby se to mohlo zkusit znovu
	  tabLink.removeClass('content-loaded');
	}
  });
};

renderSubjekty = function (entityType) {
	var currentUrl = window.location.href;

	$.get(currentUrl, function (data) {
		// Vytvoření dočasného elementu pro parsování HTML
		var tempDiv = document.createElement('div');
		tempDiv.innerHTML = data;

		// Najití požadovaného obsahu
		var tabContent = tempDiv.querySelector('#subjekty-tab');
		if (tabContent) {
			var subjektyTab = document.getElementById('subjekty-tab');
			// Nahrazení obsahu
			if (subjektyTab) {
				subjektyTab.innerHTML = tabContent.innerHTML;
			}
		}

		var docSubjectsContent = tempDiv.querySelector('#dok-subjekty');
		if (docSubjectsContent) {
			var docSubjects = document.getElementById('dok-subjekty');
			if (docSubjects) {
				docSubjects.innerHTML = docSubjectsContent.innerHTML;
			}
		}

		if (data.snippets && 'snippet--dokSubjekty' in data.snippets) {
			var dokSubjektySnippet = document.getElementById('snippet--dokSubjekty');
			if (dokSubjektySnippet) {
				dokSubjektySnippet.innerHTML = data.snippets['snippet--dokSubjekty'];
			}
		}

		// var spisSubjectsContent = tempDiv.querySelector('#spis-subjekty')
		// if (spisSubjectsContent) {
		// 	var spisSubjects = document.getElementById('spis-subjekty');
		// 	spisSubjects.innerHTML = spisSubjectsContent.innerHTML;
		// }

		if (data.snippets && 'snippet--subjektySeznam' in data.snippets) {
			var spisSubjectsSnippet = document.getElementById('snippet--subjektySeznam');
			if (spisSubjectsSnippet) {
				spisSubjectsSnippet.innerHTML = data.snippets['snippet--subjektySeznam'];
			}
		}

		if (data.snippets && 'snippet--detailSpis' in data.snippets) {
			var detailSpisSnippet = document.getElementById('snippet--detailSpis');
			if (detailSpisSnippet) {
				detailSpisSnippet.innerHTML = data.snippets['snippet--detailSpis'];
			}
		}

		if (data.snippets && 'snippet--sub-count' in data.snippets) {
			var tabsSnippet = document.getElementById('snippet--sub-count');
			if (tabsSnippet) {
				tabsSnippet.innerHTML = data.snippets['snippet--sub-count'];
			}
		}

		if (data.snippets && 'snippet--subjekty-a-vypraveni' in data.snippets) {
			var subjektyAVypraveniSnippet = document.getElementById('snippet--subjekty-a-vypraveni');
			if (subjektyAVypraveniSnippet) {
				subjektyAVypraveniSnippet.innerHTML = data.snippets['snippet--subjekty-a-vypraveni'];
			}
		}

		var vlozitDoSpisuContent = tempDiv.querySelector('#vlozit-do-spisu');
		if (vlozitDoSpisuContent) {
			var vlozitDoSpisu = document.getElementById('vlozit-do-spisu');
			if (vlozitDoSpisu) {
				vlozitDoSpisu.innerHTML = vlozitDoSpisuContent.innerHTML;
			}
		}
	});

	$.nette.load();

	return false;
};

renderKontakty = function (documentType) {
  if (typeof ADRESNI_SKUPINA_ID === "undefined") {
	return false;
  }

  // url = BASE_URL + 'subjekty/' + DOKUMENT_ID + '/nacti';
  if (documentType === "AdresniSkupinaDetail") {
	url =
	  BASE_URL +
	  "admin/adresni-skupiny/detail-ajax-nacti/?idSkupina=" +
	  ADRESNI_SKUPINA_ID +
	  "";
  } else {
	return false;
  }

  $.get(url, function (data) {
	var hasText = data.indexOf("seznam") !== -1;
	if (!hasText) {
	  $("#validateAdresat").html(
		"Není vyplněný adresát / odesílatel. Chcete pokračovat?"
	  );
	}
	$("#dok-subjekty").html(data);
  });

  var subjektElement = $("#subjekt_pripojit");

  if (subjektElement.is(":visible")) {
	subjektElement.toggle();
  }

  return false;
};

renderWfUsers = function (id) {
  url = BASE_URL + "admin/schvalovani/nacti/" + id;

  $.get(url, function (data) {
	$("#sortable").html(data);
  });

  return false;
};

renderWf = function (id) {
  url = BASE_URL + "admin/schvalovani/seznam-wf";

  $.get(url, function (data) {
	$("#workflow").html(data);
  });

  return false;
};

renderMessages = function (id) {
  url = BASE_URL + "admin/zpravy/message-list";

  $.get(url, function (data) {
	$("#messages").html(data);
  });

  return false;
};

approve = function (id) {
  $("#approveForm" + id).toggle();
  return false;
};

rejection = function (id) {
  $("#rejectionForm" + id).toggle();
  return false;
};

renderDokumentSubjekty = function (doc_to_subject_id) {
  var url =
	BASE_URL +
	"subjekty/" +
	doc_to_subject_id +
	"/nacti-subjekt?documentId=" +
	DOKUMENT_ID;

  $.get(url, function (subjekt) {
	if ($("#subjekty-table").length == 0) {
	  var html = '<table class="seznam" id="subjekty-table">';
	  html = html + "    <tr>";
	  html = html + '        <td colspan="4">Použít</td>';
	  html = html + "    </tr>";
	  html = html + subjekt;
	  html = html + "</table>";
	  $("#dok-subjekty").html(html);
	} else {
	  var subjekt_tr = $("#subjekty-table #subjekt-" + doc_to_subject_id);
	  if (subjekt_tr.length === 0) {
		$("#subjekty-table").append(subjekt);
	  }
	}
  });

  return false;
};

subjektUpravitSubmit = function () {
  postFormJ($("#subjekt-vytvorit"), function (data) {
	if (data.indexOf("###zmeneno###") != -1) {
	  closeDialog();
	  renderSubjekty('document');
	} else {
	  // chyba — formulář se vrátí do modalu včetně toast hlášek
	  $(".modal-body").html(data);
	  dialogScrollUp();
	  if (typeof loadToasts === 'function') {
		loadToasts();
	  }
	}
  });
  return false;
};

subjektSpisSubmit = function () {
  postFormJ($("#subjekt-vytvorit"), function (data) {
	if (data.indexOf("###done###") != -1) {
	  closeDialog();
	  renderSubjekty('spis');
	} else {
	  // chyba
	  $(".modal-body").html(data);
	  dialogScrollUp();
	}
  });
  return false;
};

subjektUpravitTypSubmit = function () {
  postFormJ($("#subjekt-zmenit-typ"), function (data) {
	if (data.indexOf("###zmeneno###") != -1) {
	  closeDialog();
	  renderSubjekty('document');
	} else {
	  // chyba
	  $(".modal-body").html(data);
	  dialogScrollUp();
	}
  });
  return false;
};

handleNovySubjekt = function (okFunc) {
  postFormJ($("#subjekt-vytvorit"), function (data) {
	//pridani subjektu z epodatelny
	if (data.extra_data === "ep" && data.status == "OK") {
	  renderEpodSubjekty(data.id_contact);
	} else if (data.extra_data === "ep") {
	  $("#dialog").html(data);
	  $(':input[type="submit"]').prop("disabled", false);
	  dialogScrollUp();
	}

	//pridani subjektu z detailu dokumentu
	if (data.extra_data === "doc") {
	  renderDokumentSubjekty(data.id);
	}

	if (typeof data == "object") {
	  if (data.status == "OK") {
		okFunc(data);
	  } else alert(data.status);
	} else {
	  // formular neprosel validaci
	  var values = $("#subjekt-vytvorit").serializeArray();
	  var text = "Vyplňte povinná pole";
	  for (var i = 0; i < values.length; i++) {
		if (values[i].name == "email" && values[i].value != "") {
		  var emailState =
			/^("([ !#-[\]-~]|\\[ -~])+"|[-a-z0-9!#$%&'*+\/=?^_`{|}~]+(\.[-a-z0-9!#$%&'*+\/=?^_`{|}~]+)*)@([0-9a-z\u00C0-\u02FF\u0370-\u1EFF]([-0-9a-z\u00C0-\u02FF\u0370-\u1EFF]{0,61}[0-9a-z\u00C0-\u02FF\u0370-\u1EFF])?\.)+[a-z\u00C0-\u02FF\u0370-\u1EFF]([-0-9a-z\u00C0-\u02FF\u0370-\u1EFF]{0,17}[a-z\u00C0-\u02FF\u0370-\u1EFF])?$/i.test(
			  values[i].value
			);
		  if (emailState == false) {
			var text = "Zadejte prosím platnou e-mailovou adresu.";
		  }
		}
	  }

	  alert(text);
	  $("#dialog").html(data);
	  $(':input[type="submit"]').prop("disabled", false);
	  dialogScrollUp();
	}
  });
  return false;
};

novySubjektOk = function () {
  closeDialog();
  renderSubjekty('document');
};

spisVytvoritSubmit = function (form) {
  postFormJ(form, function (data) {
	if (typeof data == "object") {
	  if (data.status === "OK") spisVlozitDokument(data.id);
	} else {
	  $(".modal-body").html(data);
	  dialogScrollUp();
	  $("#ajax-spinner").hide();
	}
  });

  return false;
};

spisVytvoritHromadneSubmit = function (form) {
  postFormJ(form, function (data) {
	if (typeof data == "object") {
	  if (data.status == "OK") spisVlozitDokumenty(data.id);
	} else {
	  $(".modal-body").html(data);
	  dialogScrollUp();
	  $("#ajax-spinner").hide();
	}
  });

  return false;
};

doplnPoznamkuKPredani = function () {
  var note = $("#frmpred-poznamka").val();
  if (note) {
	this.href =
	  this.href +
	  (this.href.match(/[\?]/g) ? "&" : "?") +
	  "note=" +
	  encodeURI(note);
  }
};

/**
 *  Platí rovněž pro výběr org. jednotky. Použito ve formuláři nového dokumentu.
 */
osobaVybrana = function () {
  var elm = $(this);
  var orgunit = elm.data("orgunit");
  var user = elm.data("user");
  $("input[name=predano_org]").val(orgunit);
  $("input[name=predano_user]").val(user);

  var text = elm.html();
  if (orgunit && !user) text = "organizační jednotka: " + text;
  $("#predano").html("<p><strong>" + text + "</strong></p>");
  $("#zrusit_predani").css("display", "");
  $(".advancedAutoComplete").val("");
  closeDialog();

  return false;
};

zrusitPredani = function () {
  event.preventDefault();
  $("input[name=predano_org]").val("");
  $("input[name=predano_user]").val("");
  $("#predano").html("");
  $(".advancedAutoComplete").val("");
  $("#zrusit_predani").css("display", "none");
  return false;
};

odebratUzivateleNastaveni = function (elm) {
  $("#predano_user").val("");
  $("#predano_org").val("");
  $("#assignUser").toggle();
  return false;
};

odebratPrilohu = function (elm) {
  if (confirm("Opravdu chcete odebrat přílohu z dokumentu?")) {
	$.get(elm.href, function (data) {
	  if (data.indexOf("###error###") !== -1) {
		data = data.replace("###error###", "");
		alert(data);
	  }
	  renderComponentNameCheck();
	  renderPrilohy();
	});
  }

  $("#theModal").modal("hide");
  return false;
};

confirmConvert = function (elm) {
  if (
	confirm(
	  "Chcete provést konverzi komponenty do formátu PDF/A-3b?\nK dokumentu bude připojena jako nová příloha v PDF."
	)
  ) {
	$.get(elm.href, function (data) {
	  if (data.indexOf("###error###") !== -1) {
		data = data.replace("###error###", "");
		alert(data);
	  }
	  renderPrilohy();
	});
  }

  return false;
};

confirmConvertBMP = function (elm) {
  if (
	confirm(
	  "Chcete provést konverzi komponenty do formátu JPEG?\nK dokumentu bude připojena jako nová příloha ve formátu JPEG."
	)
  ) {
	$.get(elm.href, function (data) {
	  if (data.indexOf("###error###") !== -1) {
		data = data.replace("###error###", "");
		alert(data);
	  }
	  renderPrilohy();
	});
  }

  return false;
};

confirmConvertKzMU = function (elm) {
  if (confirm("Chcete provést konverzi z moci úřední?")) {
	$.get(elm.href, function (data) {
	  console.log(data);
	  if (data.indexOf("###error###") !== -1) {
		data = data.replace(
		  "###error###",
		  "Konverze se nepodařila, kontaktujte administrátora."
		);
		alert(data);
	  } else {
		  alert(data);
	  }
	  renderPrilohy();
	});
  }

  return false;
};

odebratSubjekt = function (elm, entity = 'document') {
  const modalTitle = elm.dataset.title;
  const modalBody = elm.dataset.body;
  const url = elm.dataset.url;
  const link = document.getElementById("modalConfirmYes");
  link.setAttribute("href", url);
  if($(elm).hasClass("ajaxed")){
	  $(link).unbind("click");
	  $(link).on("click", function(){
		  event.preventDefault();
		  $.ajax({
			url: $(link).attr("href"),
			type: "get",
			success: function (data) {
				$("#confirmModal").modal("hide");
				renderSubjekty(entity);
			}
		  });
	  });
  }

  $(".modal-title").html(modalTitle);
  $(".modal-body").html(modalBody);

  $("#confirmModal").modal("show");
  return false;
};

odebratUzivatele = function (elm, id) {
  if (confirm("Opravdu chcete odebrat uživatele z workflow?")) {
	$.get(elm.href, function (data) {
	  renderWfUsers(id);
	});
  }

  return false;
};

odebratWorkflow = function (elm, count) {
  if (count > 0) {
	alert("Workflow nelze smazat, bylo již použito u dokumentů");
  } else {
	if (confirm("Opravdu chcete smazat workflow?")) {
	  $.get(elm.href, function (data) {
		renderWf();
	  });
	}
  }

  return false;
};

odebratZpravu = function (elm) {
  if (confirm("Opravdu chcete smazat zprávu?")) {
	$.get(elm.href, function (data) {
	  renderMessages();
	});
  }

  return false;
};

function renderVysledekHledaniDokumentu(data, typ) {
  var html = "<table class='seznam hledani-dokumentu'>";
  html = html + "<tr>";
  html = html + "<th class='cislo-jednaci'>číslo jednací</th>";
  html = html + "<th class='jid'>JID</th>";
  html = html + "<th>věc</th>";
  html = html + "</tr>";

  dokument_id = document.getElementById("dokumentid").value;
  evidence = document.getElementById("evidence");
  if (evidence == null) {
	evidence = 0;
  } else {
	evidence = evidence.value;
  }

  if (typ == 1) {
	var url =
	  BASE_URL +
	  "dokumenty/" +
	  dokument_id +
	  "/vlozitdosbernehoarchu?vlozit_do=";
	var fnc = "pripojitDokument(this)";
  } else {
	var url = BASE_URL + "spojit/" + dokument_id + "/vybrano?spojit_s=";
	var fnc = "spojitDokument(this)";
  }

  for (var zaznam in data) {
	if (evidence == 1) {
	  uevidence = "&evidence=1";
	} else {
	  uevidence = "";
	}

	a =
	  '<a class="peventMultiCklick" href="' +
	  url +
	  data[zaznam]["dokument_id"] +
	  uevidence +
	  '" onclick="' +
	  fnc +
	  '; return false;">';
	html = html + "<tr>";
	var cj = data[zaznam]["cislo_jednaci"];
	if (cj === null) cj = "";
	html = html + "<td class='cislo-jednaci'>" + a + cj + "</a></td>";
	html = html + "<td class='jid'>" + a + data[zaznam]["jid"] + "</a></td>";
	html = html + "<td>" + a + data[zaznam]["nazev"] + "</a></td>";
	html = html + "</tr>";
  }

  html = html + "</table>";
  return html;
}

hledejDokument = function (input, typ) {
  // nacteme hodnotu
  var vyraz = input.value;
  // vezmeme jen nad tri znaky
  if (vyraz.length < 2) return false;

  // cache
  var nalezeno = false;
  for (var index in cache) {
	if (index == vyraz) {
	  nalezeno = true;
	  $("#vysledek").html(renderVysledekHledaniDokumentu(cache[index], typ));
	  break;
	}
  }

  if (!nalezeno) {
	hledejDokumentAjax(vyraz, typ);
  }

  return false;
};

hledejDokumentAjax = function (vyraz, typ) {
  var url = BASE_URL + "spojit/hledat?q=" + vyraz;

  $.get(url, function (data) {
	var vysledek = $("#vysledek");

	if (data == "") {
	  vysledek.html(
		'<div class="prazdno">Nebyly nalezeny žádné dokumenty odpovídající dané sekvenci.</div>'
	  );
	} else if (data == "prilis_mnoho") {
	  vysledek.html(
		'<div class="prazdno">Daná sekvence obsahuje příliš mnoho záznamů. Zkuste zvolit přesnější sekvenci.</div>'
	  );
	} else {
	  cache[vyraz] = data;
	  vysledek.html(renderVysledekHledaniDokumentu(data, typ));
	  $(".peventMultiCklick").on("click", function(e){
		  if($(this).hasClass("preventedClick")){
			  e.preventDefault();
			  e.stopPropagation();
			  return false;
		  }
		  else{
			  $(this).addClass("preventedClick").prop("disabled", true);
			  $(this).before('<span class="buttonLoading spinner-border spinner-border-sm" role="status"></span>');
		  }
	  });
	}
  });

  return false;
};

renderSpojeni = function () {
	// var href = BASE_URL + "dokumenty/" + DOKUMENT_ID + "/detail-spojeni";
	var href = BASE_URL + "dokumenty/" + DOKUMENT_ID + "/detail";
	$.get(href, function (html) {
		// $("#snippet-spojeni").replaceWith(html);
		if (html.snippets && html.snippets['snippet--detailSpojeni']) {
			$("#snippet-spojeni").replaceWith(html.snippets['snippet--detailSpojeni']);
		} else {
			console.warn("nejsou dostupne data z snippet--detailSpojeni");
		}
	});
};

spojitDokument = function (elm) {
	if(!$(elm).hasClass("preventedClick")){
		$.get(elm.href, function () {
			closeDialog();
			renderSpojeni();
		});
	}
  return false;
};

odebratSpojeni = function (elm) {
	if(!$(elm).hasClass("preventedClick")){
	  $.get(elm.href, function (data) {
		if ((typeof data === 'string' || data instanceof String) && data.length > 0){
		  alert(data);
		} else {
		  renderSpojeni();
		}
	  });
	}

  return false;
};

pripojitDokument = function (elm) {
  $.get(elm.href, function (data) {
	if (data.indexOf("###vybrano###") != -1) {
	  data = data.replace("###vybrano###", "");

	  part = data.split("#");

	  //alert(data +' - '+ part[1]);

	  $("#dok_cjednaci").html(part[0]);
	  document.getElementById("frmnovyForm-poradi").value = part[1];
	  document.getElementById("frmnovyForm-odpoved").value = part[2];

	  //elm.href = url;
	  closeDialog();
	} else if (data.indexOf("###zaevidovano###") != -1) {
	  data = data.replace("###zaevidovano###", "");
	  window.location = data;
	  //elm.href = url;
	  closeDialog();
	} else {
	  $("#dialog").html(data);
	  dialogScrollUp();
	}
  });

  return false;
};

function renderVysledekHledaniSpis(data, typ) {
  var html = "<table class='seznam hledani-spisu'>";
  html = html + "<tr>";
  html = html + "<th class='spisova-znacka'>spisová značka</th>";
  html = html + "<th class='jid'>JID</th>";
  html = html + "<th>název</th>";
  html = html + "</tr>";

  spis_id = document.getElementById("spisid").value;
  evidence = document.getElementById("evidence");
  if (evidence == null) {
	evidence = 0;
  } else {
	evidence = evidence.value;
  }

  var url = BASE_URL + "spojit-spis/" + spis_id + "/vybrano?spojit_s=";
  var fnc = "spojitSpis(this)";

  for (var zaznam in data) {
	if (evidence == 1) {
	  uevidence = "&evidence=1";
	} else {
	  uevidence = "";
	}

	a =
	  '<a class="ajax" href="' +
	  url +
	  data[zaznam]["spis_id"] +
	  uevidence +
	  '">';
	html = html + "<tr>";
	var cj = data[zaznam]["spisova_znacka"];
	if (cj === null) cj = "";
	html = html + "<td class='spisova_znacka'>" + a + cj + "</a></td>";
	html = html + "<td class='jid'>" + a + data[zaznam]["jid"] + "</a></td>";
	html = html + "<td>" + a + data[zaznam]["nazev"] + "</a></td>";
	html = html + "</tr>";
  }

  html = html + "</table>";
  return html;
}

function renderVysledekHledaniSpis2(data) {
  var html = "<table class='seznam hledani-spisu'>";
  html = html + "<tr>";
  html = html + "<th class='spisova-znacka'>spisová značka</th>";
  html = html + "<th class='jid'>JID</th>";
  html = html + "<th>název</th>";
  html = html + "</tr>";

  dokument_id = document.getElementById("dokumentid").value;
  var url =
	BASE_URL + "dokumenty/" + dokument_id + "/vlozitdosbernehoarchu?vlozit_do=";
  var fnc = "pripojitDokument(this)";

  for (var zaznam in data) {
	a =
	  '<a href="' +
	  url +
	  data[zaznam]["spis_id"] +
	  '" onclick="' +
	  fnc +
	  '; return false;">';
	html = html + "<tr>";
	var cj = data[zaznam]["spisova_znacka"];
	if (cj === null) cj = "";
	html = html + "<td class='spisova_znacka'>" + a + cj + "</a></td>";
	html = html + "<td class='jid'>" + a + data[zaznam]["jid"] + "</a></td>";
	html = html + "<td>" + a + data[zaznam]["nazev"] + "</a></td>";
	html = html + "</tr>";
  }

  html = html + "</table>";
  return html;
}

hledejSpis = function (input, typ) {
  // nacteme hodnotu
  var vyraz = input.value;
  // vezmeme jen nad tri znaky
  if (vyraz.length < 2) return false;

  // cache
  var nalezeno = false;
  for (var index in cache) {
	if (index == vyraz) {
	  nalezeno = true;
	  $("#vysledek").html(renderVysledekHledaniSpis(cache[index], typ));
	  break;
	}
  }

  if (!nalezeno) {
	hledejSpisAjax(vyraz, typ);
  }

  return false;
};

hledejSpis2 = function (input, typ) {
  // nacteme hodnotu
  var vyraz = input.value;
  // vezmeme jen nad tri znaky
  if (vyraz.length < 2) return false;

  // cache
  var nalezeno = false;
  for (var index in cache) {
	if (index == vyraz) {
	  nalezeno = true;
	  $("#vysledek").html(renderVysledekHledaniSpis2(cache[index], typ));
	  break;
	}
  }

  if (!nalezeno) {
	hledejSpisAjax2(vyraz, typ);
  }

  return false;
};

hledejSpisAjax = function (vyraz, typ) {
  var url = BASE_URL + "spojit-spis/hledat?q=" + vyraz;

  $.get(url, function (data) {
	var vysledek = $("#vysledek");

	if (data == "") {
	  vysledek.html(
		'<div class="prazdno">Nebyly nalezeny žádné spisy odpovídající dané sekvenci.</div>'
	  );
	} else if (data == "prilis_mnoho") {
	  vysledek.html(
		'<div class="prazdno">Daná sekvence obsahuje příliš mnoho záznamů. Zkuste zvolit přesnější sekvenci.</div>'
	  );
	} else {
	  cache[vyraz] = data;
	  vysledek.html(renderVysledekHledaniSpis(data, typ));
	}
  });

  return false;
};

hledejSpisAjax2 = function (vyraz, typ) {
  var url = BASE_URL + "spojit-spis/hledat?q=" + vyraz;

  $.get(url, function (data) {
	var vysledek = $("#vysledek");

	if (data == "") {
	  vysledek.html(
		'<div class="prazdno">Nebyly nalezeny žádné spisy odpovídající dané sekvenci.</div>'
	  );
	} else if (data == "prilis_mnoho") {
	  vysledek.html(
		'<div class="prazdno">Daná sekvence obsahuje příliš mnoho záznamů. Zkuste zvolit přesnější sekvenci.</div>'
	  );
	} else {
	  cache[vyraz] = data;
	  vysledek.html(renderVysledekHledaniSpis2(data, typ));
	}
  });

  return false;
};

renderSpojeniSpisu = function () {
  var href = BASE_URL + "spisy/" + SPIS_ID + "/detail-spojeni";
  $.get(href, function (html) {
	$("#snippet-spojeni").replaceWith(html);
  });
};

spojitSpis = function (elm) {
  $.get(elm.href, function () {
	closeDialog();
	renderSpojeniSpisu();
  });

  return false;
};

odebratSpojeniSpisu = function (elm) {
  $.get(elm.href, function () {
	renderSpojeniSpisu();
  });

  return false;
};

selectReadOnly = function (select) {
  select.selectedIndex = 1;
  return false;
};

filtrSestavy = function (elm) {
  re = /sestavy\/([0-9]+)\/(.*)/;
  var matched = re.exec(elm.href);
  var url = BASE_URL + "sestavy/" + matched[1] + "/filtr/";
  if (matched[2]) url += "?tisk=" + matched[2];

  return dialog(elm, "Filtr", url);
};

zobrazSestavu = function (elm) {
  var param = "?";

  if (elm.pc_od.value != "") {
	param = param + "pc_od=" + elm.pc_od.value + "&";
  }
  if (elm.pc_do.value != "") {
	param = param + "pc_do=" + elm.pc_do.value + "&";
  }
  if (elm.d_od.value != "") {
	param = param + "d_od=" + elm.d_od.value + "&";
  }
  if (elm.d_do.value != "") {
	param = param + "d_do=" + elm.d_do.value + "&";
  }
  if (elm.d_today.checked) {
	param = param + "d_today=" + elm.d_today.value + "&";
  }
  if (elm.rok.value != "") {
	param = param + "rok=" + elm.rok.value;
  }

  //window.location.href = elm.url.value + param;
  window.open(elm.url.value + param);

  closeDialog();

  return false;
};

function select_set_value(SelectObject, Value) {
  for (index = 0; index < SelectObject.length; index++) {
	if (SelectObject[index].value == Value) SelectObject.selectedIndex = index;
  }
}

function htmlspecialchars(string, quote_style, charset, double_encode) {
  // http://kevin.vanzonneveld.net
  // +   original by: Mirek Slugen
  // +   improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
  // +   bugfixed by: Nathan
  // +   bugfixed by: Arno
  // +    revised by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
  // +    bugfixed by: Brett Zamir (http://brett-zamir.me)
  // +      input by: Ratheous
  // +      input by: Mailfaker (http://www.weedem.fr/)
  // +      reimplemented by: Brett Zamir (http://brett-zamir.me)
  // +      input by: felix
  // +    bugfixed by: Brett Zamir (http://brett-zamir.me)
  // +    bugfixed by: Tomas Vancura (chyba pri prazdnem string ;))
  // %        note 1: charset argument not supported
  // *     example 1: htmlspecialchars("<a href='test'>Test</a>", 'ENT_QUOTES');
  // *     returns 1: '&lt;a href=&#039;test&#039;&gt;Test&lt;/a&gt;'
  // *     example 2: htmlspecialchars("ab\"c'd", ['ENT_NOQUOTES', 'ENT_QUOTES']);
  // *     returns 2: 'ab"c&#039;d'
  // *     example 3: htmlspecialchars("my "&entity;" is still here", null, null, false);
  // *     returns 3: 'my &quot;&entity;&quot; is still here'
  var optTemp = 0,
	i = 0,
	noquotes = false;
  if (typeof quote_style === "undefined" || quote_style === null) {
	quote_style = 2;
  }

  if (typeof string == "object") return "";

  string = string.toString();
  if (double_encode !== false) {
	// Put this first to avoid double-encoding
	string = string.replace(/&/g, "&amp;");
  }
  string = string.replace(/</g, "&lt;").replace(/>/g, "&gt;");

  var OPTS = {
	ENT_NOQUOTES: 0,
	ENT_HTML_QUOTE_SINGLE: 1,
	ENT_HTML_QUOTE_DOUBLE: 2,
	ENT_COMPAT: 2,
	ENT_QUOTES: 3,
	ENT_IGNORE: 4,
  };
  if (quote_style === 0) {
	noquotes = true;
  }
  if (typeof quote_style !== "number") {
	// Allow for a single string or an array of string flags
	quote_style = [].concat(quote_style);
	for (i = 0; i < quote_style.length; i++) {
	  // Resolve string input to bitwise e.g. 'ENT_IGNORE' becomes 4
	  if (OPTS[quote_style[i]] === 0) {
		noquotes = true;
	  } else if (OPTS[quote_style[i]]) {
		optTemp = optTemp | OPTS[quote_style[i]];
	  }
	}
	quote_style = optTemp;
  }
  if (quote_style & OPTS.ENT_HTML_QUOTE_SINGLE) {
	string = string.replace(/'/g, "&#039;");
  }
  if (!noquotes) {
	string = string.replace(/"/g, "&quot;");
  }

  return string;
}

zmen_rezim_subjektu = function () {
  var document_to_subject_id = this.id.replace(/subjekt_ikona_/, "");
  var url = BASE_URL + "subjekty/" + document_to_subject_id + "/zmenrezim?";
  url += "dok_id=" + DOKUMENT_ID;

  $.get(
	url,
	"",
	function (data) {
		if(data==='OK'){
			renderSubjekty('document');
		}
		else{
			alert(data);
		}
	},
	"text"
  );
};

changeDocumentToSubjectType = function () {
  const id = this.dataset.id;
  let url = BASE_URL + "subjekty/" + id + "/zmenrezim?";
  url += "dok_id=" + DOKUMENT_ID;

  $.get(
	url,
	"",
	function (data) {
		if(data==='OK'){
			renderSubjekty('document');
		}
		else{
			alert(data);
		}
	},
	"text"
  );
};

/**
 * Initializuje Select2 widgety na prvcich select s atributem data-widget-select2=1
 * kontroluje zda je funkce dostupna
 * @returns {void}
 */
initSelect2 = function () {
  try {
	if (typeof $().select2 !== "undefined") {
	  // Poznamka: nasledujici neni pouzito, nahrazeno widgetem spisoveho znaku
	  $("select:not(has-select2-widget)[data-widget-select2=1]").each(
		  function () {
			var options = $(this).data("widget-select2-options") || {};

			$(this).select2(options).attr("has-select2-widget", 1);
		  }
	  );

	  $(".widget_vecna_skupina").select2({
		width: "100%",
	  });

	  $("#labels_colors").select2({
		templateResult: iconFromValue,
		templateSelection: iconFromValueOnlyIcons,
		tags: false,
		escapeMarkup: function (m) {
		  return m;
		},
	  });

	  $("#labels_colors").css("border", "0px");
	  $("#labels_colors").children().css("border", "0px");
	}
  }catch (error){
	console.log(error);
  }

};

function iconFromValue(val) {
  if (val.element) {
	const option = $(val.element);
	const color = option.data("hex");
	if (!color) {
	  color = "black";
	}

	val = `<i class="fa-solid fa-tag" style="color: #${color};"></i><span> ${val.text}`; // barva + název
  }
  return val;
}

function iconFromValueOnlyIcons(val) {
  if (val.element) {
	const option = $(val.element);
	const color = option.data("hex");
	if (!color) {
	  color = "black";
	}

	val = `<i class="fa-solid fa-tag" style="color: #${color};"></i><span>`; // pouze ikona
  }
  return val;
}

vybratVecnouSkupinu = function (element) {

  const form = $(element).parents("form").first()[0];

  const key = form['vecna_skupina_id'].selectedIndex;
  const vs_id = form['vecna_skupina_id'].options[key].value;
  const spisovyPlanId = form['spisovyPlanId'].value;

  if (vs_id === 0 || vs_id === "")
	return true;

  const url = BASE_URL + "vecne-skupiny/detail?vsId=" + vs_id + "&spisovyPlanId=" + spisovyPlanId;

  $.get(url, function (data) {

	if(data.skartacniRezim && data.skartacniRezim.jid && $("#srJID"))
		$("#srJID").text(data.skartacniRezim.jid);

	if(data.skartacniRezim && data.skartacniRezim.znepristupneny !== undefined && $("#srZnepristupneny"))
		$("#srZnepristupneny").text(data.skartacniRezim.znepristupneny ? 'Ano' : 'Ne');

	if(data.skartacniRezim && data.skartacniRezim.duvodUpravy && $("#srDuvodUpravy"))
		$("#srDuvodUpravy").text(data.skartacniRezim.duvodUpravy);

	if(data.skartacniRezim && data.skartacniRezim.skartacniZnak){
	  if(form.skartacni_znak)
		$(form.skartacni_znak).val(data.skartacniRezim.skartacniZnak);

	  if($("#srSkartacniZnak"))
		$("#srSkartacniZnak").text(data.skartacniRezim.skartacniZnak);
	}

	if(data.zpusobPridelovaniCj == '0' || data.zpusobPridelovaniCj == '1'){
	  if(form.typ_evidence)
		$(form.typ_evidence).val(data.zpusobPridelovaniCj);

	  if($("#srTypEvidence")){
		if (data.zpusobPridelovaniCj == '1'){
		  $("#srTypEvidence").text('priorace');
		} else {
		  $("#srTypEvidence").text('sběrný arch');
		}
	  }
	}

	if(data.skartacniRezim && data.skartacniRezim.skartacniLhuta !== undefined && data.skartacniRezim.skartacniLhuta !== null){
	  if (form.skartacni_lhuta)
		$(form.skartacni_lhuta).val(data.skartacniRezim.skartacniLhuta);

	  if(data.skartacniRezim && $("#srSkartacniLhuta")){
		  $("#srSkartacniLhuta").parent().parent().removeClass('d-none');
		  $("#srSkartacniLhuta").text(data.skartacniRezim.skartacniLhuta);
	  }
	}else{
	  $("#srSkartacniLhuta").parent().parent().removeClass('d-none').addClass('d-none');
	}

	if(data.spousteciUdalost.id){
	  if(form.spousteci_udalost_id)
		$(form.spousteci_udalost_id).val(parseInt(data.spousteciUdalost.id));

	  if($("#srSpousteciUdalost")){}
		$("#srSpousteciUdalost").text(data.spousteciUdalost.nazev);
	}

	if(data.jeTrvalySkartacniSouhlas && data.trvalySkartacniSouhlas) {
	  $("#srTrvalySouhlas").text('Ano - ' + data.trvalySkartacniSouhlas);
	} else if(data.jeTrvalySkartacniSouhlas){
		$("#srTrvalySouhlas").text('Ano - chybí identifikátor NA');
	} else {
		$("#srTrvalySouhlas").text('Ne');
	}
  });

  return true;
};

function selectionValidation() {
  var cat = document.getElementById(
	"frmvyrizovaniForm-zpusob_vyrizeni_id"
  ).value;
  if (cat == "4") {
	if (
	  document.getElementById("frmvyrizovaniForm-oduvodneni_vyrizeni").value ==
	  ""
	) {
	  alert("Způsob vyřízení “Jiný způsob” vyžaduje odůvodnění vyřízení.");
	  return false;
	}
  }
  return true;
}

postFormJ = function (form, callback) {
  if (!(form instanceof jQuery)) form = $(form);

  form.find("input[type='submit']").prop("disabled", true);

  $.post(form.attr("action"), form.serialize(), callback);
};

initSpisAutocomplete = function () {
  var url = BASE_URL + "spisy/seznam-ajax";

  $(".spis_autocomplete").autoComplete({
	minLength: 3,
	resolver: "custom",
	resolverSettings: {
	  requestThrottling: 100, //Default 500
	},
	noResultsText: "Nebyl nalezen žádný spis",
	formatResult: function (item) {
	  return {
		value: item.id,
		text: item.text + " - " + item.nazev,
	  };
	},
	events: {
	  search: function (qry, callback) {
		$.ajax(url, {
		  data: { q: qry },
		}).done(function (res) {
		  callback(res.results);
		});
	  },
	},
  });

  $(".spis_autocomplete").on("autocomplete.select", function (evt, item) {
	spisVlozitDokument(item.id);
	return false;
  });
};

initSpisAutocompleteForDocuments = function () {
  var url = BASE_URL + "spisy/seznam-ajax";

  $(".spis_autocomplete_input").autoComplete({
	minLength: 3,
	resolver: "custom",
	resolverSettings: {
	  requestThrottling: 100, //Default 500
	},
	noResultsText: "Nebyl nalezen žádný spis",
	formatResult: function (item) {
	  return {
		value: item.id,
		text: item.text + " - " + item.nazev,
	  };
	},
	events: {
	  search: function (qry, callback) {
		$.ajax(url, {
		  data: { q: qry },
		}).done(function (res) {
		  callback(res.results);
		});
	  },
	},
  });

  $(".spis_autocomplete_input").on("autocomplete.select", function (evt, item) {
	spisVlozitDokumenty(item.id);
	return false;
  });
};

openHelpWindow = function (url) {
  $("#napoveda").dialog("option", "title", "Nápověda");
  // $('#napoveda').html('');
  $("#napoveda").dialog("open");

  displayHelpPage(url);
  return false;
};

displayHelpPage = function (url) {
  $("#theModal .modal-body").load(url, function () {
	$("#theModal").modal("show");
  });

  return false;
};

ajaxAnchor = function (event) {
  $.get(this.href, function (payload) {
	var sel = $("#" + payload.id);
	sel.html(payload.html);
  });

  return false;
};

ajaxDialog = function (event) {
  var title = $(this).data("title") || "";
  dialog(this, title);
  return false;
};

installDatePicker = function () {

  $("input.datepicker").datepicker({
	language: "cs",
	todayHighlight: true,
	appendTo: "#theModal",
  });

  $("input.datepicker.forbid-past-dates").datepicker({
	language: "cs",
	todayHighlight: true,
	minDate: 0
  });

  $("#frmnovyForm-nazev").keyup(updateCount).keydown(updateCount);

};

$(document).ready(function()
{
  $(':text[data-provide="datepicker"]').datepicker(
  {
	language: 'cs'
  });
});

function updateCount() {
  var cs = $(this).val().length;
  $("#characterCount span").text(cs);
}

// HACK padStart() for Internet Explorer 11
if (!String.prototype.padStart) {
  String.prototype.padStart = function padStart(targetLength, padString) {
	targetLength = targetLength >> 0; //truncate if number or convert non-number to 0;
	padString = String(typeof padString !== "undefined" ? padString : " ");
	if (this.length > targetLength) {
	  return String(this);
	} else {
	  targetLength = targetLength - this.length;
	  if (targetLength > padString.length) {
		padString += padString.repeat(targetLength / padString.length); //append to original to ensure we are longer than needed
	  }
	  return padString.slice(0, targetLength) + String(this);
	}
  };
}

convertCompleted = function (documentId, fileId) {
  $("#progressbar").show();

  $(function () {
	var progressTimer,
	  progressbar = $("#progressbar"),
	  progressLabel = $(".progress-label");

	progressTimer = setTimeout(progress, 200);

	progressbar.progressbar({
	  value: false,
	  change: function () {
		var actual = progressbar.progressbar("value");
		var message = "";

		if (actual <= 30) {
		  message = "vytvářím ZFO";
		}

		if (actual >= 31 && actual < 70) {
		  message = "odesílám data";
		}

		if (actual > 70) {
		  message = "dokončuji konverzi";
		}

		progressLabel.text(message);
	  },
	  complete: function () {
		progressLabel.text("Hotovo!");
		closeDownload();
		return false;
	  },
	});

	function progress() {
	  var val = progressbar.progressbar("value") || 0;

	  progressbar.progressbar("value", val + 2);

	  if (val < 30) {
		progressTimer = setTimeout(progress, 80);
	  }

	  if (val >= 30 && val < 40) {
		progressTimer = setTimeout(progress, 150);
	  }

	  if (val >= 40 && val < 60) {
		progressTimer = setTimeout(progress, 400);
	  }

	  if (val >= 60 && val < 70) {
		progressTimer = setTimeout(progress, 100);
	  }

	  if (val >= 70 && val < 99) {
		progressTimer = setTimeout(progress, 80);
	  }
	}

	function closeDownload() {
	  var isOpen = $("#dialog").dialog("isOpen");
	  if (isOpen === true) {
		clearTimeout(progressTimer);
		progressbar.progressbar("value", false);
		progressbar.progressbar("option", "disabled", true);

		$("#ajax-spinner").hide();
		$("#dialog").dialog("close");

		var e = document.getElementById("frmconvertForm-typ");
		var typ = e.options[e.selectedIndex].value;

		var href =
		  BASE_URL +
		  "prilohy/converse-add?document_id=" +
		  documentId +
		  "&file_id=" +
		  fileId +
		  "&type=" +
		  typ;
		$.get(href, function (dokument) {
		  renderPrilohy();
		  return true;
		});
	  }
	}
  });
};

attachmentUploadCompleted = function (response) {
  if (response.substring(0, 13) === "###nahrano###") {
	alert("Příloha byla nahrána.");
  } else if (response.substring(0, 13) === "###zmemeno###") {
	alert("Příloha byla upravena.");
  } else {
	// Bohuzel nedokazi rozpoznat, jestli response obsahuje HTML formular nebo
	// Tracy dump s chybou
	// Neni dostupna informace, jestli pozadavek skoncil s 200 nebo 500
	// alert('V aplikaci došlo k problému.');
	$("#dialog").html(response);
	return;
  }
  $("#theModal").modal("hide");

  renderPrilohy();
};

/**
 * Odešle formulář odeslání/doručení přes XHR (ne přes AIM iframe ani nette.ajax class=ajax),
 * aby po úspěchu běžel callback se zavřením dialogu a obnovením UI.
 */
submitOdeslaniForm = function (form, onComplete) {
  var $form = $(form);
  var data = $form.serializeArray();
  // Nette onClick u SubmitButton vyžaduje jméno tlačítka v POST datech
  var $submit = $form.find(":submit").filter(":focus");
  if (!$submit.length) {
	$submit = $form.find(":submit").first();
  }
  if ($submit.length && $submit.attr("name")) {
	data.push({ name: $submit.attr("name"), value: $submit.val() });
  }
  $.ajax({
	url: $form.attr("action") || window.location.href,
	type: ($form.attr("method") || "post").toUpperCase(),
	data: $.param(data),
	success: function (response) {
	  $("#ajax-spinner").hide();
	  onComplete(response);
	},
	error: function (xhr) {
	  $("#ajax-spinner").hide();
	  alert("Akce se nepovedla" + (xhr.responseText || ""));
	},
  });
  return false;
};

onSubmitOdeslani = function (form) {
  return submitOdeslaniForm(form, zmenaOdeslaniSkonceno);
};

objectifyForm = function (formArray) {
  //serialize data function
  var returnArray = {};
  for (var i = 0; i < formArray.length; i++) {
	returnArray[formArray[i]["name"]] = formArray[i]["value"];
  }
  return returnArray;
};

onSubmitOdeslaniInfoVypravna = function (form) {
  var formData = objectifyForm($(form).serializeArray());
  return submitOdeslaniForm(form, function (response) {
	zmenaOdeslaniSkoncenoInfoVypravna(response, formData);
  });
};

hasOdeslaniMarker = function (response, marker) {
  return typeof response === "string" && response.indexOf(marker) !== -1;
};

finishOdeslaniSuccess = function () {
  closeDialog();
  location.reload();
};

zmenaOdeslaniSkonceno = function (response) {
  if (hasOdeslaniMarker(response, "###ok_d_upl###")) {
	alert("Datum vrácení bylo uloženo.");
	finishOdeslaniSuccess();
  } else if (hasOdeslaniMarker(response, "###ok_info_upl###") || hasOdeslaniMarker(response, "###ok_l_upl###")) {
	alert("Informace o doručení byly uloženy.");
	finishOdeslaniSuccess();
  } else if (hasOdeslaniMarker(response, "###ok_d_del###")) {
	// alert('Datum vrácení bylo smazáno.');
	finishOdeslaniSuccess();
  } else if (hasOdeslaniMarker(response, "###ok_l_del###")) {
	// alert('Číslo doporučeného dopisu bylo smazáno.');
	finishOdeslaniSuccess();
  } else {
	alert("Akce se nepovedla" + response);
  }
};

zmenaOdeslaniSkoncenoInfoVypravna = function (response, data) {
  if (hasOdeslaniMarker(response, "###ok_l_upl###")) {
	alert("Informace o doručení byly uloženy.");
	finishOdeslaniSuccess();
  } else {
	alert("Akce se nepovedla" + response);
  }
};

onSubmitTiskZebra = function (form) {
  AIM.submit(form, {
	onComplete: function (s) {
	  $("#ajax-spinner").hide();
	  printZebraEnd(s);
	},
	returnJson: true,
  });
};

printZebraEnd = function (response) {
  if (response.substring(0, 14) == "###ok_d_upl###") {
	// alert("Štítek byl odeslaný na tiskárnu.");
  } else {
	alert("Akce se nepovedla" + response);
  }
};

odstranitPrvekOdeslani = function (url, typ) {
  if (confirm("Opravdu chcete odstranit " + typ + "?")) {
	$.get(url, function (data) {
	  zmenaOdeslaniSkonceno(data);
	});
  } else {
	return false;
  }
  return false;
};

nastaveniPriraditSpis = function (spis_id) {
  var href = BASE_URL + "admin/nastaveni/priradit-spis?spis_id=" + spis_id;

  $.get(href, function (spis) {
	$("#tp_spis_id").val(spis.id);
	$("#spis-nazev").html(
	  '<a href="/admin/spisy/detail/' + spis.id + '/">' + spis.nazev + "</a>"
	);
	$("#spis-vyjmout").show();
	closeDialog();
  });

  return false;
};

nastaveniZrusitPrirazeniSpisu = function () {
  if (
	confirm(
	  "Opravdu chcete zrušit přiřazení generovaných transakčních protokolů do spisu?"
	)
  ) {
	$("#tp_spis_id").val("");
	$("#spis-nazev").html("Spisu - nevybrán žádný spis - ");
	$("#spis-vyjmout").hide();
  }

  return false;
};

odebratSubjektNastaveni = function () {
  if (
	confirm(
	  "Opravdu chcete odebrat subjekt používaný jako adresát i odesílatel u generovaných transakčních protokolů?"
	)
  ) {
	$("#dok-subjekty").html("");
	$("#tp_subjekt_id2").val("");
	$("#tp_subjekt_id2").show();
  }

  return false;
};

formatujDatum = function (zdroj) {
  var datum = "";
  var navrat = false;

  if (typeof zdroj == "object" && zdroj.date != null) {
	datum = zdroj.date;
  } else if (typeof zdroj == "string") {
	datum = zdroj;
  }

  if (datum != "") {
	datum = new Date(datum);
	var dd = String(datum.getDate()).padStart(2, "0");
	var mm = String(datum.getMonth() + 1).padStart(2, "0");
	var yyyy = datum.getFullYear();
	var hh = String(datum.getHours()).padStart(2, "0");
	var min = String(datum.getMinutes()).padStart(2, "0");
	var sec = String(datum.getSeconds()).padStart(2, "0");
	datum = dd + "." + mm + "." + yyyy;
	datum_a_cas = dd + "." + mm + "." + yyyy + " " + hh + ":" + min + ":" + sec;
	cas = hh + ":" + min + ":" + sec;
	navrat = [datum, datum_a_cas, cas];
  }

  return navrat;
};

function disableSubmitButtons(formId) {
  $("#" + formId + " input[type=submit]").click(function () {
	let btn = $(this);
	if (!btn.hasClass("no-disable")) {
	  setTimeout(function () {
		btn.addClass("preventedClick").prop("disabled", true);
	  }, 0);
	  btn.before('<span class="buttonLoading spinner-border spinner-border-sm" role="status"></span>');
	  /*
	  setTimeout(function () {
		btn.removeProp("disabled").removeClass("preventedClick");
	  }, 5000);
	  */
	}
  });
}

function disableSubmitButtonsHard(formId) {
  $("#" + formId + " input[type=submit]").click(function () {
	let btn = $(this);
	if (!btn.hasClass("no-disable")) {
	  setTimeout(function () {
		btn.prop("disabled", true);
	  }, 0);
	}
  });
}

function disableLink(endsOn) {
  $('a[href$="' + endsOn + '"]').click(function () {
	const link = $(this).prop("href");
	$(this).attr("href", "javascript:void(0)");

	window.location.href = link;
  });
}

$(".one-click-link").click(function (event) {
  $(this).off("click");
  $(this).css("pointer-events", "none");
  event.preventDefault();
});

/*
 * Univerzalni funkce pro (od)zaskrtnuti vsech checkboxu na strance s danym prefixem podle volane hodnoty stavu
 * */
selectAllCheckbox = function (
  status,
  prefix_checkbox,
  excluded_checbox = "",
  second_excluded = ""
) {
  if (status) {
	$("input[name^='" + prefix_checkbox + "']:visible").prop("checked", true);
	if (excluded_checbox != "") {
	  $("input[name^='" + excluded_checbox + "']").prop("checked", false);
	}
	if (second_excluded != "") {
	  $("input[name^='" + second_excluded + "']").prop("checked", false);
	}
  } else {
	$("input[name^='" + prefix_checkbox + "']").prop("checked", false);
  }
};

/**
 * Univerzalni funkce pro (od)zaskrtnuti souvisejiciho checkboxu podle hodnoty stavu volaneho checkboxu
 */
changeRelatedCheckbox = function (
  actual,
  other_checkbox,
  second_other = "",
  where,
  both_way = false
) {
  if (where == "name") {
	if (actual.checked) {
	  $("input[name^='" + other_checkbox + "']").prop("checked", false);
	  if (second_other != "") {
		$("input[name^='" + second_other + "']").prop("checked", false);
	  }
	} else if (both_way) {
	  $("input[name^='" + other_checkbox + "']").prop("checked", true);
	}
  }
};

$(document).ready(function() {
  $('[name="lhuta"]').change(function() {
	if($(this).parents(".subjectsSearchForm").length){
		return true;
	}

	var val = $(this).val();
	var lhutaDatumInput = $('[name="lhuta_datum"]');
	var datum_vzniku = ''

	if($('[name="datum_vzniku"]')){
	  datum_vzniku = $('[name="datum_vzniku"]').val();
	}

	if (val !== '' && parseInt(val) >= 0) {
	  $.get(BASE_URL + 'dokumenty/datum-ze-lhuty?lhuta=' + parseInt(val) + '&datum_vzniku=' + datum_vzniku , function (data) {
		let date = new Date(data.timestamp * 1000);
		lhutaDatumInput.val(date.getDate() + "." + (date.getMonth() + 1) + "." + date.getFullYear());
	  });

	  $('[name="bezLhuty"]').prop('checked', false);

	  return false;
	}
  });

  $('[name="lhuta_datum"]').change(function() {
	var val = $(this).val();
	var lhutaInput = $('[name="lhuta"]');
	var lhutaDefaultInput = $('[name="lhuta_default"]');

	var datum_vzniku = ''

	if($('[name="datum_vzniku"]')){
	  datum_vzniku = $('[name="datum_vzniku"]').val();
	}

	if (val !== '') {
	  $.get(BASE_URL + 'dokumenty/lhuta-z-data?datum=' + val + '&datum_vzniku=' + datum_vzniku , function (data) {
		lhutaInput.val(data.lhuta);
	  });
	  $('[name="bezLhuty"]').prop('checked', false);
	  return false;
	} else {
	  lhutaInput.val(lhutaDefaultInput.val());
	}
  });

})

/*
 * Nastaveni 3 statovych checkboxů
 *	dokumentace:
 *		http://vanderlee.github.io/tristate/
 *
 * */
$(document).ready(function () {
	$('.tristate').tristate();
});
/*
 * Nastaveni kalendare s datem a casem
 *	kompletni popis moznosti:
 *		https://www.jqueryscript.net/time-clock/Date-Time-Picker-Bootstrap-4.html
 *		 https://momentjs.com/docs/#/displaying/format/
 *
 * */
$(document).ready(function () {
  $(
	"#frmmyFilterForm-form-dateFrom,#frmmyFilterForm-form-dateTo"
  ).datetimepicker({
	format: "DD.MM.YYYY HH:mm:ss",
	showTodayButton: true,
	useCurrent: false,
	showClear: true,
	showClose: true,
	sideBySide: true,
	useStrict: true,
	toolbarPlacement: "bottom",
	locale: moment.locale("cs"),

	// Change the default icons for the pickers functions.
	icons: {
	  time: "fa-regular fa-clock",
	  date: "fa-regular fa-calendar",
	  up: "fa-solid fa-chevron-up",
	  down: "fa-solid fa-chevron-down",
	  previous: "fa-solid fa-chevron-left",
	  next: "fa-solid fa-chevron-right",
	  today: "fa-solid fa-crosshairs",
	  clear: "fa-light fa-eraser",
	  close: "fa-solid fa-times",
	},

	// custom tooltip text
	tooltips: {
	  today: "Dnes",
	  clear: "Vymazat výběr",
	  close: "Zavřít kalendář",
	  selectMonth: "Vybrat měsíc",
	  prevMonth: "Předchozí měsíc",
	  nextMonth: "Příští měsíc",
	  selectYear: "Vybrat rok",
	  prevYear: "Předchozí rok",
	  nextYear: "Příští rok",
	  selectDecade: "Vybrat desetiletí",
	  prevDecade: "Předchozí desetiletí",
	  nextDecade: "Příští desetiletí",
	  prevCentury: "Předchozí století",
	  nextCentury: "Příští století",
	  pickHour: "Vybrat hodinu",
	  incrementHour: "Přičíst hodinu",
	  decrementHour: "Odečíst hodinu",
	  pickMinute: "Vybrat minutu",
	  incrementMinute: "Přičíst minutu",
	  decrementMinute: "Odečíst minutu",
	  pickSecond: "Vybrat vteřinu",
	  incrementSecond: "Přičíst vteřinu",
	  decrementSecond: "Odečíst vteřinu",
	  togglePeriod: "Změnit období",
	  selectTime: "Vybrat čas",
	},
  });

  $("#labels_colors").on("change", function (e) {
	typ_nastaveni = $(this).data("typ");
	objektId = $(this).data("objektid");
	url = BASE_URL + typ_nastaveni + "/ulozit-tagy";
	labels_selected = $(this).val();
	objektId = $(this).data("objektid");
	$.post(
	  url,
	  { objekt_id: objektId, label_id: labels_selected },
	  function (data) {}
	);
  });

  $("#labels_colors").on("select2:opening select2:closing", function (event) {
	var $searchfield = $(this).parent().find(".select2-search__field");
	$searchfield.prop("disabled", true);
  });

  $("#stitky_button,#stitky_button>i").click(function () {
	$("#labels_colors").select2("open");
  });
});

// pridat kontakt do adresni skupiny

function pridejKontaktDoAdresniSpookyny(skupina_id, kontakt_id) {
  url =
	BASE_URL +
	"admin/adresni-skupiny/detail/" +
	skupina_id +
	"/?idAdresniSkupiny=" +
	skupina_id +
	"&idKontakt=" +
	kontakt_id +
	"&do=priradit" +
	"&autocomplete=1";
  $.get(url, function (data) {
	renderKontakty("AdresniSkupinaDetail");
	closeDialog();
  });
}

function pridejAdresniSkupinuKDokumentu(skupina_id, dokument_id) {
  url =
	BASE_URL +
	"adresni-skupiny/?do=priraditkdokumentu&skupina_id=" +
	skupina_id +
	"&dok_id=" +
	dokument_id +
	"&autocomplete=1";
  $.get(url, function (data) {
	if (data.indexOf("###vybrano###") !== -1) {
	  $("#validateAdresat").html("");
	  renderSubjekty('document');
	} else {
	  alert(data);
	}
  });
}

function pridejAdresniSkupinuKeSpisu(skupina_id, spis_id) {
  url =
	BASE_URL +
	"adresni-skupiny/?do=priraditkespisu&skupina_id=" +
	skupina_id +
	"&spis_id=" +
	spis_id +
	"&autocomplete=1";
  $.get(url, function (data) {
	if (data.indexOf("###vybrano###") !== -1) {
	  $("#validateAdresat").html("");
	  renderSubjekty('spis');
	} else if (data.trim() !== "") {
	  alert(data);
	}
  });
}

// obecna funkce pro zobrazeni a skryti prvku na strance - prvky jsou zadane jako pole ID cek prvku
showItems = function (ids) {
  event.preventDefault();
  for (const element of ids) {
	$("#" + element).toggle();
  }
};


function IgnoreAlpha(e) {
  if (!e) {
	e = window.event;
  }
  if (e.keyCode >= 65 && e.keyCode <= 90) {
	// A to Z
	e.returnValue = false;
	e.cancel = true;
  }
}

// zobrazeni dat Skartacniho rezimu pri editaci typu dokumentu a vecnych skupin
function getAndShowSRData(formNameItem) {
  let shredItems = $("#" + formNameItem).data('items');
  let selectedShredId = parseInt($("#" + formNameItem).val());

  if (selectedShredId == 0){
	$("#srZnepristupneny").text('');
	$("#srSkartacniZnak").text('');
	$("#srSkartacniLhuta").parent().parent().removeClass('d-none').addClass('d-none');
	$("#srDuvodUpravy").text('');
  } else if (shredItems[selectedShredId]) {
	let item = shredItems[selectedShredId];
	$("#srSpousteciUdalost").text(item['spousteciUdalost']['nazev'] + ' (kód: ' + item['spousteciUdalost']['kod'] + ')');
	$("#srZnepristupneny").text(item['znepristupneny'] ? 'Ano' : 'Ne');
	$("#srSkartacniZnak").text(item['skartacniZnak']);

	if(item['skartacniLhuta'] !== ''){
	  $("#srSkartacniLhuta").parent().parent().removeClass('d-none');
	  $("#srSkartacniLhuta").text(item['skartacniLhuta']);
	}else{
	  $("#srSkartacniLhuta").parent().parent().removeClass('d-none').addClass('d-none');
	}

	$("#srDuvodUpravy").text(item['duvodUpravy']);
  }
}


$(document).ready(function() {
  $(document).on("input", ".whole-number-input", function () {
	const inputValue = $(this).val();

	if (!Number.isInteger(Number(inputValue)) || inputValue.toString().includes('.') || inputValue.toString().includes(',')) {
	  alert('Prosím zadejte celé číslo.');
	  $(this).val('');
	}
  });

  $('.truncated-select option').each(function () {
	const text = $(this).text();
	$(this).attr('title', text);
	$(this).attr('class', 'truncate');

	const truncated = text.length > 75 ? text.substring(0, 75) + '...' : text;
	$(this).text(truncated);
  });

});

$(document).ready(function() {
  $("#hmotnost-input").on("input", function() {
	if($("#cena-zasilky-input")){
	  $.ajax({
		url: BASE_URL + "vypravna/get-package-price?packageId=" + $("#druhZasilky").val() + "&weight=" + $("#hmotnost-input").val() + "&size=" + $("#velikost-input").val(),
		type: "GET",
		success: function (data, textStatus, jqXHR) {
		  $("#cena-zasilky-input").val(data['price']);
		},
	  });
	}
  });

  $("#druhZasilky").on("input", function() {
	if($("#cena-zasilky-input")){
	  $.ajax({
		url: BASE_URL + "vypravna/get-package-price?packageId=" + $("#druhZasilky").val() + "&weight=" + $("#hmotnost-input").val() + "&size=" + $("#velikost-input").val(),
		type: "GET",
		success: function (data, textStatus, jqXHR) {
		  $("#cena-zasilky-input").val(data['price']);
		},
	  });
	}
  });

  $("#velikost-input").on("input", function() {
	if($("#cena-zasilky-input")){
	  $.ajax({
		url: BASE_URL + "vypravna/get-package-price?packageId=" + $("#druhZasilky").val() + "&weight=" + $("#hmotnost-input").val() + "&size=" + $("#velikost-input").val(),
		type: "GET",
		success: function (data, textStatus, jqXHR) {
		  $("#cena-zasilky-input").val(data['price']);
		},
	  });
	}
  });
});

$(document).ready(function() {
  $(document).on("click", ".datagrid.datagrid-subjectsGrid table tbody tr", function (event) {
	  if (!$(event.target).is('a')) {
		$(this).find('a[data-toggle-detail-grid="subjectsGrid"]').trigger('click');
	  }
  });
});

vybratTypovySpis = function (element) {
	const form = $(element).parents("form").first()[0];
	const $createButton = $(form).find('#button-vytvorit-zmenit');
	const key = form['vecna_skupina_id'].selectedIndex;
	const vs_id = form['vecna_skupina_id'].options[key].value;
	const url = BASE_URL + "typove-spisy/seznam-typovych-spisu-ajax?vsId=" + vs_id + "";

	$.get(url, function (data) {
		if (data['vecnaSkupinaProTypovySpis']) {
			const typoveSpisy = Array.isArray(data['typoveSpisy']) ? data['typoveSpisy'] : [];
			const hasOpen = !!(data['existujeOtevrenyTypovySpis'] || typoveSpisy.some(function (item) {
				return item.active;
			}));
			if (data['existujeTypovySpis'] || hasOpen) {
				// pokud existuje vyplnit selecty
				const select = $(form).find("select[name='typovy_spis_id']").first();
				select.empty();
				/*				select.append(new Option("", 0, true, true)); */
				let firstActiveValue = null;
				$.each(typoveSpisy, function (index, item) {
					let opt = new Option(item.nazev, item.id, false, false);
					// pokud je typovy spis neaktivni, zablokujeme vyber
					opt.disabled = !item.active;
					if (item.active && firstActiveValue === null) {
						firstActiveValue = item.id;
					}
					select.append(opt);
				});
				if (hasOpen) {
					select.prop('disabled', false);
					if (firstActiveValue !== null) {
						select.val(String(firstActiveValue));
					}
					// a spustime vyber soucasti
					$(form).find("select[name='typovy_spis_id']").trigger('change');
					$createButton.prop('disabled', false);
				} else {
					// jen uzavřené typové spisy – zobrazit, ale neumožnit vytvořit
					select.prop('disabled', true);
					const select2 = $(form).find("select[name='typovy_spis_soucast_id']").first();
					select2.empty();
					select2.append(new Option("Žádná součást", 0, true, true));
					select2.prop('disabled', true);
					$createButton.prop('disabled', true);
				}
			} else {
				const select = $(form).find("select[name='typovy_spis_id']").first();
				select.empty();
				select.append(new Option("Žádný typový spis", 0, true, true));
				select.prop('disabled', true);

				const select2 = $(form).find("select[name='typovy_spis_soucast_id']").first();
				select2.empty();
				select2.append(new Option("Žádná součást", 0, true, true));
				select2.prop('disabled', true);
				$createButton.prop('disabled', true);
			}
			// zviditelnime cely odstavec
			$("#typovy_spis_div").removeClass('d-none');
			$("#typovy_spis_soucast_div").removeClass('d-none');
	  $("#spisy-propojene-pevnym-krizovym-odkazem").removeClass('d-none');
		} else {
			// pokud neexistuje vymazeme selecty
			const select = $(form).find("select[name='typovy_spis_id']").first();
			select.empty();
			select.append(new Option("Žádný typový spis", 0, true, true));
			select.prop('disabled', true);

			const select2 = $(form).find("select[name='typovy_spis_soucast_id']").first();
			select2.empty();
			select2.append(new Option("Žádná součást", 0, true, true));
			select2.prop('disabled', true);

			// a zneviditelnime cely odstavec
			$("#typovy_spis_div").addClass('d-none');
			$("#typovy_spis_soucast_div").addClass('d-none');
			$createButton.prop('disabled', false);
	  $("#spisy-propojene-pevnym-krizovym-odkazem").addClass('d-none');
		}
	});

	return true;
};


/* Vyber soucasti pro typovy spis*/
vybratSoucastiProTypovySpis = function (element) {
	const form = $(element).parents("form").first()[0];
	const key = form['typovy_spis_id'].selectedIndex;

	if (!form['typovy_spis_id']?.options?.[key]?.value) {
		// pokud neexistuje vymazeme selecty
		const select = $(form).find("select[name='typovy_spis_soucast_id']").first();
		select.empty();
		select.append(new Option("Žádná součást", 0, true, true));
		select.prop('disabled', true);
		return true;
	}

	const ts_id = form['typovy_spis_id'].options[key].value;
	const url = BASE_URL + "typove-spisy/seznam-soucasti-typovych-spisu-ajax?tsId=" + ts_id + "";

	$.get(url, function (data) {
		if (data['existujeTypovySpis']) {
			const select = $(form).find("select[name='typovy_spis_soucast_id']").first();
			select.empty();
			/*				select.append(new Option("", 0, true, true));*/
			$.each(data['typoveSpisySoucasti'], function (index, item) {
				const nazev = item.nazev.replace(/&nbsp;/g, '\u00A0'); // pevná mezera
				const option = new Option(nazev, item.id, false, false);
				// pokud je soucast prirazena k podcasti nebo neni aktivni, zablokujeme vyber
				if (item.maPodcasti || !item.active) {
					option.disabled = true;
				}
				select.append(option);
			});
			select.prop('disabled', false);

			// a spustime vyber soucasti
			$("select[name='typovy_spis_soucast_id']").trigger('change');

		} else {
			// pokud neexistuje vymazeme selecty
			const select = $(form).find("select[name='typovy_spis_soucast_id']").first();
			select.empty();
			select.append(new Option("Žádná součást", 0, true, true));
			select.prop('disabled', true);
		}
	});
	return true;
};

/* Vyber skartacniho rezimu pro soucast typoveho spisu*/
vybratSkartacniRezimProSoucastProTypovySpis = function (element) {
	const form = $(element).parents("form").first()[0];
	const selectElement = form['typovy_spis_soucast_id'];
  const key = selectElement?.selectedIndex ?? 0;
	const tss_id = selectElement?.options?.[key]?.value ?? 0;
	const url = BASE_URL + "typove-spisy/skartacni-rezim-pro-soucast-typoveho-spisu-ajax?tssId=" + tss_id;

	$.get(url, function (data) {
		if (data['existujeSoucast']) {
			// vyplnit informace o skartacnim reziimu
			$("#srTypEvidence").text(data['skartacniRezim']['typ_evidence']);
			$("#srJID").text(data['skartacniRezim']['jid']);
			$("#srSpousteciUdalost").text(data['skartacniRezim']['spousteci_udalost']);
			$("#srZnepristupneny").text(data['skartacniRezim']['znepristupneny'] ? 'Ano' : 'Ne');
			$("#srSkartacniZnak").text(data['skartacniRezim']['skartacni_znak']);
			$("#srSkartacniLhuta").text(data['skartacniRezim']['skartacni_lhuta']);
			$("#srTrvalySouhlas").text(data['skartacniRezim']['trvaly_souhlas']);

			// vyplnit hidden pole ve formu
			form['typ_evidence'].value = data['skartacniRezim']['typ_evidence_id'];
			form['skartacni_znak'].value = data['skartacniRezim']['skartacni_znak'];
			form['skartacni_lhuta'].value = data['skartacniRezim']['skartacni_lhuta'];
			form['spousteci_udalost_id'].value = data['skartacniRezim']['spousteci_udalost_id'];

		} else {
			// vymazat informace o skartacnim reziimu
			$("#srTypEvidence").text('');
			$("#srJID").text('');
			$("#srSpousteciUdalost").text('');
			$("#srZnepristupneny").text('');
			$("#srSkartacniZnak").text('');
			$("#srSkartacniLhuta").text('');
			$("#srTrvalySouhlas").text('');

			// vymazat hidden pole ve formu
			form['skartacni_znak'].value = '';
			form['skartacni_lhuta'].value = '';
			form['spousteci_udalost_id'].value = '';
		}
	});
	return true;
};


// Po zapnuti/vypnuti sloupce zustane nabidka nastaveni otevrena a zachova se pozice posuvniku.
(function () {
	var pendingColumnSettings = null;

	function findDatagridByName(name) {
		var $grid = $();
		if (name) {
			$grid = $('.datagrid').filter(function () {
				return $(this).attr('data-datagrid-name') === name;
			});
		}
		if (!$grid.length) {
			$grid = $('.datagrid').first();
		}
		return $grid;
	}

	function restoreColumnSettingsScroll($menu, scrollTop) {
		if ($menu && $menu.length) {
			$menu.scrollTop(scrollTop || 0);
		}
	}

	function reopenColumnSettingsMenu(state) {
		if (!state) {
			return;
		}
		var $grid = findDatagridByName(state.name);
		var $btn = $grid.find('.datagrid-settings [data-bs-toggle="dropdown"]').first();
		var $menu = $grid.find('.datagrid-settings .dropdown-menu').first();
		if (!$btn.length) {
			return;
		}
		var applyScroll = function () {
			restoreColumnSettingsScroll($menu, state.scrollTop);
		};
		$btn.off('shown.bs.dropdown.datagridSettings').one('shown.bs.dropdown.datagridSettings', applyScroll);
		if (window.bootstrap && bootstrap.Dropdown) {
			bootstrap.Dropdown.getOrCreateInstance($btn[0]).show();
		} else if (typeof $btn.dropdown === 'function') {
			$btn.dropdown('show');
		}
		applyScroll();
		setTimeout(applyScroll, 0);
	}

	if ($.nette && typeof $.nette.ext === 'function') {
		$.nette.ext('datagridColumnSettingsKeepOpen', {
			before: function (jqXHR, settings) {
				var $el = settings && settings.nette && settings.nette.el;
				if (!$el || !$el.closest) {
					return true;
				}
				var $menu = $el.closest('.datagrid-settings .dropdown-menu');
				if (!$menu.length) {
					return true;
				}
				pendingColumnSettings = {
					name: $el.closest('.datagrid').attr('data-datagrid-name') || '',
					scrollTop: $menu.scrollTop() || 0
				};
				return true;
			},
			success: function (payload) {
				if (!payload || !payload._datagrid_settings_keep_open) {
					return;
				}
				var state = pendingColumnSettings || {
					name: payload._datagrid_name || '',
					scrollTop: 0
				};
				pendingColumnSettings = null;
				setTimeout(function () {
					reopenColumnSettingsMenu(state);
				}, 0);
			}
		});
	}
})();

// Po AJAXovem prekresleni datagridu zvyrazni pole filtru, ktera omezuji vypis (radek filtru se neprekresluje).
if ($.nette && typeof $.nette.ext === 'function') {
	$.nette.ext('datagrid.active-filter-highlight', {
		success: function (payload) {
			if (!payload || !payload._datagrid_active_filter_controls) {
				return;
			}
			$.each(payload._datagrid_active_filter_controls, function (gridName, names) {
				var $grid = $('.datagrid').filter(function () {
					return $(this).attr('data-datagrid-name') === gridName;
				});
				$grid.find('[name^="filter["]').each(function () {
					$(this).toggleClass('datagrid-filter-active', $.inArray(this.name, names) !== -1);
				});
			});
		}
	});
}

// Pri zmene stranky na datagridu chceme zarolovat nahoru (pouze ale pri zmene stranky a pouze pokud jsme dole)
$(document).ready(function() {
  $(document).ajaxComplete(function(event, xhr, settings) {
	$('.datagrid').each(function() {
	  const grid = $(this);

	  const gridClasses = grid.attr('class').split(' ');
	  const gridName = gridClasses.find(function (className) {
		return className.startsWith('datagrid-');
	  }).replace('datagrid-', '');

	  if (settings.url.includes('page') && settings.url.includes(gridName)) {
		  const gridOffsetTop = grid.offset().top;
		  const currentScrollTop = $(window).scrollTop();

		  if (currentScrollTop > gridOffsetTop) {
			  $('html, body').animate({
				  scrollTop: gridOffsetTop
			  }, 'slow');
		  }
		}
	});
  });
});

$(function() {
	$('.dropdown').on('show.bs.dropdown', function() {
		$('.toast-container').css({
			'opacity': '0.5',
			'z-index': '105'
		});
		$('#dropdownMenuButton').css({
			'position': 'relative',
			'z-index': '1050'
		});
	});
	$('.dropdown').on('hide.bs.dropdown', function() {
		$('.toast-container').css({
			'opacity': '1',
			'z-index': '1050'
		});
		$('#dropdownMenuButton').css({
			'position': '',
			'z-index': ''
		});
	});
});

function bindSloucitNazevCounter($root) {
	var $scope = $root && $root.length ? $root : $(document);
	var $counter = $scope.find('#sloucit-nazev-counter').first();
	if (!$counter.length) {
		return;
	}
	var $input = $counter.closest('.form-group').find('input, textarea').first();
	if (!$input.length) {
		$input = $scope.find('.js-sloucit-nazev, #sloucit-nazev').first();
	}
	if (!$input.length) {
		return;
	}
	var maxLen = parseInt($input.attr('maxlength'), 10) || 100;
	var update = function () {
		var value = $input.val() || '';
		if (value.length > maxLen) {
			value = value.substring(0, maxLen);
			$input.val(value);
		}
		$counter.text(value.length);
		var empty = $.trim(value) === '';
		$scope.find('#sloucit-save, [data-testid="button-sloucit-ulozit"]').prop('disabled', empty);
	};
	$input.off('input.sloucitNazev keyup.sloucitNazev paste.sloucitNazev')
		.on('input.sloucitNazev keyup.sloucitNazev paste.sloucitNazev', update);
	update();
}

function isSloucitPdfMime(mime) {
	return String(mime || '').split(';')[0].trim().toLowerCase() === 'application/pdf';
}

function getSloucitPrilohyDisableReason($checked, allPdf) {
	if ($checked.length > 0 && !allPdf) {
		return 'Sloučení nelze provést, protože vybraná komponenta není ve formátu PDF.';
	}
	return 'Ke sloučení je potřeba vybrat alespoň dvě PDF přílohy.';
}

function refreshSloucitTooltip($btn, reason) {
	var $wrap = $btn.parent();
	if (!$wrap.hasClass('sloucit-tooltip-wrap')) {
		$btn.wrap('<span class="sloucit-tooltip-wrap d-inline-block"></span>');
		$wrap = $btn.parent();
	}
	try {
		if ($wrap.data('bs.tooltip')) {
			$wrap.tooltip('dispose');
		}
	} catch (e) {}
	$wrap.attr('data-toggle', 'tooltip');
	$wrap.attr('data-placement', 'top');
	$wrap.attr('title', reason || '');
	$wrap.attr('data-original-title', reason || '');
	$btn.removeAttr('title');
	if (reason) {
		$wrap.tooltip({ trigger: 'hover', placement: 'top' });
	}
}

function updateSloucitPrilohyButton(gridEl) {
	var $grid = gridEl ? $(gridEl).closest('.datagrid') : $();
	if (!$grid.length) {
		$grid = $('#dok-prilohy .datagrid').has('[data-testid="button-sloucit-prilohy"]').first();
	}
	if (!$grid.length) {
		$grid = $('#dok-prilohy .datagrid').first();
	}
	var $btn = $grid.find('[data-testid="button-sloucit-prilohy"]');
	if (!$btn.length) {
		return;
	}
	var $checked = $grid.find('tbody input[type=checkbox][data-check]:checked');
	var allPdf = true;
	$checked.each(function () {
		var $row = $(this).closest('tr');
		if (!isSloucitPdfMime($row.attr('data-mime-type'))) {
			allPdf = false;
		}
	});
	var canMerge = $checked.length >= 2 && allPdf;
	var reason = canMerge ? '' : getSloucitPrilohyDisableReason($checked, allPdf);
	$btn.prop('disabled', !canMerge);
	$btn.attr('data-sloucit-reason', reason);
	// Disabled buttons otherwise ignore hover, so the tooltip would never appear.
	$btn.css('pointer-events', 'auto');
	refreshSloucitTooltip($btn, reason);
}

var pdfMergePollTimer = null;
function maybePollPdfMerge() {
	if (pdfMergePollTimer) {
		return;
	}
	var $banner = $('[data-pdf-merge-status="pending"]').first();
	if (!$banner.length) {
		return;
	}
	var url = $banner.attr('data-pdf-merge-status-url');
	if (!url && typeof DOKUMENT_ID !== 'undefined' && typeof BASE_URL !== 'undefined') {
		url = BASE_URL + 'prilohy/' + DOKUMENT_ID + '/pdf-merge-status';
	}
	if (!url) {
		return;
	}
	var ticks = 0;
	var inFlight = false;
	var stopPdfMergePoll = function () {
		if (!pdfMergePollTimer) {
			return;
		}
		clearInterval(pdfMergePollTimer);
		pdfMergePollTimer = null;
	};
	var reloadPrilohyOnce = function () {
		stopPdfMergePoll();
		if (typeof renderPrilohy === 'function') {
			renderPrilohy(true);
		}
	};
	var pollPdfMergeStatus = function () {
		ticks++;
		if (ticks > 60) {
			stopPdfMergePoll();
			return;
		}
		if (inFlight) {
			return;
		}
		inFlight = true;
		fetch(url, {
			credentials: 'same-origin',
			headers: {
				'Accept': 'application/json',
				'X-Requested-With': 'XMLHttpRequest'
			}
		}).then(function (response) {
			if (!response.ok) {
				return null;
			}
			return response.json();
		}).then(function (data) {
			if (!data) {
				return;
			}
			if (data.status === 'pending' || data.status === 'in_progress') {
				if (data.statusText) {
					$('[data-pdf-merge-status-text]').text(data.statusText);
				}
				return;
			}
			reloadPrilohyOnce();
		}).catch(function () {
		}).finally(function () {
			inFlight = false;
		});
	};
	pdfMergePollTimer = setInterval(pollPdfMergeStatus, 5000);
	pollPdfMergeStatus();
}

document.addEventListener('change', function (e) {
	if (!e.target || !e.target.getAttribute) {
		return;
	}
	if (!e.target.getAttribute('data-check') && !e.target.getAttribute('data-check-all')) {
		return;
	}
	if (!$(e.target).closest('#dok-prilohy').length) {
		return;
	}
	setTimeout(function () {
		updateSloucitPrilohyButton(e.target);
	}, 0);
});

document.addEventListener('click', function (e) {
	var btn = e.target && e.target.closest ? e.target.closest('[data-testid="button-sloucit-prilohy"]') : null;
	if (!btn) {
		return;
	}
	e.preventDefault();
	e.stopImmediatePropagation();
	if (btn.disabled) {
		var disabledReason = btn.getAttribute('data-sloucit-reason') || btn.getAttribute('title');
		if (disabledReason && typeof showPrilohaToast === 'function') {
			showPrilohaToast(disabledReason, 'warning');
		}
		return;
	}
	var $grid = $(btn).closest('.datagrid');
	var ids = [];
	var allPdf = true;
	$grid.find('tbody input[type=checkbox][data-check]:checked').each(function () {
		var $row = $(this).closest('tr');
		ids.push($row.attr('data-id'));
		if (!isSloucitPdfMime($row.attr('data-mime-type'))) {
			allPdf = false;
		}
	});
	if (ids.length < 2 || !allPdf) {
		var $checkedRows = $grid.find('tbody input[type=checkbox][data-check]:checked');
		var reason = getSloucitPrilohyDisableReason($checkedRows, allPdf);
		if (typeof showPrilohaToast === 'function') {
			showPrilohaToast(reason, 'warning');
		}
		return;
	}
	if (typeof DOKUMENT_ID === 'undefined') {
		return;
	}
	var url = btn.getAttribute('data-sloucit-url');
	if (url) {
		url += (url.indexOf('?') >= 0 ? '&' : '?') + 'fileIds=' + encodeURIComponent(ids.join('-'));
	} else {
		url = BASE_URL + 'prilohy/' + DOKUMENT_ID + '/sloucit?fileIds=' + encodeURIComponent(ids.join('-'));
	}
	$('#ajax-spinner').show();
	$.get(url, function (html) {
		if (html && typeof html === 'object') {
			if (html.message) {
				showPrilohaToast(html.message, html.messageType || 'danger');
			}
			$('#ajax-spinner').hide();
			return;
		}
		$('#theModal .modal-title').text('Sloučení příloh');
		$('#theModal .modal-body').html(html);
		$('#theModal .modal-dialog').removeClass('modal-xl').addClass('modal-lg');
		$('#theModal').modal('show');
		bindSloucitNazevCounter($('#theModal'));
		if ($.nette && $.nette.load) {
			$.nette.load();
		}
		$('#ajax-spinner').hide();
	}).fail(function () {
		$('#ajax-spinner').hide();
		if (typeof showPrilohaToast === 'function') {
			showPrilohaToast('Sloučení příloh se nepodařilo otevřít.', 'danger');
		}
	});
}, true);

if (typeof showPrilohaToast !== 'function') {
	window.showPrilohaToast = function (message, type, delay) {
		type = type || 'success';
		var $container = $('.toast-container');
		if ($container.length === 0) {
			$container = $('<div class="toast-container" aria-live="polite" aria-atomic="true"></div>').appendTo('#content');
		}
		var $toast = $(
			'<div class="toast toast-' + type + '" role="alert" aria-live="assertive" aria-atomic="true">' +
				'<div class="toast-header">' +
					'<div class="toast-rect rounded toast-rect-' + type + ' mr-2"></div>' +
					'<strong class="mr-auto">eSSl Spisová služba</strong>' +
					'<button type="button" class="ml-2 mb-1 close" data-dismiss="toast" aria-label="Zavřít">' +
						'<span aria-hidden="true">&times;</span>' +
					'</button>' +
				'</div>' +
				'<div class="toast-body"></div>' +
			'</div>'
		);
		$toast.find('.toast-body').text(message);
		$container.append($toast);
		var options = (delay === false) ? { autohide: false } : { delay: delay || 20000 };
		$toast.toast(options).toast('show').on('hidden.bs.toast', function () {
			$(this).remove();
		});
	};
}

$(function () {
	if (typeof updateSloucitPrilohyButton === 'function') {
		updateSloucitPrilohyButton();
	}
	if (typeof maybePollPdfMerge === 'function') {
		maybePollPdfMerge();
	}
});
